var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));

// ../../node_modules/react-is/cjs/react-is.development.js
var require_react_is_development = __commonJS({
  "../../node_modules/react-is/cjs/react-is.development.js"(exports) {
    "use strict";
    if (true) {
      (function() {
        "use strict";
        var hasSymbol = typeof Symbol === "function" && Symbol.for;
        var REACT_ELEMENT_TYPE = hasSymbol ? /* @__PURE__ */ Symbol.for("react.element") : 60103;
        var REACT_PORTAL_TYPE = hasSymbol ? /* @__PURE__ */ Symbol.for("react.portal") : 60106;
        var REACT_FRAGMENT_TYPE = hasSymbol ? /* @__PURE__ */ Symbol.for("react.fragment") : 60107;
        var REACT_STRICT_MODE_TYPE = hasSymbol ? /* @__PURE__ */ Symbol.for("react.strict_mode") : 60108;
        var REACT_PROFILER_TYPE = hasSymbol ? /* @__PURE__ */ Symbol.for("react.profiler") : 60114;
        var REACT_PROVIDER_TYPE = hasSymbol ? /* @__PURE__ */ Symbol.for("react.provider") : 60109;
        var REACT_CONTEXT_TYPE = hasSymbol ? /* @__PURE__ */ Symbol.for("react.context") : 60110;
        var REACT_ASYNC_MODE_TYPE = hasSymbol ? /* @__PURE__ */ Symbol.for("react.async_mode") : 60111;
        var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? /* @__PURE__ */ Symbol.for("react.concurrent_mode") : 60111;
        var REACT_FORWARD_REF_TYPE = hasSymbol ? /* @__PURE__ */ Symbol.for("react.forward_ref") : 60112;
        var REACT_SUSPENSE_TYPE = hasSymbol ? /* @__PURE__ */ Symbol.for("react.suspense") : 60113;
        var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? /* @__PURE__ */ Symbol.for("react.suspense_list") : 60120;
        var REACT_MEMO_TYPE = hasSymbol ? /* @__PURE__ */ Symbol.for("react.memo") : 60115;
        var REACT_LAZY_TYPE = hasSymbol ? /* @__PURE__ */ Symbol.for("react.lazy") : 60116;
        var REACT_BLOCK_TYPE = hasSymbol ? /* @__PURE__ */ Symbol.for("react.block") : 60121;
        var REACT_FUNDAMENTAL_TYPE = hasSymbol ? /* @__PURE__ */ Symbol.for("react.fundamental") : 60117;
        var REACT_RESPONDER_TYPE = hasSymbol ? /* @__PURE__ */ Symbol.for("react.responder") : 60118;
        var REACT_SCOPE_TYPE = hasSymbol ? /* @__PURE__ */ Symbol.for("react.scope") : 60119;
        function isValidElementType(type) {
          return typeof type === "string" || typeof type === "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
          type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === "object" && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
        }
        function typeOf(object) {
          if (typeof object === "object" && object !== null) {
            var $$typeof = object.$$typeof;
            switch ($$typeof) {
              case REACT_ELEMENT_TYPE:
                var type = object.type;
                switch (type) {
                  case REACT_ASYNC_MODE_TYPE:
                  case REACT_CONCURRENT_MODE_TYPE:
                  case REACT_FRAGMENT_TYPE:
                  case REACT_PROFILER_TYPE:
                  case REACT_STRICT_MODE_TYPE:
                  case REACT_SUSPENSE_TYPE:
                    return type;
                  default:
                    var $$typeofType = type && type.$$typeof;
                    switch ($$typeofType) {
                      case REACT_CONTEXT_TYPE:
                      case REACT_FORWARD_REF_TYPE:
                      case REACT_LAZY_TYPE:
                      case REACT_MEMO_TYPE:
                      case REACT_PROVIDER_TYPE:
                        return $$typeofType;
                      default:
                        return $$typeof;
                    }
                }
              case REACT_PORTAL_TYPE:
                return $$typeof;
            }
          }
          return void 0;
        }
        var AsyncMode = REACT_ASYNC_MODE_TYPE;
        var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
        var ContextConsumer = REACT_CONTEXT_TYPE;
        var ContextProvider = REACT_PROVIDER_TYPE;
        var Element = REACT_ELEMENT_TYPE;
        var ForwardRef = REACT_FORWARD_REF_TYPE;
        var Fragment9 = REACT_FRAGMENT_TYPE;
        var Lazy = REACT_LAZY_TYPE;
        var Memo = REACT_MEMO_TYPE;
        var Portal = REACT_PORTAL_TYPE;
        var Profiler = REACT_PROFILER_TYPE;
        var StrictMode = REACT_STRICT_MODE_TYPE;
        var Suspense = REACT_SUSPENSE_TYPE;
        var hasWarnedAboutDeprecatedIsAsyncMode = false;
        function isAsyncMode(object) {
          {
            if (!hasWarnedAboutDeprecatedIsAsyncMode) {
              hasWarnedAboutDeprecatedIsAsyncMode = true;
              console["warn"]("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.");
            }
          }
          return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
        }
        function isConcurrentMode(object) {
          return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
        }
        function isContextConsumer(object) {
          return typeOf(object) === REACT_CONTEXT_TYPE;
        }
        function isContextProvider(object) {
          return typeOf(object) === REACT_PROVIDER_TYPE;
        }
        function isElement(object) {
          return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
        }
        function isForwardRef(object) {
          return typeOf(object) === REACT_FORWARD_REF_TYPE;
        }
        function isFragment(object) {
          return typeOf(object) === REACT_FRAGMENT_TYPE;
        }
        function isLazy(object) {
          return typeOf(object) === REACT_LAZY_TYPE;
        }
        function isMemo(object) {
          return typeOf(object) === REACT_MEMO_TYPE;
        }
        function isPortal(object) {
          return typeOf(object) === REACT_PORTAL_TYPE;
        }
        function isProfiler(object) {
          return typeOf(object) === REACT_PROFILER_TYPE;
        }
        function isStrictMode(object) {
          return typeOf(object) === REACT_STRICT_MODE_TYPE;
        }
        function isSuspense(object) {
          return typeOf(object) === REACT_SUSPENSE_TYPE;
        }
        exports.AsyncMode = AsyncMode;
        exports.ConcurrentMode = ConcurrentMode;
        exports.ContextConsumer = ContextConsumer;
        exports.ContextProvider = ContextProvider;
        exports.Element = Element;
        exports.ForwardRef = ForwardRef;
        exports.Fragment = Fragment9;
        exports.Lazy = Lazy;
        exports.Memo = Memo;
        exports.Portal = Portal;
        exports.Profiler = Profiler;
        exports.StrictMode = StrictMode;
        exports.Suspense = Suspense;
        exports.isAsyncMode = isAsyncMode;
        exports.isConcurrentMode = isConcurrentMode;
        exports.isContextConsumer = isContextConsumer;
        exports.isContextProvider = isContextProvider;
        exports.isElement = isElement;
        exports.isForwardRef = isForwardRef;
        exports.isFragment = isFragment;
        exports.isLazy = isLazy;
        exports.isMemo = isMemo;
        exports.isPortal = isPortal;
        exports.isProfiler = isProfiler;
        exports.isStrictMode = isStrictMode;
        exports.isSuspense = isSuspense;
        exports.isValidElementType = isValidElementType;
        exports.typeOf = typeOf;
      })();
    }
  }
});

// ../../node_modules/react-is/index.js
var require_react_is = __commonJS({
  "../../node_modules/react-is/index.js"(exports, module) {
    "use strict";
    if (false) {
      module.exports = null;
    } else {
      module.exports = require_react_is_development();
    }
  }
});

// ../../node_modules/object-assign/index.js
var require_object_assign = __commonJS({
  "../../node_modules/object-assign/index.js"(exports, module) {
    "use strict";
    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    var propIsEnumerable = Object.prototype.propertyIsEnumerable;
    function toObject(val) {
      if (val === null || val === void 0) {
        throw new TypeError("Object.assign cannot be called with null or undefined");
      }
      return Object(val);
    }
    function shouldUseNative() {
      try {
        if (!Object.assign) {
          return false;
        }
        var test1 = new String("abc");
        test1[5] = "de";
        if (Object.getOwnPropertyNames(test1)[0] === "5") {
          return false;
        }
        var test2 = {};
        for (var i = 0; i < 10; i++) {
          test2["_" + String.fromCharCode(i)] = i;
        }
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
          return test2[n];
        });
        if (order2.join("") !== "0123456789") {
          return false;
        }
        var test3 = {};
        "abcdefghijklmnopqrst".split("").forEach(function(letter) {
          test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") {
          return false;
        }
        return true;
      } catch (err) {
        return false;
      }
    }
    module.exports = shouldUseNative() ? Object.assign : function(target, source) {
      var from;
      var to = toObject(target);
      var symbols;
      for (var s = 1; s < arguments.length; s++) {
        from = Object(arguments[s]);
        for (var key in from) {
          if (hasOwnProperty.call(from, key)) {
            to[key] = from[key];
          }
        }
        if (getOwnPropertySymbols) {
          symbols = getOwnPropertySymbols(from);
          for (var i = 0; i < symbols.length; i++) {
            if (propIsEnumerable.call(from, symbols[i])) {
              to[symbols[i]] = from[symbols[i]];
            }
          }
        }
      }
      return to;
    };
  }
});

// ../../node_modules/prop-types/lib/ReactPropTypesSecret.js
var require_ReactPropTypesSecret = __commonJS({
  "../../node_modules/prop-types/lib/ReactPropTypesSecret.js"(exports, module) {
    "use strict";
    var ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
    module.exports = ReactPropTypesSecret;
  }
});

// ../../node_modules/prop-types/lib/has.js
var require_has = __commonJS({
  "../../node_modules/prop-types/lib/has.js"(exports, module) {
    "use strict";
    module.exports = Function.call.bind(Object.prototype.hasOwnProperty);
  }
});

// ../../node_modules/prop-types/checkPropTypes.js
var require_checkPropTypes = __commonJS({
  "../../node_modules/prop-types/checkPropTypes.js"(exports, module) {
    "use strict";
    var printWarning = function() {
    };
    if (true) {
      ReactPropTypesSecret = require_ReactPropTypesSecret();
      loggedTypeFailures = {};
      has = require_has();
      printWarning = function(text) {
        var message = "Warning: " + text;
        if (typeof console !== "undefined") {
          console.error(message);
        }
        try {
          throw new Error(message);
        } catch (x) {
        }
      };
    }
    var ReactPropTypesSecret;
    var loggedTypeFailures;
    var has;
    function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
      if (true) {
        for (var typeSpecName in typeSpecs) {
          if (has(typeSpecs, typeSpecName)) {
            var error;
            try {
              if (typeof typeSpecs[typeSpecName] !== "function") {
                var err = Error(
                  (componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
                );
                err.name = "Invariant Violation";
                throw err;
              }
              error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
            } catch (ex) {
              error = ex;
            }
            if (error && !(error instanceof Error)) {
              printWarning(
                (componentName || "React class") + ": type specification of " + location + " `" + typeSpecName + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof error + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
              );
            }
            if (error instanceof Error && !(error.message in loggedTypeFailures)) {
              loggedTypeFailures[error.message] = true;
              var stack = getStack ? getStack() : "";
              printWarning(
                "Failed " + location + " type: " + error.message + (stack != null ? stack : "")
              );
            }
          }
        }
      }
    }
    checkPropTypes.resetWarningCache = function() {
      if (true) {
        loggedTypeFailures = {};
      }
    };
    module.exports = checkPropTypes;
  }
});

// ../../node_modules/prop-types/factoryWithTypeCheckers.js
var require_factoryWithTypeCheckers = __commonJS({
  "../../node_modules/prop-types/factoryWithTypeCheckers.js"(exports, module) {
    "use strict";
    var ReactIs = require_react_is();
    var assign2 = require_object_assign();
    var ReactPropTypesSecret = require_ReactPropTypesSecret();
    var has = require_has();
    var checkPropTypes = require_checkPropTypes();
    var printWarning = function() {
    };
    if (true) {
      printWarning = function(text) {
        var message = "Warning: " + text;
        if (typeof console !== "undefined") {
          console.error(message);
        }
        try {
          throw new Error(message);
        } catch (x) {
        }
      };
    }
    function emptyFunctionThatReturnsNull() {
      return null;
    }
    module.exports = function(isValidElement, throwOnDirectAccess) {
      var ITERATOR_SYMBOL = typeof Symbol === "function" && Symbol.iterator;
      var FAUX_ITERATOR_SYMBOL = "@@iterator";
      function getIteratorFn(maybeIterable) {
        var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
        if (typeof iteratorFn === "function") {
          return iteratorFn;
        }
      }
      var ANONYMOUS = "<<anonymous>>";
      var ReactPropTypes = {
        array: createPrimitiveTypeChecker("array"),
        bigint: createPrimitiveTypeChecker("bigint"),
        bool: createPrimitiveTypeChecker("boolean"),
        func: createPrimitiveTypeChecker("function"),
        number: createPrimitiveTypeChecker("number"),
        object: createPrimitiveTypeChecker("object"),
        string: createPrimitiveTypeChecker("string"),
        symbol: createPrimitiveTypeChecker("symbol"),
        any: createAnyTypeChecker(),
        arrayOf: createArrayOfTypeChecker,
        element: createElementTypeChecker(),
        elementType: createElementTypeTypeChecker(),
        instanceOf: createInstanceTypeChecker,
        node: createNodeChecker(),
        objectOf: createObjectOfTypeChecker,
        oneOf: createEnumTypeChecker,
        oneOfType: createUnionTypeChecker,
        shape: createShapeTypeChecker,
        exact: createStrictShapeTypeChecker
      };
      function is(x, y) {
        if (x === y) {
          return x !== 0 || 1 / x === 1 / y;
        } else {
          return x !== x && y !== y;
        }
      }
      function PropTypeError(message, data) {
        this.message = message;
        this.data = data && typeof data === "object" ? data : {};
        this.stack = "";
      }
      PropTypeError.prototype = Error.prototype;
      function createChainableTypeChecker(validate) {
        if (true) {
          var manualPropTypeCallCache = {};
          var manualPropTypeWarningCount = 0;
        }
        function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
          componentName = componentName || ANONYMOUS;
          propFullName = propFullName || propName;
          if (secret !== ReactPropTypesSecret) {
            if (throwOnDirectAccess) {
              var err = new Error(
                "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
              );
              err.name = "Invariant Violation";
              throw err;
            } else if (typeof console !== "undefined") {
              var cacheKey = componentName + ":" + propName;
              if (!manualPropTypeCallCache[cacheKey] && // Avoid spamming the console because they are often not actionable except for lib authors
              manualPropTypeWarningCount < 3) {
                printWarning(
                  "You are manually calling a React.PropTypes validation function for the `" + propFullName + "` prop on `" + componentName + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
                );
                manualPropTypeCallCache[cacheKey] = true;
                manualPropTypeWarningCount++;
              }
            }
          }
          if (props[propName] == null) {
            if (isRequired) {
              if (props[propName] === null) {
                return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required " + ("in `" + componentName + "`, but its value is `null`."));
              }
              return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required in " + ("`" + componentName + "`, but its value is `undefined`."));
            }
            return null;
          } else {
            return validate(props, propName, componentName, location, propFullName);
          }
        }
        var chainedCheckType = checkType.bind(null, false);
        chainedCheckType.isRequired = checkType.bind(null, true);
        return chainedCheckType;
      }
      function createPrimitiveTypeChecker(expectedType) {
        function validate(props, propName, componentName, location, propFullName, secret) {
          var propValue = props[propName];
          var propType = getPropType(propValue);
          if (propType !== expectedType) {
            var preciseType = getPreciseType(propValue);
            return new PropTypeError(
              "Invalid " + location + " `" + propFullName + "` of type " + ("`" + preciseType + "` supplied to `" + componentName + "`, expected ") + ("`" + expectedType + "`."),
              { expectedType }
            );
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createAnyTypeChecker() {
        return createChainableTypeChecker(emptyFunctionThatReturnsNull);
      }
      function createArrayOfTypeChecker(typeChecker) {
        function validate(props, propName, componentName, location, propFullName) {
          if (typeof typeChecker !== "function") {
            return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside arrayOf.");
          }
          var propValue = props[propName];
          if (!Array.isArray(propValue)) {
            var propType = getPropType(propValue);
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an array."));
          }
          for (var i = 0; i < propValue.length; i++) {
            var error = typeChecker(propValue, i, componentName, location, propFullName + "[" + i + "]", ReactPropTypesSecret);
            if (error instanceof Error) {
              return error;
            }
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createElementTypeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
          var propValue = props[propName];
          if (!isValidElement(propValue)) {
            var propType = getPropType(propValue);
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement."));
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createElementTypeTypeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
          var propValue = props[propName];
          if (!ReactIs.isValidElementType(propValue)) {
            var propType = getPropType(propValue);
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement type."));
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createInstanceTypeChecker(expectedClass) {
        function validate(props, propName, componentName, location, propFullName) {
          if (!(props[propName] instanceof expectedClass)) {
            var expectedClassName = expectedClass.name || ANONYMOUS;
            var actualClassName = getClassName(props[propName]);
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + actualClassName + "` supplied to `" + componentName + "`, expected ") + ("instance of `" + expectedClassName + "`."));
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createEnumTypeChecker(expectedValues) {
        if (!Array.isArray(expectedValues)) {
          if (true) {
            if (arguments.length > 1) {
              printWarning(
                "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
              );
            } else {
              printWarning("Invalid argument supplied to oneOf, expected an array.");
            }
          }
          return emptyFunctionThatReturnsNull;
        }
        function validate(props, propName, componentName, location, propFullName) {
          var propValue = props[propName];
          for (var i = 0; i < expectedValues.length; i++) {
            if (is(propValue, expectedValues[i])) {
              return null;
            }
          }
          var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
            var type = getPreciseType(value);
            if (type === "symbol") {
              return String(value);
            }
            return value;
          });
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of value `" + String(propValue) + "` " + ("supplied to `" + componentName + "`, expected one of " + valuesString + "."));
        }
        return createChainableTypeChecker(validate);
      }
      function createObjectOfTypeChecker(typeChecker) {
        function validate(props, propName, componentName, location, propFullName) {
          if (typeof typeChecker !== "function") {
            return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside objectOf.");
          }
          var propValue = props[propName];
          var propType = getPropType(propValue);
          if (propType !== "object") {
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an object."));
          }
          for (var key in propValue) {
            if (has(propValue, key)) {
              var error = typeChecker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
              if (error instanceof Error) {
                return error;
              }
            }
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createUnionTypeChecker(arrayOfTypeCheckers) {
        if (!Array.isArray(arrayOfTypeCheckers)) {
          true ? printWarning("Invalid argument supplied to oneOfType, expected an instance of array.") : void 0;
          return emptyFunctionThatReturnsNull;
        }
        for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
          var checker = arrayOfTypeCheckers[i];
          if (typeof checker !== "function") {
            printWarning(
              "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + getPostfixForTypeWarning(checker) + " at index " + i + "."
            );
            return emptyFunctionThatReturnsNull;
          }
        }
        function validate(props, propName, componentName, location, propFullName) {
          var expectedTypes = [];
          for (var i2 = 0; i2 < arrayOfTypeCheckers.length; i2++) {
            var checker2 = arrayOfTypeCheckers[i2];
            var checkerResult = checker2(props, propName, componentName, location, propFullName, ReactPropTypesSecret);
            if (checkerResult == null) {
              return null;
            }
            if (checkerResult.data && has(checkerResult.data, "expectedType")) {
              expectedTypes.push(checkerResult.data.expectedType);
            }
          }
          var expectedTypesMessage = expectedTypes.length > 0 ? ", expected one of type [" + expectedTypes.join(", ") + "]" : "";
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`" + expectedTypesMessage + "."));
        }
        return createChainableTypeChecker(validate);
      }
      function createNodeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
          if (!isNode(props[propName])) {
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`, expected a ReactNode."));
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function invalidValidatorError(componentName, location, propFullName, key, type) {
        return new PropTypeError(
          (componentName || "React class") + ": " + location + " type `" + propFullName + "." + key + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + type + "`."
        );
      }
      function createShapeTypeChecker(shapeTypes) {
        function validate(props, propName, componentName, location, propFullName) {
          var propValue = props[propName];
          var propType = getPropType(propValue);
          if (propType !== "object") {
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
          }
          for (var key in shapeTypes) {
            var checker = shapeTypes[key];
            if (typeof checker !== "function") {
              return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
            }
            var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
            if (error) {
              return error;
            }
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createStrictShapeTypeChecker(shapeTypes) {
        function validate(props, propName, componentName, location, propFullName) {
          var propValue = props[propName];
          var propType = getPropType(propValue);
          if (propType !== "object") {
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
          }
          var allKeys = assign2({}, props[propName], shapeTypes);
          for (var key in allKeys) {
            var checker = shapeTypes[key];
            if (has(shapeTypes, key) && typeof checker !== "function") {
              return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
            }
            if (!checker) {
              return new PropTypeError(
                "Invalid " + location + " `" + propFullName + "` key `" + key + "` supplied to `" + componentName + "`.\nBad object: " + JSON.stringify(props[propName], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(shapeTypes), null, "  ")
              );
            }
            var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
            if (error) {
              return error;
            }
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function isNode(propValue) {
        switch (typeof propValue) {
          case "number":
          case "string":
          case "undefined":
            return true;
          case "boolean":
            return !propValue;
          case "object":
            if (Array.isArray(propValue)) {
              return propValue.every(isNode);
            }
            if (propValue === null || isValidElement(propValue)) {
              return true;
            }
            var iteratorFn = getIteratorFn(propValue);
            if (iteratorFn) {
              var iterator = iteratorFn.call(propValue);
              var step;
              if (iteratorFn !== propValue.entries) {
                while (!(step = iterator.next()).done) {
                  if (!isNode(step.value)) {
                    return false;
                  }
                }
              } else {
                while (!(step = iterator.next()).done) {
                  var entry = step.value;
                  if (entry) {
                    if (!isNode(entry[1])) {
                      return false;
                    }
                  }
                }
              }
            } else {
              return false;
            }
            return true;
          default:
            return false;
        }
      }
      function isSymbol(propType, propValue) {
        if (propType === "symbol") {
          return true;
        }
        if (!propValue) {
          return false;
        }
        if (propValue["@@toStringTag"] === "Symbol") {
          return true;
        }
        if (typeof Symbol === "function" && propValue instanceof Symbol) {
          return true;
        }
        return false;
      }
      function getPropType(propValue) {
        var propType = typeof propValue;
        if (Array.isArray(propValue)) {
          return "array";
        }
        if (propValue instanceof RegExp) {
          return "object";
        }
        if (isSymbol(propType, propValue)) {
          return "symbol";
        }
        return propType;
      }
      function getPreciseType(propValue) {
        if (typeof propValue === "undefined" || propValue === null) {
          return "" + propValue;
        }
        var propType = getPropType(propValue);
        if (propType === "object") {
          if (propValue instanceof Date) {
            return "date";
          } else if (propValue instanceof RegExp) {
            return "regexp";
          }
        }
        return propType;
      }
      function getPostfixForTypeWarning(value) {
        var type = getPreciseType(value);
        switch (type) {
          case "array":
          case "object":
            return "an " + type;
          case "boolean":
          case "date":
          case "regexp":
            return "a " + type;
          default:
            return type;
        }
      }
      function getClassName(propValue) {
        if (!propValue.constructor || !propValue.constructor.name) {
          return ANONYMOUS;
        }
        return propValue.constructor.name;
      }
      ReactPropTypes.checkPropTypes = checkPropTypes;
      ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
      ReactPropTypes.PropTypes = ReactPropTypes;
      return ReactPropTypes;
    };
  }
});

// ../../node_modules/prop-types/index.js
var require_prop_types = __commonJS({
  "../../node_modules/prop-types/index.js"(exports, module) {
    "use strict";
    if (true) {
      ReactIs = require_react_is();
      throwOnDirectAccess = true;
      module.exports = require_factoryWithTypeCheckers()(ReactIs.isElement, throwOnDirectAccess);
    } else {
      module.exports = null();
    }
    var ReactIs;
    var throwOnDirectAccess;
  }
});

// ../../node_modules/@fortawesome/pro-solid-svg-icons/faSun.js
var require_faSun = __commonJS({
  "../../node_modules/@fortawesome/pro-solid-svg-icons/faSun.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var prefix = "fas";
    var iconName = "sun";
    var width = 512;
    var height = 512;
    var aliases = [9728];
    var unicode = "f185";
    var svgPathData = "M361.5 1.2c5 2.1 8.6 6.6 9.6 11.9L391 121l107.9 19.8c5.3 1 9.8 4.6 11.9 9.6s1.5 10.7-1.6 15.2L446.9 256l62.3 90.3c3.1 4.5 3.7 10.2 1.6 15.2s-6.6 8.6-11.9 9.6L391 391 371.1 498.9c-1 5.3-4.6 9.8-9.6 11.9s-10.7 1.5-15.2-1.6L256 446.9l-90.3 62.3c-4.5 3.1-10.2 3.7-15.2 1.6s-8.6-6.6-9.6-11.9L121 391 13.1 371.1c-5.3-1-9.8-4.6-11.9-9.6s-1.5-10.7 1.6-15.2L65.1 256 2.8 165.7c-3.1-4.5-3.7-10.2-1.6-15.2s6.6-8.6 11.9-9.6L121 121 140.9 13.1c1-5.3 4.6-9.8 9.6-11.9s10.7-1.5 15.2 1.6L256 65.1 346.3 2.8c4.5-3.1 10.2-3.7 15.2-1.6zM160 256a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zm224 0a128 128 0 1 0 -256 0 128 128 0 1 0 256 0z";
    exports.definition = {
      prefix,
      iconName,
      icon: [
        width,
        height,
        aliases,
        unicode,
        svgPathData
      ]
    };
    exports.faSun = exports.definition;
    exports.prefix = prefix;
    exports.iconName = iconName;
    exports.width = width;
    exports.height = height;
    exports.ligatures = aliases;
    exports.unicode = unicode;
    exports.svgPathData = svgPathData;
    exports.aliases = aliases;
  }
});

// ../../node_modules/@fortawesome/pro-solid-svg-icons/faMoon.js
var require_faMoon = __commonJS({
  "../../node_modules/@fortawesome/pro-solid-svg-icons/faMoon.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var prefix = "fas";
    var iconName = "moon";
    var width = 384;
    var height = 512;
    var aliases = [127769, 9214];
    var unicode = "f186";
    var svgPathData = "M223.5 32C100 32 0 132.3 0 256S100 480 223.5 480c60.6 0 115.5-24.2 155.8-63.4c5-4.9 6.3-12.5 3.1-18.7s-10.1-9.7-17-8.5c-9.8 1.7-19.8 2.6-30.1 2.6c-96.9 0-175.5-78.8-175.5-176c0-65.8 36-123.1 89.3-153.3c6.1-3.5 9.2-10.5 7.7-17.3s-7.3-11.9-14.3-12.5c-6.3-.5-12.6-.8-19-.8z";
    exports.definition = {
      prefix,
      iconName,
      icon: [
        width,
        height,
        aliases,
        unicode,
        svgPathData
      ]
    };
    exports.faMoon = exports.definition;
    exports.prefix = prefix;
    exports.iconName = iconName;
    exports.width = width;
    exports.height = height;
    exports.ligatures = aliases;
    exports.unicode = unicode;
    exports.svgPathData = svgPathData;
    exports.aliases = aliases;
  }
});

// src/components/ThemeEditor/ThemeEditor.tsx
import { useEffect as useEffect7 } from "react";

// src/context/Context.tsx
import { createContext, useContext } from "react";
var Context = createContext(void 0);
var useThemeEditor = () => {
  const context = useContext(Context);
  if (!context) {
    throw new Error(
      "useThemeEditor must be used within an ThemeEditorProvider"
    );
  }
  return context;
};
var Context_default = Context;

// src/components/DonateComponentModal/DonateComponentModal.tsx
import { useEffect as useEffect3, useState as useState3 } from "react";
import { faCircleExclamation } from "@fortawesome/pro-regular-svg-icons/faCircleExclamation";
import { faFloppyDisk } from "@fortawesome/pro-regular-svg-icons/faFloppyDisk";
import { faArrowsRotate } from "@fortawesome/pro-regular-svg-icons/faArrowsRotate";
import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalTitle,
  ModalDescription,
  ModalFooter,
  FormControl,
  FormItem,
  FormLabel,
  FormMessage,
  Input,
  Button,
  Icon as Icon2,
  Alert,
  AlertDescription,
  cn as cn4
} from "@appcues/sonar-builder";
import { get as get2 } from "object-path-immutable";
import camelCase from "lodash.camelcase";
import startCase from "lodash.startcase";

// src/components/PreviewPane/PreviewPane.tsx
import { useState as useState2 } from "react";
import { faSun } from "@fortawesome/free-solid-svg-icons/faSun";
import { faMoon } from "@fortawesome/free-solid-svg-icons/faMoon";
import {
  SegmentedControlGroup,
  SegmentedControlGroupItem,
  Icon,
  cn as cn3
} from "@appcues/sonar-builder";

// src/lib/preview/style-from.ts
import { get } from "object-path-immutable";
var getTokenValueFromPath = (tokens, path) => get(tokens, path)?.$value;
var resolveTokenValue = (theme, reference, overrideId) => {
  const path = reference.replace(/[{}]/g, "");
  if (overrideId) {
    const overrideTokens = theme.content.overrides?.find(
      ({ id }) => id === overrideId
    )?.tokens;
    if (overrideTokens) {
      const value2 = getTokenValueFromPath(overrideTokens, path);
      if (value2) {
        if (value2.startsWith("{")) {
          return resolveTokenValue(theme, value2);
        }
        return value2;
      }
    }
  }
  const value = getTokenValueFromPath(theme.content.tokens, path);
  if (value) {
    if (value.startsWith("{")) {
      return resolveTokenValue(theme, value);
    }
    return value;
  }
  return reference;
};
var transformValue = (platform, value) => {
  if (platform === "web") {
    return value;
  }
  if (typeof value === "string" && value.endsWith("px")) {
    return Number.parseFloat(value);
  }
  if (value === "100%") {
    return -1;
  }
  return value;
};
var handleMobileFontFamily = (theme, styleObject, overrideId) => {
  const path = styleObject.fontFamily.replace(/[{}]/g, "");
  const tokenObj = get(theme.content.tokens, path);
  const fontExtensions = tokenObj?.$extensions?.["com.appcues.theme.font"];
  const fontWeight = resolveTokenValue(theme, styleObject.fontWeight, overrideId) || "regular";
  const mobileFontName = fontExtensions?.mobile?.[fontWeight];
  return mobileFontName;
};
var styleFrom = (theme, platform, path, overrideId) => {
  const componentStyle = get(theme.content.components, `${path}.$style`);
  const override = theme.content.overrides?.find(({ id }) => id === overrideId);
  const overrideStyle = override ? get(override.components, `${path}.$style`) : void 0;
  if (!componentStyle && !overrideStyle) return {};
  const mergedStyle = {
    ...componentStyle,
    ...overrideStyle
  };
  const resolveStyleTokens = (styleObject) => {
    if (typeof styleObject !== "object" || styleObject === null) {
      return styleObject;
    }
    return Object.entries(styleObject).reduce(
      (acc, [key, value]) => {
        if (platform === "mobile" && key === "fontFamily") {
          const val = handleMobileFontFamily(theme, styleObject, overrideId);
          acc.fontName = val;
          return acc;
        }
        if (typeof value === "string" && value.startsWith("{")) {
          acc[key] = transformValue(
            platform,
            resolveTokenValue(theme, value, overrideId)
          );
        } else if (typeof value === "object") {
          acc[key] = resolveStyleTokens(value);
        } else {
          acc[key] = transformValue(platform, value);
        }
        return acc;
      },
      {}
    );
  };
  return resolveStyleTokens(mergedStyle);
};

// src/lib/preview/component-preview/mobile/helpers.ts
var DEFAULT_ICON_URL = "https://images.appcues.com/v1660836995/103523/roh2p8ba1mtwtzganmad.png";
var stackBlockWrapper = (content) => ({
  type: "stack",
  id: `${content.id}-stack`,
  orientation: "horizontal",
  distribution: "equal",
  items: [
    {
      type: "block",
      blockType: content.type,
      id: `${content.id}-block`,
      content
    }
  ]
});

// src/lib/preview/component-preview/helpers.ts
var DEFAULT_IMAGE_URL = "https://images.appcues.com/v1658371422/mobile-builder/default-image.jpg";
var capitalize = (s) => s.charAt(0).toUpperCase() + s.slice(1);

// src/lib/preview/component-preview/mobile/image.ts
var mobileImagePreview = (theme, variantName) => ({
  block: stackBlockWrapper({
    type: "image",
    id: `image-${variantName}`,
    imageUrl: DEFAULT_IMAGE_URL,
    style: styleFrom(theme, "mobile", `image.${variantName}`)
  })
});

// src/lib/preview/component-preview/mobile/text.ts
var mobileTextPreview = (theme, variantName) => ({
  block: stackBlockWrapper({
    type: "text",
    id: `text-${variantName}`,
    text: `${capitalize(variantName)} text`,
    style: styleFrom(theme, "mobile", `text.${variantName}`)
  })
});

// src/lib/preview/component-preview/mobile/button.ts
var mobileButtonPreview = (theme, variantName) => ({
  block: stackBlockWrapper({
    type: "button",
    id: `button-${variantName}`,
    content: {
      type: "text",
      id: `button-${variantName}-text`,
      text: `${capitalize(variantName)} Button`,
      style: styleFrom(theme, "mobile", `button.${variantName}.text`)
    },
    style: styleFrom(theme, "mobile", `button.${variantName}`)
  })
});

// src/lib/preview/make-mobile-experience.ts
var PLATFORM = "mobile";
var makeImageRows = (theme) => Object.keys(theme.content.components?.image || {}).flatMap((variantName) => {
  const preview = mobileImagePreview(theme, variantName);
  return preview?.block ? [preview.block] : [];
});
var makeTextRows = (theme) => Object.keys(theme.content.components?.text || {}).flatMap((variantName) => {
  const preview = mobileTextPreview(theme, variantName);
  return preview?.block ? [preview.block] : [];
});
var makeButtonRows = (theme) => Object.keys(theme.content.components?.button || {}).flatMap((variantName) => {
  const preview = mobileButtonPreview(theme, variantName);
  return preview?.block ? [preview.block] : [];
});
var makeMobileExperience = (theme) => ({
  id: "exp-0",
  name: "POC Modal One",
  type: "mobile",
  tags: [],
  theme: "",
  actions: {},
  traits: [],
  steps: [
    {
      id: "step-group-0",
      type: "group",
      actions: {},
      traits: [
        {
          type: "@appcues/modal",
          config: {
            presentationStyle: "dialog",
            style: styleFrom(theme, PLATFORM, "container.modal.default")
          }
        },
        {
          type: "@appcues/backdrop",
          config: styleFrom(
            theme,
            PLATFORM,
            "container.modal.default.backdrop"
          )
        }
      ],
      children: [
        {
          id: "step-child-0",
          type: "modal",
          contentType: "application/json",
          content: {
            type: "stack",
            orientation: "vertical",
            id: "main-stack",
            style: {},
            items: [
              ...makeImageRows(theme),
              ...makeTextRows(theme),
              ...makeButtonRows(theme)
            ]
          },
          traits: [],
          actions: {}
        }
      ]
    }
  ]
});
var wrapMobileComponentPreview = ({
  traits,
  block
}) => ({
  id: "exp-0",
  name: "Component",
  type: "mobile_embed",
  tags: [],
  theme: "",
  actions: {},
  traits: [],
  steps: [
    {
      id: "step-group-0",
      type: "group",
      actions: {},
      traits: traits ?? [
        {
          type: "@appcues/embedded",
          config: {
            presentationStyle: "embed"
          }
        }
      ],
      children: [
        {
          id: "step-child-0",
          type: "modal",
          contentType: "application/json",
          content: {
            type: "stack",
            orientation: "vertical",
            id: "main-stack",
            style: {},
            items: [
              block ?? stackBlockWrapper({
                type: "text",
                id: "text-0",
                text: "",
                style: {
                  fontSize: 16,
                  marginTop: 48,
                  marginBottom: 48
                }
              })
            ]
          },
          traits: [],
          actions: {}
        }
      ]
    }
  ]
});

// src/lib/preview/component-preview/web/helpers.ts
var cellWrapper = (content) => ({
  nodeId: `${content.nodeId}-cell`,
  type: "block",
  version: 1,
  props: {
    blockType: "Cell",
    is: "div",
    style: {
      alignItems: "center",
      boxSizing: "border-box",
      display: "flex",
      flex: 1,
      height: "100%",
      justifyContent: "center",
      paddingBottom: "10px",
      paddingInlineEnd: "10px",
      paddingInlineStart: "10px",
      paddingTop: "10px",
      position: "relative",
      width: "100%"
    },
    children: [content]
  }
});
var makeFloatingTrait = () => ({
  config: {
    placementUnit: "pixel",
    strategy: "fixed",
    target: { selector: "flow-root" },
    unsetOppositeDirection: true,
    xOffset: 0,
    xPosition: "center",
    yOffset: 0,
    yPosition: "center"
  },
  type: "@appcues/floating"
});
var makeStepBase = () => ({
  id: "step-0",
  type: "flow",
  actions: {},
  traits: [makeFloatingTrait()]
});
var makeExpBase = () => ({
  id: "exp-0",
  name: "Component",
  type: "flow",
  accountId: "103523",
  tags: [],
  theme: "",
  actions: {},
  traits: [{ type: "@appcues/sequential" }, { type: "@appcues/coreEvents" }]
});
var makeWebContainerExperience = (blockType, is, containerStyle) => ({
  ...makeExpBase(),
  steps: [
    {
      ...makeStepBase(),
      content: {
        nodeId: "container",
        type: "block",
        version: 1,
        props: {
          behaviors: { position: "center-center" },
          blockType,
          id: "flow-root",
          is,
          style: {
            minHeight: "min-content",
            minWidth: "min-content",
            maxWidth: "80vw",
            maxHeight: "80vh",
            ...containerStyle
          },
          children: []
        }
      }
    }
  ]
});

// src/lib/preview/component-preview/web/text.ts
var WEB_TEXT_TAGS = /* @__PURE__ */ new Set(["h1", "h2", "h3", "h4", "h5", "p"]);
var textLabel = (tag, variantName) => {
  if (variantName !== "default") return `${variantName} (${tag.toUpperCase()})`;
  return tag === "p" ? "Paragraph" : `Heading ${tag.toUpperCase()}`;
};
var webTextPrimitive = (theme, tag, variantName) => ({
  nodeId: `${tag}-${variantName}-primitive`,
  type: "primitive",
  props: {
    is: tag,
    style: styleFrom(theme, "web", `web.${tag}.${variantName}`),
    children: [textLabel(tag, variantName)]
  }
});
var webTextPreview = (theme, children) => {
  const [firstTag, firstVariant] = children[0] ?? ["text", "default"];
  const nodeId = `${firstTag}-${firstVariant}`;
  return {
    block: cellWrapper({
      nodeId,
      type: "block",
      version: 1,
      props: {
        blockType: "RichText",
        id: nodeId,
        is: "div",
        style: { margin: 0, minWidth: "200px" },
        children: children.map(
          ([tag, variantName]) => webTextPrimitive(theme, tag, variantName)
        )
      }
    })
  };
};

// src/lib/preview/component-preview/web/button.ts
var webButtonPreview = (theme, variantName) => ({
  block: cellWrapper({
    nodeId: `button-${variantName}`,
    type: "block",
    version: 1,
    props: {
      blockType: "Button",
      id: `button-${variantName}`,
      is: "button",
      style: styleFrom(theme, "web", `web.button.${variantName}`),
      children: [`${capitalize(variantName)} Button`]
    }
  })
});

// src/lib/preview/make-web-experience.ts
var PLATFORM2 = "web";
var HEADING_LEVELS = ["h1", "h2", "h3", "h4", "h5"];
var makeTextRows2 = (theme) => {
  const webComponents = theme.content.components?.web;
  const pairs = [...HEADING_LEVELS, "p"].flatMap(
    (tag) => Object.keys(webComponents?.[tag] || {}).map(
      (variantKey) => [tag, variantKey]
    )
  );
  if (pairs.length === 0) return [];
  const preview = webTextPreview(theme, pairs);
  return preview?.block ? [preview.block] : [];
};
var makeButtonRows2 = (theme) => Object.keys(
  theme.content.components?.web?.button || {}
).flatMap((variantKey) => {
  const preview = webButtonPreview(theme, variantKey);
  return preview?.block ? [preview.block] : [];
});
var makeWebExperience = (theme) => ({
  id: "exp-0",
  name: "POC Modal One",
  type: "flow",
  accountId: "103523",
  actions: {},
  traits: [
    {
      type: "@appcues/sequential"
    },
    {
      type: "@appcues/coreEvents"
    }
  ],
  steps: [
    {
      id: "step-0",
      type: "flow",
      actions: {},
      traits: [
        {
          config: {
            placementUnit: "pixel",
            strategy: "fixed",
            target: {
              selector: "flow-root"
            },
            unsetOppositeDirection: true,
            xOffset: 0,
            xPosition: "center",
            yOffset: 0,
            yPosition: "center"
          },
          type: "@appcues/floating"
        }
      ],
      content: {
        nodeId: "resizable-container",
        type: "block",
        version: 1,
        props: {
          behaviors: {
            position: "center-center"
          },
          blockType: "ResizableContainer",
          id: "flow-root",
          is: "div",
          style: {
            maxHeight: "80vh",
            maxWidth: "80vw",
            minHeight: "min-content",
            minWidth: "min-content",
            position: "relative",
            width: "720px",
            ...styleFrom(theme, PLATFORM2, "web.modal.default")
          },
          children: [
            {
              nodeId: "layout-builder",
              type: "block",
              version: 1,
              props: {
                behaviors: {
                  interaction: true
                },
                blockType: "LayoutBuilder",
                id: "layout-builder-53b4ddf0-e523-49d3-ac76-41755676dbd4",
                is: "div",
                root: false,
                style: {
                  display: "flex",
                  flex: 1,
                  flexDirection: "column",
                  height: "100%",
                  minHeight: "min-content",
                  minWidth: "min-content",
                  pointerEvents: "all",
                  width: "100%"
                },
                children: [...makeTextRows2(theme), ...makeButtonRows2(theme)]
              }
            }
          ]
        }
      }
    }
  ]
});
var wrapWebComponentPreview = (block) => ({
  id: "exp-0",
  name: "Component",
  type: "flow",
  accountId: "103523",
  tags: [],
  theme: "",
  actions: {},
  traits: [
    {
      type: "@appcues/sequential"
    },
    {
      type: "@appcues/coreEvents"
    }
  ],
  steps: [
    {
      id: "step-0",
      type: "flow",
      actions: {},
      traits: [
        {
          config: {
            placementUnit: "pixel",
            strategy: "fixed",
            target: {
              selector: "flow-root"
            },
            unsetOppositeDirection: true,
            xOffset: 0,
            xPosition: "center",
            yOffset: 0,
            yPosition: "center"
          },
          type: "@appcues/floating"
        }
      ],
      content: {
        nodeId: "resizable-container",
        type: "block",
        version: 1,
        props: {
          behaviors: {
            position: "center-center"
          },
          blockType: "ResizableContainer",
          id: "flow-root",
          is: "div",
          style: {
            width: "80%",
            height: "80%",
            fontFamily: "Arial, sans-serif"
          },
          children: [block]
        }
      }
    }
  ]
});

// src/lib/preview/component-preview/mobile/hero.ts
var mobileHeroPreview = (theme, variantName) => {
  const heroId = `hero-${variantName}`;
  return {
    block: {
      type: "block",
      blockType: "hero",
      id: `${heroId}-block`,
      content: {
        type: "stack",
        id: heroId,
        orientation: "vertical",
        style: {
          width: -1,
          ...styleFrom(theme, "mobile", `hero.${variantName}`)
        },
        items: [
          {
            type: "stack",
            id: `${heroId}-title-stack`,
            orientation: "horizontal",
            distribution: "equal",
            items: [
              {
                type: "text",
                id: `${heroId}-title`,
                text: "Ready to make your workflow simpler?",
                style: styleFrom(theme, "mobile", `hero.${variantName}.title`)
              }
            ]
          },
          {
            type: "stack",
            id: `${heroId}-subtitle-stack`,
            orientation: "horizontal",
            distribution: "equal",
            items: [
              {
                type: "text",
                id: `${heroId}-subtitle`,
                text: "Take a few moments to learn how to use our features.",
                style: styleFrom(
                  theme,
                  "mobile",
                  `hero.${variantName}.subtitle`
                )
              }
            ]
          }
        ]
      }
    }
  };
};

// src/lib/preview/component-preview/mobile/image-with-text.ts
var mobileImageWithTextPreview = (theme, variantName) => {
  const iwtId = `imagewithtext-${variantName}`;
  return {
    block: {
      type: "block",
      blockType: "imagewithtext",
      id: `${iwtId}-block`,
      content: {
        type: "stack",
        id: iwtId,
        orientation: "horizontal",
        distribution: "center",
        style: {
          horizontalAlignment: "leading",
          verticalAlignment: "center",
          paddingTop: 8,
          paddingBottom: 8,
          paddingLeading: 16,
          paddingTrailing: 16,
          ...styleFrom(theme, "mobile", `imagewithtext.${variantName}`)
        },
        items: [
          {
            type: "stack",
            id: `${iwtId}-image-stack`,
            orientation: "vertical",
            style: { verticalAlignment: "top" },
            items: [
              {
                type: "image",
                id: `${iwtId}-image`,
                imageUrl: DEFAULT_ICON_URL,
                contentMode: "fit",
                intrinsicSize: { width: 112, height: 112 },
                style: {
                  width: 56,
                  marginTrailing: 8,
                  ...styleFrom(
                    theme,
                    "mobile",
                    `imagewithtext.${variantName}.image`
                  )
                }
              }
            ]
          },
          {
            type: "stack",
            id: `${iwtId}-text-stack`,
            orientation: "vertical",
            style: { horizontalAlignment: "leading" },
            items: [
              {
                type: "text",
                id: `${iwtId}-title`,
                text: "New feature",
                style: styleFrom(
                  theme,
                  "mobile",
                  `imagewithtext.${variantName}.title`
                )
              },
              {
                type: "text",
                id: `${iwtId}-subtitle`,
                text: "Now you can customize your experience!",
                style: styleFrom(
                  theme,
                  "mobile",
                  `imagewithtext.${variantName}.subtitle`
                )
              }
            ]
          }
        ]
      }
    }
  };
};

// src/lib/preview/component-preview/mobile/select.ts
var mobileSelectPreview = (theme, variantName) => {
  const selectId = `select-${variantName}`;
  const optionStyle = styleFrom(
    theme,
    "mobile",
    `select.${variantName}.optionContent`
  );
  return {
    block: {
      type: "block",
      blockType: "singleSelect",
      id: `${selectId}-block`,
      content: {
        type: "optionSelect",
        id: selectId,
        label: {
          type: "text",
          id: `${selectId}-label`,
          text: "Question label",
          style: styleFrom(theme, "mobile", `select.${variantName}.label`)
        },
        selectMode: "single",
        options: [
          {
            value: "Yes",
            content: {
              id: `${selectId}-yes`,
              type: "text",
              text: "Yes",
              style: optionStyle
            }
          },
          {
            value: "No",
            content: {
              id: `${selectId}-no`,
              type: "text",
              text: "No",
              style: optionStyle
            }
          }
        ],
        controlPosition: "leading",
        displayFormat: "verticalList",
        style: styleFrom(theme, "mobile", `select.${variantName}`)
      }
    }
  };
};

// src/lib/preview/component-preview/mobile/text-input.ts
var mobileTextInputPreview = (theme, variantName) => {
  const tiId = `textinput-${variantName}`;
  return {
    block: {
      type: "block",
      blockType: "textInput",
      id: `${tiId}-block`,
      content: {
        type: "textInput",
        id: tiId,
        label: {
          type: "text",
          id: `${tiId}-label`,
          text: "Question label",
          style: styleFrom(theme, "mobile", `textinput.${variantName}.label`)
        },
        placeholder: {
          type: "text",
          id: `${tiId}-placeholder`,
          text: "Answer",
          style: styleFrom(
            theme,
            "mobile",
            `textinput.${variantName}.placeholder`
          )
        },
        textFieldStyle: styleFrom(
          theme,
          "mobile",
          `textinput.${variantName}.textField`
        ),
        style: styleFrom(theme, "mobile", `textinput.${variantName}`),
        dataType: "text",
        numberOfLines: 1,
        maxLength: 1e5
      }
    }
  };
};

// src/lib/preview/component-preview/mobile/container.ts
var mobileModalPreview = (theme, variantName) => ({
  traits: [
    {
      type: "@appcues/modal",
      config: {
        presentationStyle: "dialog",
        style: styleFrom(theme, "mobile", `container.modal.${variantName}`)
      }
    },
    {
      type: "@appcues/backdrop",
      config: styleFrom(
        theme,
        "mobile",
        `container.modal.${variantName}.backdrop`
      )
    }
  ]
});
var mobileTooltipPreview = (theme, variantName) => ({
  traits: [
    {
      type: "@appcues/tooltip",
      config: {
        presentationStyle: "tooltip",
        style: styleFrom(theme, "mobile", `container.tooltip.${variantName}`)
      }
    }
  ]
});
var mobileEmbedPreview = (theme, variantName) => ({
  traits: [
    {
      type: "@appcues/embedded",
      config: {
        presentationStyle: "embed",
        style: styleFrom(theme, "mobile", `container.embed.${variantName}`)
      }
    }
  ]
});

// src/lib/preview/component-preview/mobile/index.ts
var makeMobilePreview = (theme, componentType, variantName) => {
  switch (componentType) {
    case "text":
      return mobileTextPreview(theme, variantName);
    case "button":
      return mobileButtonPreview(theme, variantName);
    case "image":
      return mobileImagePreview(theme, variantName);
    case "hero":
      return mobileHeroPreview(theme, variantName);
    case "imagewithtext":
      return mobileImageWithTextPreview(theme, variantName);
    case "select":
      return mobileSelectPreview(theme, variantName);
    case "textinput":
      return mobileTextInputPreview(theme, variantName);
    case "container.modal":
      return mobileModalPreview(theme, variantName);
    case "container.tooltip":
      return mobileTooltipPreview(theme, variantName);
    case "container.embed":
      return mobileEmbedPreview(theme, variantName);
    default:
      return null;
  }
};

// src/lib/preview/component-preview/web/img.ts
var webImgPreview = (theme, variantName) => {
  const imgId = `img-${variantName}`;
  return {
    block: cellWrapper({
      nodeId: imgId,
      type: "block",
      version: 1,
      props: {
        blockType: "Image",
        is: "figure",
        style: {
          margin: 0,
          border: "none",
          background: "none",
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        },
        children: [
          {
            nodeId: `${imgId}-img`,
            type: "primitive",
            version: 1,
            props: {
              is: "img",
              src: DEFAULT_IMAGE_URL,
              role: "presentation",
              style: {
                boxSizing: "border-box",
                width: "200px",
                height: "150px",
                objectFit: "cover",
                ...styleFrom(theme, "web", `web.img.${variantName}`)
              }
            }
          }
        ]
      }
    })
  };
};

// src/lib/preview/component-preview/web/cell.ts
var webCellPreview = (theme, variantName) => {
  const cellId = `cell-${variantName}`;
  return {
    block: {
      nodeId: cellId,
      type: "block",
      version: 1,
      props: {
        blockType: "Cell",
        is: "div",
        "data-theme": `web.cell.${variantName}`,
        style: {
          flex: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
          height: "100%",
          boxSizing: "border-box",
          ...styleFrom(theme, "web", `web.cell.${variantName}`)
        },
        children: []
      }
    }
  };
};

// src/lib/preview/component-preview/web/close-x.ts
var CLOSE_X_PATH = "M12.2944 0.292751C12.6851 -0.0975836 13.3164 -0.0975836 13.707 0.292751C14.0977 0.683398 14.0977 1.31656 13.707 1.7072L8.41609 6.97219L13.707 12.2944C14.0977 12.685 14.0977 13.3163 13.707 13.7069C13.3164 14.0976 12.6851 14.0976 12.2944 13.7069L6.97226 8.41602L1.70728 13.7069C1.31664 14.0976 0.683476 14.0976 0.292891 13.7069C-0.0976305 13.3163 -0.0976305 12.685 0.292891 12.2944L5.58469 6.97219L0.292891 1.7072C-0.0976305 1.31656 -0.0976305 0.683398 0.292891 0.292751C0.683476 -0.0975836 1.31664 -0.0975836 1.70728 0.292751L6.97226 5.58461L12.2944 0.292751Z";
var webCloseXPreview = (theme, variantName) => {
  const closeXId = `close-x-${variantName}`;
  return {
    block: cellWrapper({
      nodeId: closeXId,
      type: "block",
      version: 1,
      props: {
        blockType: "CloseX",
        id: "close-x-button",
        is: "button",
        "data-theme": `web.close-x.${variantName}`,
        style: {
          width: "14px",
          height: "14px",
          boxSizing: "content-box",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
          ...styleFrom(theme, "web", `web.close-x.${variantName}`),
          // Override default positioning so the button centres in the preview
          position: "relative",
          top: "auto",
          insetInlineEnd: "auto",
          zIndex: "auto"
        },
        children: [
          {
            nodeId: `${closeXId}-svg`,
            version: 1,
            type: "primitive",
            props: {
              is: "svg",
              "aria-hidden": true,
              viewBox: "0 0 14 14",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg",
              style: { width: "100%", height: "100%" },
              children: [
                {
                  nodeId: `${closeXId}-path`,
                  version: 1,
                  type: "primitive",
                  props: {
                    is: "path",
                    d: CLOSE_X_PATH,
                    fill: "currentColor",
                    children: []
                  }
                }
              ]
            }
          }
        ]
      }
    })
  };
};

// src/lib/preview/component-preview/web/container.ts
var webModalPreview = (theme, variantName) => ({
  experience: makeWebContainerExperience("ResizableContainer", "div", {
    height: "300px",
    width: "500px",
    ...styleFrom(theme, "web", `web.modal.${variantName}`)
  })
});
var webTooltipPreview = (theme, variantName) => ({
  experience: makeWebContainerExperience("ResizableContainer", "div", {
    height: "200px",
    width: "300px",
    ...styleFrom(theme, "web", `web.tooltip.${variantName}`)
  })
});
var webEmbedPreview = (theme, variantName) => ({
  experience: makeWebContainerExperience("FullContainer", "aside", {
    width: "100%",
    height: "200px",
    display: "block",
    boxSizing: "border-box",
    ...styleFrom(theme, "web", `web.embed.${variantName}`)
  })
});

// src/lib/preview/component-preview/web/index.ts
var makeWebPreview = (theme, key, variantName) => {
  switch (key) {
    case "web.button":
      return webButtonPreview(theme, variantName);
    case "web.img":
      return webImgPreview(theme, variantName);
    case "web.cell":
      return webCellPreview(theme, variantName);
    case "web.close-x":
      return webCloseXPreview(theme, variantName);
    case "web.modal":
      return webModalPreview(theme, variantName);
    case "web.tooltip":
      return webTooltipPreview(theme, variantName);
    case "web.embed":
      return webEmbedPreview(theme, variantName);
    default: {
      const tag = key.replace(/^web\./, "");
      return WEB_TEXT_TAGS.has(tag) ? webTextPreview(theme, [[tag, variantName]]) : null;
    }
  }
};

// src/lib/preview/component-preview/registry.ts
var MOBILE_COMPONENT_TYPES = {
  Blocks: [
    { id: "text", label: "Text", keys: ["text"] },
    { id: "button", label: "Button", keys: ["button"] },
    { id: "image", label: "Image", keys: ["image"] },
    { id: "hero", label: "Hero", keys: ["hero"] },
    { id: "imagewithtext", label: "Image with Text", keys: ["imagewithtext"] },
    { id: "select", label: "Select", keys: ["select"] },
    { id: "textinput", label: "Text Input", keys: ["textinput"] }
  ],
  Containers: [
    { id: "container.modal", label: "Modal", keys: ["container.modal"] },
    { id: "container.tooltip", label: "Tooltip", keys: ["container.tooltip"] },
    { id: "container.embed", label: "Embed", keys: ["container.embed"] }
  ]
};
var WEB_COMPONENT_TYPES = {
  Blocks: [
    {
      id: "web.text",
      label: "Text",
      keys: ["web.h1", "web.h2", "web.h3", "web.h4", "web.h5", "web.p"]
    },
    { id: "web.button", label: "Button", keys: ["web.button"] },
    { id: "web.img", label: "Image", keys: ["web.img"] },
    { id: "web.close-x", label: "Close X", keys: ["web.close-x"] }
  ],
  Containers: [
    { id: "web.modal", label: "Modal", keys: ["web.modal"] },
    { id: "web.tooltip", label: "Tooltip", keys: ["web.tooltip"] },
    { id: "web.embed", label: "Embed", keys: ["web.embed"] },
    { id: "web.cell", label: "Cell", keys: ["web.cell"] }
  ]
};
var getComponentTypes = (platform) => platform === "web" ? WEB_COMPONENT_TYPES : MOBILE_COMPONENT_TYPES;
var getVariants = (components, keys) => keys.flatMap((key) => {
  const parts = key.split(".");
  let node = components;
  for (const part of parts) {
    node = node[part] ?? {};
  }
  return Object.keys(node).map((variantName) => ({ key, variantName }));
});

// src/lib/preview/component-preview/index.ts
var makeComponentVariantPreview = (theme, platform, key, variantName) => {
  if (platform === "mobile") {
    return makeMobilePreview(theme, key, variantName);
  }
  return makeWebPreview(theme, key, variantName);
};

// src/components/PreviewPane/MobilePreviewFrame.tsx
import { useEffect, useRef } from "react";
import { cn } from "@appcues/sonar-builder";
import { jsx, jsxs } from "react/jsx-runtime";
var MobilePreviewFrame = ({
  title,
  mobileExperience,
  colorMode = "light"
}) => {
  const iframeRef = useRef(null);
  const srcUrl = `${window.location.origin}/image-service`;
  useEffect(() => {
    const iframe = iframeRef.current?.contentWindow;
    if (iframe) {
      iframe.addEventListener("load", () => {
        iframe.apc_set_mobile_experience?.(mobileExperience, "step-child-0", {
          colorMode
        });
      });
    }
  });
  useEffect(() => {
    const iframe = iframeRef.current?.contentWindow;
    if (iframe) {
      iframe.apc_set_mobile_experience?.(mobileExperience, "step-child-0", {
        colorMode
      });
    }
  }, [mobileExperience, colorMode]);
  return /* @__PURE__ */ jsxs("div", { className: cn("relative flex-1"), children: [
    /* @__PURE__ */ jsx(
      "iframe",
      {
        ref: iframeRef,
        className: cn("w-full h-full border-0 pointer-events-none"),
        title,
        scrolling: "no",
        src: srcUrl
      }
    ),
    title ? /* @__PURE__ */ jsx(
      "div",
      {
        className: cn("absolute top-0 left-0 p-4 font-bold leading-normal"),
        children: title
      }
    ) : null
  ] });
};

// src/components/PreviewPane/WebPreviewFrame.tsx
import { useEffect as useEffect2, useCallback, useRef as useRef2, useState } from "react";
import createAppcues from "@appcues/open-builder";
import { cn as cn2 } from "@appcues/sonar-builder";
import { jsx as jsx2, jsxs as jsxs2 } from "react/jsx-runtime";
var STANDALONE_SRCDOC = '<!DOCTYPE html><html><head><style>body{font-family:"Lato",sans-serif}</style></head><body></body></html>';
function makeExtensionSrcdoc(openBuilderUrl) {
  return `<!DOCTYPE html>
<html>
<head>
  <script src="${openBuilderUrl}"><\/script>
  <script>
  let sdk = null;
  window.addEventListener('message', ({ data }) => {
    if (data?.type !== 'APPCUES_PREVIEW') return;
    sdk?.stopAll();
    sdk = createAppcues({
      getWindowReference: () => window,
      sendEvent: () => {},
      updateUserProfile: () => {},
      showFlow: () => {},
    });
    sdk.show(data.experience);
  });
  <\/script>
  <style>body{font-family:"Lato",sans-serif}</style>
</head>
<body></body>
</html>`;
}
var extensionSrcdocCache = null;
function getExtensionSrcdoc() {
  if (!extensionSrcdocCache) {
    const url = window.chrome?.runtime?.getURL("open-builder.iife.js") ?? "";
    extensionSrcdocCache = makeExtensionSrcdoc(url);
  }
  return extensionSrcdocCache;
}
function getIsExtension() {
  return !!window.chrome?.runtime?.id;
}
function swallow(event) {
  event.preventDefault();
  event.stopPropagation();
}
function suppressClicks(doc) {
  doc.addEventListener("click", swallow, true);
  doc.addEventListener("auxclick", swallow, true);
}
var WebPreviewFrame = ({
  title,
  experience
}) => {
  const isExtension = getIsExtension();
  const [sdk, setSdk] = useState(null);
  const [iframeLoaded, setIframeLoaded] = useState(false);
  const iframeRef = useRef2(null);
  const handleIframeLoad = useCallback(() => {
    const doc = iframeRef.current?.contentDocument;
    if (doc) suppressClicks(doc);
    if (isExtension) {
      setIframeLoaded(true);
    } else {
      const node = iframeRef.current;
      if (!node?.contentWindow) return;
      setSdk(
        createAppcues({
          sendEvent: () => {
          },
          updateUserProfile: () => {
          },
          showFlow: () => {
          },
          getWindowReference: () => node.contentWindow
        })
      );
    }
  }, [isExtension]);
  useEffect2(() => {
    if (!sdk) return () => {
    };
    sdk.show(experience);
    return () => {
      if (iframeRef.current?.contentWindow) sdk.stopAll();
    };
  }, [sdk, experience]);
  useEffect2(() => {
    if (!iframeLoaded) return;
    iframeRef.current?.contentWindow?.postMessage(
      { type: "APPCUES_PREVIEW", experience },
      "*"
    );
  }, [iframeLoaded, experience]);
  return /* @__PURE__ */ jsxs2("div", { className: cn2("relative flex-1"), children: [
    /* @__PURE__ */ jsx2(
      "iframe",
      {
        ref: iframeRef,
        className: cn2("w-full h-full border-0"),
        onLoad: handleIframeLoad,
        title,
        scrolling: "no",
        srcDoc: isExtension ? getExtensionSrcdoc() : STANDALONE_SRCDOC,
        sandbox: "allow-scripts allow-same-origin"
      }
    ),
    title ? /* @__PURE__ */ jsx2(
      "div",
      {
        className: cn2("absolute top-0 left-0 p-4 font-bold leading-normal"),
        children: title
      }
    ) : null
  ] });
};

// src/components/PreviewPane/PreviewFrame.tsx
import { jsx as jsx3 } from "react/jsx-runtime";
var PreviewFrame = ({
  theme,
  platform,
  component,
  title,
  colorMode = "light"
}) => {
  if (platform === "mobile") {
    const mobileExperience = component ? wrapMobileComponentPreview(component) : makeMobileExperience(theme);
    return /* @__PURE__ */ jsx3(
      MobilePreviewFrame,
      {
        title,
        mobileExperience,
        colorMode
      }
    );
  }
  const webExperience = component?.experience ?? (component?.block ? wrapWebComponentPreview(component.block) : makeWebExperience(theme));
  return /* @__PURE__ */ jsx3(WebPreviewFrame, { title, experience: webExperience });
};

// src/components/PreviewPane/PreviewPane.tsx
import { jsx as jsx4, jsxs as jsxs3 } from "react/jsx-runtime";
var PreviewPane = ({
  platform,
  theme
}) => {
  const [colorMode, setColorMode] = useState2("light");
  return /* @__PURE__ */ jsxs3(
    "div",
    {
      className: cn3(
        "h-full flex flex-col items-stretch",
        colorMode === "dark" ? "bg-level-inverse" : "bg-neutral-0"
      ),
      "data-theme": colorMode,
      children: [
        /* @__PURE__ */ jsx4(
          "div",
          {
            className: cn3(
              "flex items-center justify-end mx-4 py-4 border-b border-neutral-2"
            ),
            children: /* @__PURE__ */ jsxs3(
              SegmentedControlGroup,
              {
                iconOnly: true,
                value: colorMode,
                size: "small",
                "aria-label": "Preview mode",
                onValueChange: (value) => setColorMode(value),
                children: [
                  /* @__PURE__ */ jsx4(SegmentedControlGroupItem, { value: "light", children: /* @__PURE__ */ jsx4(Icon, { icon: faSun }) }),
                  /* @__PURE__ */ jsx4(SegmentedControlGroupItem, { value: "dark", children: /* @__PURE__ */ jsx4(Icon, { icon: faMoon }) })
                ]
              }
            )
          }
        ),
        /* @__PURE__ */ jsx4(PreviewFrame, { theme, platform, colorMode })
      ]
    }
  );
};

// src/components/DonateComponentModal/DonateComponentModal.tsx
import { Fragment, jsx as jsx5, jsxs as jsxs4 } from "react/jsx-runtime";
var makeUpdatedComponentDefinition = (base, delta) => {
  const result = { ...base };
  Object.entries(delta).forEach(([key, value]) => {
    if (typeof value === "object" && value !== null && !Array.isArray(value)) {
      result[key] = makeUpdatedComponentDefinition(result[key] || {}, value);
    } else if (value === void 0) {
      delete result[key];
    } else {
      result[key] = delta[key];
    }
  });
  return result;
};
var DonateComponentModal = ({
  platform,
  onSave
}) => {
  const {
    container,
    theme,
    updateTheme,
    donatedComponent,
    setDonatedComponent
  } = useThemeEditor();
  const [componentName, setComponentName] = useState3("");
  const [saveState, setSaveState] = useState3(
    "idle"
  );
  const { isCreate, type, existingPath } = donatedComponent ?? {};
  const existingName = existingPath?.split(".").pop();
  const path = isCreate ? `${type}.${camelCase(componentName)}` : existingPath;
  useEffect3(() => {
    const initialName = existingName ? `${existingName.split(".").pop()} 2` : void 0;
    setComponentName(initialName ?? "");
    setSaveState("idle");
  }, [existingName]);
  useEffect3(() => {
    if (saveState === "pending") {
      onSave({ donatedVariantName: path });
      setSaveState("saving");
    }
  }, [saveState, onSave, path]);
  if (!donatedComponent || !theme) return null;
  const unavailableNames = Object.keys(
    theme.content.components[donatedComponent.type] ?? {}
  );
  const showErrors = saveState === "idle";
  const nameIsError = showErrors && unavailableNames.includes(camelCase(componentName));
  const handleSave = () => {
    const existingComponent = get2(theme.content.components, existingPath) ?? {};
    const updatedComponent = makeUpdatedComponentDefinition(
      existingComponent,
      donatedComponent.componentDefinition
    );
    updateTheme(`content.components.${path}`, updatedComponent);
    setSaveState("pending");
  };
  return /* @__PURE__ */ jsx5(
    Modal,
    {
      container,
      open: donatedComponent !== null,
      onOpenChange: () => setDonatedComponent(null),
      children: /* @__PURE__ */ jsxs4(ModalContent, { children: [
        /* @__PURE__ */ jsx5(ModalHeader, { children: /* @__PURE__ */ jsxs4(ModalTitle, { children: [
          /* @__PURE__ */ jsx5(Icon2, { icon: isCreate ? faFloppyDisk : faArrowsRotate }),
          isCreate ? "Save as new variant" : `Update \u201C${startCase(existingName)}\u201D`
        ] }) }),
        /* @__PURE__ */ jsx5(ModalDescription, { children: /* @__PURE__ */ jsxs4(
          "form",
          {
            className: cn4("flex flex-col gap-6"),
            "aria-label": "save component form",
            role: "form",
            "data-theme": "light",
            children: [
              isCreate && /* @__PURE__ */ jsxs4(Fragment, { children: [
                "Save your changes as a new variant so it can be reused in flows that use the theme \u201C",
                theme.name,
                "\u201D.",
                /* @__PURE__ */ jsxs4(FormItem, { children: [
                  /* @__PURE__ */ jsx5(FormLabel, { htmlFor: "name", children: "Variant name" }),
                  /* @__PURE__ */ jsx5(FormControl, { children: /* @__PURE__ */ jsx5(
                    Input,
                    {
                      id: "name",
                      defaultValue: componentName,
                      onChange: (event) => setComponentName(event.target.value),
                      placeholder: "Component name"
                    }
                  ) }),
                  nameIsError && /* @__PURE__ */ jsxs4(FormMessage, { state: "error", children: [
                    "\u201C",
                    componentName,
                    "\u201D already exists."
                  ] })
                ] })
              ] }),
              !isCreate && /* @__PURE__ */ jsxs4(Alert, { variant: "warning", children: [
                /* @__PURE__ */ jsx5(Icon2, { icon: faCircleExclamation, size: "small" }),
                /* @__PURE__ */ jsx5(AlertDescription, { children: "This updated style will immediately be applied to all flows that use this variant." })
              ] }),
              /* @__PURE__ */ jsxs4("div", { className: cn4("flex border border-neutral-2 rounded-md"), children: [
                donatedComponent.originalReferenceModel ? /* @__PURE__ */ jsxs4(Fragment, { children: [
                  /* @__PURE__ */ jsx5(
                    PreviewFrame,
                    {
                      theme,
                      platform,
                      title: "Original",
                      component: donatedComponent.originalReferenceModel
                    }
                  ),
                  /* @__PURE__ */ jsx5("div", { className: "w-px self-stretch my-4 bg-neutral-2" })
                ] }) : null,
                /* @__PURE__ */ jsx5(
                  PreviewFrame,
                  {
                    theme,
                    platform,
                    title: isCreate ? "Preview" : "Updated",
                    component: donatedComponent.referenceModel
                  }
                )
              ] })
            ]
          }
        ) }),
        /* @__PURE__ */ jsxs4(ModalFooter, { children: [
          /* @__PURE__ */ jsx5(
            Button,
            {
              type: "button",
              variant: "outline",
              onClick: () => setDonatedComponent(null),
              children: "Cancel"
            }
          ),
          /* @__PURE__ */ jsx5(
            Button,
            {
              type: "button",
              variant: "primary",
              disabled: isCreate && !(componentName && !nameIsError),
              onClick: handleSave,
              children: isCreate ? "Save" : "Update variant"
            }
          )
        ] })
      ] })
    }
  );
};

// ../../node_modules/@fortawesome/react-fontawesome/index.es.js
var import_prop_types = __toESM(require_prop_types());
import { parse, icon } from "@fortawesome/fontawesome-svg-core";
import React from "react";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), true).forEach(function(key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _typeof(obj) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj2) {
    return typeof obj2;
  } : function(obj2) {
    return obj2 && "function" == typeof Symbol && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
  }, _typeof(obj);
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function classList(props) {
  var _classes;
  var beat = props.beat, fade = props.fade, beatFade = props.beatFade, bounce = props.bounce, shake = props.shake, flash = props.flash, spin = props.spin, spinPulse = props.spinPulse, spinReverse = props.spinReverse, pulse = props.pulse, fixedWidth = props.fixedWidth, inverse = props.inverse, border = props.border, listItem = props.listItem, flip = props.flip, size = props.size, rotation = props.rotation, pull = props.pull;
  var classes = (_classes = {
    "fa-beat": beat,
    "fa-fade": fade,
    "fa-beat-fade": beatFade,
    "fa-bounce": bounce,
    "fa-shake": shake,
    "fa-flash": flash,
    "fa-spin": spin,
    "fa-spin-reverse": spinReverse,
    "fa-spin-pulse": spinPulse,
    "fa-pulse": pulse,
    "fa-fw": fixedWidth,
    "fa-inverse": inverse,
    "fa-border": border,
    "fa-li": listItem,
    "fa-flip": flip === true,
    "fa-flip-horizontal": flip === "horizontal" || flip === "both",
    "fa-flip-vertical": flip === "vertical" || flip === "both"
  }, _defineProperty(_classes, "fa-".concat(size), typeof size !== "undefined" && size !== null), _defineProperty(_classes, "fa-rotate-".concat(rotation), typeof rotation !== "undefined" && rotation !== null && rotation !== 0), _defineProperty(_classes, "fa-pull-".concat(pull), typeof pull !== "undefined" && pull !== null), _defineProperty(_classes, "fa-swap-opacity", props.swapOpacity), _classes);
  return Object.keys(classes).map(function(key) {
    return classes[key] ? key : null;
  }).filter(function(key) {
    return key;
  });
}
function _isNumerical(obj) {
  obj = obj - 0;
  return obj === obj;
}
function camelize(string) {
  if (_isNumerical(string)) {
    return string;
  }
  string = string.replace(/[\-_\s]+(.)?/g, function(match, chr) {
    return chr ? chr.toUpperCase() : "";
  });
  return string.substr(0, 1).toLowerCase() + string.substr(1);
}
var _excluded = ["style"];
function capitalize2(val) {
  return val.charAt(0).toUpperCase() + val.slice(1);
}
function styleToObject(style) {
  return style.split(";").map(function(s) {
    return s.trim();
  }).filter(function(s) {
    return s;
  }).reduce(function(acc, pair) {
    var i = pair.indexOf(":");
    var prop = camelize(pair.slice(0, i));
    var value = pair.slice(i + 1).trim();
    prop.startsWith("webkit") ? acc[capitalize2(prop)] = value : acc[prop] = value;
    return acc;
  }, {});
}
function convert(createElement, element) {
  var extraProps = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  if (typeof element === "string") {
    return element;
  }
  var children = (element.children || []).map(function(child) {
    return convert(createElement, child);
  });
  var mixins = Object.keys(element.attributes || {}).reduce(function(acc, key) {
    var val = element.attributes[key];
    switch (key) {
      case "class":
        acc.attrs["className"] = val;
        delete element.attributes["class"];
        break;
      case "style":
        acc.attrs["style"] = styleToObject(val);
        break;
      default:
        if (key.indexOf("aria-") === 0 || key.indexOf("data-") === 0) {
          acc.attrs[key.toLowerCase()] = val;
        } else {
          acc.attrs[camelize(key)] = val;
        }
    }
    return acc;
  }, {
    attrs: {}
  });
  var _extraProps$style = extraProps.style, existingStyle = _extraProps$style === void 0 ? {} : _extraProps$style, remaining = _objectWithoutProperties(extraProps, _excluded);
  mixins.attrs["style"] = _objectSpread2(_objectSpread2({}, mixins.attrs["style"]), existingStyle);
  return createElement.apply(void 0, [element.tag, _objectSpread2(_objectSpread2({}, mixins.attrs), remaining)].concat(_toConsumableArray(children)));
}
var PRODUCTION = false;
try {
  PRODUCTION = false;
} catch (e) {
}
function log() {
  if (!PRODUCTION && console && typeof console.error === "function") {
    var _console;
    (_console = console).error.apply(_console, arguments);
  }
}
function normalizeIconArgs(icon2) {
  if (icon2 && _typeof(icon2) === "object" && icon2.prefix && icon2.iconName && icon2.icon) {
    return icon2;
  }
  if (parse.icon) {
    return parse.icon(icon2);
  }
  if (icon2 === null) {
    return null;
  }
  if (icon2 && _typeof(icon2) === "object" && icon2.prefix && icon2.iconName) {
    return icon2;
  }
  if (Array.isArray(icon2) && icon2.length === 2) {
    return {
      prefix: icon2[0],
      iconName: icon2[1]
    };
  }
  if (typeof icon2 === "string") {
    return {
      prefix: "fas",
      iconName: icon2
    };
  }
}
function objectWithKey(key, value) {
  return Array.isArray(value) && value.length > 0 || !Array.isArray(value) && value ? _defineProperty({}, key, value) : {};
}
var FontAwesomeIcon = /* @__PURE__ */ React.forwardRef(function(props, ref) {
  var iconArgs = props.icon, maskArgs = props.mask, symbol = props.symbol, className = props.className, title = props.title, titleId = props.titleId, maskId = props.maskId;
  var iconLookup = normalizeIconArgs(iconArgs);
  var classes = objectWithKey("classes", [].concat(_toConsumableArray(classList(props)), _toConsumableArray(className.split(" "))));
  var transform = objectWithKey("transform", typeof props.transform === "string" ? parse.transform(props.transform) : props.transform);
  var mask = objectWithKey("mask", normalizeIconArgs(maskArgs));
  var renderedIcon = icon(iconLookup, _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, classes), transform), mask), {}, {
    symbol,
    title,
    titleId,
    maskId
  }));
  if (!renderedIcon) {
    log("Could not find icon", iconLookup);
    return null;
  }
  var abstract = renderedIcon.abstract;
  var extraProps = {
    ref
  };
  Object.keys(props).forEach(function(key) {
    if (!FontAwesomeIcon.defaultProps.hasOwnProperty(key)) {
      extraProps[key] = props[key];
    }
  });
  return convertCurry(abstract[0], extraProps);
});
FontAwesomeIcon.displayName = "FontAwesomeIcon";
FontAwesomeIcon.propTypes = {
  beat: import_prop_types.default.bool,
  border: import_prop_types.default.bool,
  beatFade: import_prop_types.default.bool,
  bounce: import_prop_types.default.bool,
  className: import_prop_types.default.string,
  fade: import_prop_types.default.bool,
  flash: import_prop_types.default.bool,
  mask: import_prop_types.default.oneOfType([import_prop_types.default.object, import_prop_types.default.array, import_prop_types.default.string]),
  maskId: import_prop_types.default.string,
  fixedWidth: import_prop_types.default.bool,
  inverse: import_prop_types.default.bool,
  flip: import_prop_types.default.oneOf([true, false, "horizontal", "vertical", "both"]),
  icon: import_prop_types.default.oneOfType([import_prop_types.default.object, import_prop_types.default.array, import_prop_types.default.string]),
  listItem: import_prop_types.default.bool,
  pull: import_prop_types.default.oneOf(["right", "left"]),
  pulse: import_prop_types.default.bool,
  rotation: import_prop_types.default.oneOf([0, 90, 180, 270]),
  shake: import_prop_types.default.bool,
  size: import_prop_types.default.oneOf(["2xs", "xs", "sm", "lg", "xl", "2xl", "1x", "2x", "3x", "4x", "5x", "6x", "7x", "8x", "9x", "10x"]),
  spin: import_prop_types.default.bool,
  spinPulse: import_prop_types.default.bool,
  spinReverse: import_prop_types.default.bool,
  symbol: import_prop_types.default.oneOfType([import_prop_types.default.bool, import_prop_types.default.string]),
  title: import_prop_types.default.string,
  titleId: import_prop_types.default.string,
  transform: import_prop_types.default.oneOfType([import_prop_types.default.string, import_prop_types.default.object]),
  swapOpacity: import_prop_types.default.bool
};
FontAwesomeIcon.defaultProps = {
  border: false,
  className: "",
  mask: null,
  maskId: null,
  fixedWidth: false,
  inverse: false,
  flip: false,
  icon: null,
  listItem: false,
  pull: null,
  pulse: false,
  rotation: null,
  size: null,
  spin: false,
  spinPulse: false,
  spinReverse: false,
  beat: false,
  fade: false,
  beatFade: false,
  bounce: false,
  shake: false,
  symbol: false,
  title: "",
  titleId: null,
  transform: null,
  swapOpacity: false
};
var convertCurry = convert.bind(null, React.createElement);

// src/components/ThemeModal/ThemeModal.tsx
import { faSwatchbook } from "@fortawesome/pro-regular-svg-icons/faSwatchbook";
import { faPuzzlePiece } from "@fortawesome/pro-regular-svg-icons/faPuzzlePiece";
import { faArrowRightFromLine } from "@fortawesome/pro-regular-svg-icons/faArrowRightFromLine";
import { faSpinnerThird } from "@fortawesome/pro-regular-svg-icons/faSpinnerThird";
import {
  Modal as Modal2,
  ModalContent as ModalContent2,
  ModalHeader as ModalHeader2,
  ModalTitle as ModalTitle2,
  ModalFooter as ModalFooter2,
  Icon as Icon8,
  Button as Button7,
  TabsRoot,
  TabsList,
  TabsTrigger,
  TabsContent
} from "@appcues/sonar-builder";

// src/components/StyleSettings/StyleSettings.tsx
import { Accordion } from "@appcues/sonar-builder";

// src/components/StyleSettings/OverviewSection.tsx
import { useState as useState4 } from "react";
import {
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
  Flex,
  Input as Input2,
  Label,
  Switch
} from "@appcues/sonar-builder";

// src/lib/color-handler.ts
var updateToDarkMode = (enabled, components) => {
  const processValue = (value) => {
    if (!value || typeof value !== "object") {
      return value;
    }
    if ("light" in value && typeof value.light === "string") {
      if (!enabled) {
        const { dark, ...rest } = value;
        return rest;
      }
      return {
        ...value,
        dark: value.light.startsWith("{colors.") ? value.light.replace("{colors.", "{colors.dark.") : value.light
      };
    }
    return Object.fromEntries(
      Object.entries(value).map(([key, val]) => [key, processValue(val)])
    );
  };
  return processValue(components);
};

// src/components/StyleSettings/SettingsFieldset.tsx
import { cn as cn5 } from "@appcues/sonar-builder";
import { jsx as jsx6 } from "react/jsx-runtime";
var SettingsFieldset = ({
  children,
  className
}) => /* @__PURE__ */ jsx6(
  "fieldset",
  {
    className: cn5(
      "flex flex-row justify-between gap-2 m-0 p-0 border-0 [&>label]:min-w-[40%] [&>label]:flex-1",
      className
    ),
    children
  }
);

// src/components/StyleSettings/OverviewSection.tsx
import { jsx as jsx7, jsxs as jsxs5 } from "react/jsx-runtime";
var OverviewSection = ({ theme }) => {
  const { updateTheme } = useThemeEditor();
  const { name: themeName, content } = theme;
  const { meta, components } = content;
  const [name, setName] = useState4(themeName);
  const [darkMode, setDarkMode] = useState4(meta?.darkMode ?? false);
  const handleNameChange = (event) => {
    const { value } = event.target;
    setName(value);
    updateTheme("", { name: value });
  };
  const handleDarkModeChange = (checked) => {
    setDarkMode(checked);
    updateTheme("content", {
      meta: {
        ...meta,
        darkMode: checked
      },
      components: updateToDarkMode(checked, components)
    });
  };
  return /* @__PURE__ */ jsxs5(AccordionItem, { value: "overview", children: [
    /* @__PURE__ */ jsx7(AccordionTrigger, { children: "Theme settings" }),
    /* @__PURE__ */ jsx7(AccordionContent, { children: /* @__PURE__ */ jsxs5(Flex, { direction: "column", gap: "md", children: [
      /* @__PURE__ */ jsxs5(SettingsFieldset, { children: [
        /* @__PURE__ */ jsx7(Label, { htmlFor: "name", children: "Name" }),
        /* @__PURE__ */ jsx7(
          Input2,
          {
            size: "small",
            id: "name",
            defaultValue: name,
            onChange: handleNameChange,
            placeholder: "Theme name"
          }
        )
      ] }),
      /* @__PURE__ */ jsxs5(SettingsFieldset, { children: [
        /* @__PURE__ */ jsx7(Label, { htmlFor: "dark-mode", children: "Enable dark mode" }),
        /* @__PURE__ */ jsx7(
          Switch,
          {
            id: "dark-mode",
            checked: darkMode,
            onCheckedChange: handleDarkModeChange
          }
        )
      ] })
    ] }) })
  ] });
};

// src/components/StyleSettings/ColorSection.tsx
var import_faSun2 = __toESM(require_faSun());
var import_faMoon2 = __toESM(require_faMoon());
import startCase2 from "lodash.startcase";
import { get as get3 } from "object-path-immutable";
import {
  AccordionItem as AccordionItem2,
  AccordionTrigger as AccordionTrigger2,
  AccordionContent as AccordionContent2,
  Flex as Flex2,
  Icon as Icon3,
  Label as Label2
} from "@appcues/sonar-builder";

// src/components/StyleSettings/ColorTokenInput.tsx
import { useState as useState5 } from "react";
import { Input as Input3, useModalPortal } from "@appcues/sonar-builder";
import { jsx as jsx8 } from "react/jsx-runtime";
var ColorTokenInput = ({
  path,
  token,
  prefix
}) => {
  const modalPortal = useModalPortal();
  const { updateTheme } = useThemeEditor();
  const [color, setColor] = useState5(token?.$value ?? "");
  const handleChange = (colorResult) => {
    const { hex } = colorResult;
    setColor(hex);
    updateTheme(path, {
      ...token,
      $value: hex
    });
  };
  return /* @__PURE__ */ jsx8(
    Input3,
    {
      id: path,
      type: "color",
      value: color,
      onChange: handleChange,
      size: "small",
      container: modalPortal,
      prefix
    }
  );
};

// src/components/StyleSettings/ColorSection.tsx
import { jsx as jsx9, jsxs as jsxs6 } from "react/jsx-runtime";
var ColorSection = ({ tokens, showDarkMode }) => {
  const controls = ["foreground", "background", "primary"].map((field) => ({
    light: {
      path: `content.tokens.colors.${field}`,
      label: startCase2(field),
      token: get3(tokens, `colors.${field}`)
    },
    ...showDarkMode && {
      dark: {
        path: `content.tokens.colors.dark.${field}`,
        token: get3(tokens, `colors.dark.${field}`)
      }
    }
  }));
  return /* @__PURE__ */ jsxs6(AccordionItem2, { value: "color", children: [
    /* @__PURE__ */ jsx9(AccordionTrigger2, { children: "Colors" }),
    /* @__PURE__ */ jsx9(AccordionContent2, { children: /* @__PURE__ */ jsx9(Flex2, { direction: "column", gap: "md", children: controls.map(({ light, dark }) => /* @__PURE__ */ jsxs6(SettingsFieldset, { children: [
      /* @__PURE__ */ jsx9(Label2, { htmlFor: light.path, children: light.label }),
      /* @__PURE__ */ jsx9(
        ColorTokenInput,
        {
          path: light.path,
          token: light.token,
          prefix: dark ? /* @__PURE__ */ jsx9(Icon3, { icon: import_faSun2.faSun, colorToken: "color-neutral-700" }) : void 0
        }
      ),
      dark ? /* @__PURE__ */ jsx9(
        ColorTokenInput,
        {
          path: dark.path,
          token: dark.token,
          prefix: /* @__PURE__ */ jsx9(Icon3, { icon: import_faMoon2.faMoon, colorToken: "color-neutral-700" })
        }
      ) : null
    ] }, light.path)) }) })
  ] });
};

// src/components/StyleSettings/InterfaceSection.tsx
import { useState as useState7 } from "react";
import { get as get5 } from "object-path-immutable";
import {
  AccordionItem as AccordionItem3,
  AccordionTrigger as AccordionTrigger3,
  AccordionContent as AccordionContent3,
  Flex as Flex3
} from "@appcues/sonar-builder";

// src/components/RangeInput.tsx
import { Label as Label3, Input as Input4, cn as cn6 } from "@appcues/sonar-builder";
import { jsx as jsx10, jsxs as jsxs7 } from "react/jsx-runtime";
var RangeInput = ({
  label,
  value,
  min,
  max,
  onValueChange
}) => {
  return /* @__PURE__ */ jsxs7("div", { className: cn6("flex-1 grid grid-cols-[1fr_auto] gap-2"), children: [
    /* @__PURE__ */ jsx10(Label3, { children: label }),
    /* @__PURE__ */ jsx10(
      Input4,
      {
        type: "number",
        size: "small",
        min,
        max,
        value,
        onChange: (event) => onValueChange(Number(event.target.value))
      }
    )
  ] });
};

// src/lib/basic-theme-tokens.ts
import { get as get4 } from "object-path-immutable";

// src/types.ts
var TOKEN_EXTENSIONS = {
  FONT: "com.appcues.theme.font",
  PRESET: "com.appcues.theme.preset"
};
var PRESET_SIZES = ["S", "M", "L"];

// src/lib/basic-theme-tokens.ts
var PRESET_FONT_SIZES = {
  S: [12, 14, 18, 14, 16, 18, 20, 24],
  M: [14, 16, 22, 16, 18, 20, 24, 32],
  L: [16, 18, 24, 18, 20, 22, 26, 34]
};
var PRESET_SPACING = {
  S: [0, 4, 6, 8, 10, 12],
  M: [0, 8, 12, 16, 20, 24],
  L: [0, 12, 18, 24, 30, 36]
};
var currentFontSize = (tokens) => {
  return get4(tokens, ["font", "size", "$extensions", TOKEN_EXTENSIONS.PRESET]);
};
var currentCornerRadius = (tokens) => Number.parseFloat(get4(tokens, "parts.container.corner-radius.$value"));
var currentSpacing = (tokens) => {
  return get4(tokens, [
    "dimensions",
    "unit",
    "$extensions",
    TOKEN_EXTENSIONS.PRESET
  ]);
};
var presetFontSizes = (size) => {
  const [small, regular, large, h5, h4, h3, h2, h1] = PRESET_FONT_SIZES[size];
  return {
    $type: "dimension",
    $extensions: {
      [TOKEN_EXTENSIONS.PRESET]: size
    },
    small: { $value: `${small}px` },
    regular: { $value: `${regular}px` },
    large: { $value: `${large}px` },
    h5: { $value: `${h5}px` },
    h4: { $value: `${h4}px` },
    h3: { $value: `${h3}px` },
    h2: { $value: `${h2}px` },
    h1: { $value: `${h1}px` }
  };
};
var presetSpacing = (size) => ({
  $type: "dimension",
  unit: {
    $extensions: {
      [TOKEN_EXTENSIONS.PRESET]: size
    },
    ...Object.fromEntries(
      PRESET_SPACING[size].map((value, i) => [
        i.toString(),
        { $value: `${value}px` }
      ])
    )
  }
});

// src/components/FontFamilySelect.tsx
import { useState as useState6 } from "react";
import startCase3 from "lodash.startcase";
import {
  Label as Label4,
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectPortal,
  SelectItem
} from "@appcues/sonar-builder";
import { Fragment as Fragment2, jsx as jsx11, jsxs as jsxs8 } from "react/jsx-runtime";
var SYSTEM_FONT_MAPPING = {
  "System Sans-serif": "System Default",
  "System Serif": "System Serif",
  "System Monospaced": "System Monospaced",
  "System Rounded": "System Rounded"
};
var systemFontMapping = (fontName) => ({
  ultralight: `${fontName} Ultralight`,
  thin: `${fontName} Thin`,
  light: `${fontName} Light`,
  regular: `${fontName} Regular`,
  medium: `${fontName} Medium`,
  semibold: `${fontName} Semibold`,
  bold: `${fontName} Bold`,
  heavy: `${fontName} Heavy`,
  black: `${fontName} Black`
});
var FontFamilySelect = ({
  path,
  label = startCase3(path.split(".").pop()),
  token
}) => {
  const { updateTheme, container } = useThemeEditor();
  const [fontFamily, setFontFamily] = useState6(token?.$value ?? "");
  const handleFontFamilyChange = (value) => {
    setFontFamily(value);
    const systemFontName = SYSTEM_FONT_MAPPING[value];
    updateTheme(path, {
      $value: value,
      $extensions: {
        [TOKEN_EXTENSIONS.FONT]: {
          mobile: systemFontMapping(systemFontName)
        }
      }
    });
  };
  return /* @__PURE__ */ jsxs8(Fragment2, { children: [
    /* @__PURE__ */ jsx11(Label4, { htmlFor: "font-family", children: label }),
    /* @__PURE__ */ jsxs8(
      Select,
      {
        name: "font-family",
        defaultValue: fontFamily,
        onValueChange: handleFontFamilyChange,
        children: [
          /* @__PURE__ */ jsx11(SelectTrigger, { id: "font-family", size: "small", children: /* @__PURE__ */ jsx11(SelectValue, { placeholder: "Select one" }) }),
          /* @__PURE__ */ jsx11(SelectPortal, { container, children: /* @__PURE__ */ jsxs8(SelectContent, { children: [
            /* @__PURE__ */ jsx11(SelectItem, { value: "System Sans-serif", children: "System Sans-serif" }),
            /* @__PURE__ */ jsx11(SelectItem, { value: "System Serif", children: "System Serif" }),
            /* @__PURE__ */ jsx11(SelectItem, { value: "System Monospaced", children: "System Monospaced" }),
            /* @__PURE__ */ jsx11(SelectItem, { value: "System Rounded", children: "System Rounded" })
          ] }) })
        ]
      }
    )
  ] });
};

// src/components/PresetSizeControl.tsx
import {
  Label as Label5,
  SegmentedControlGroup as SegmentedControlGroup2,
  SegmentedControlGroupItem as SegmentedControlGroupItem2
} from "@appcues/sonar-builder";
import { Fragment as Fragment3, jsx as jsx12, jsxs as jsxs9 } from "react/jsx-runtime";
var PresetSizeControl = ({
  label,
  value,
  onChange
}) => {
  return /* @__PURE__ */ jsxs9(Fragment3, { children: [
    /* @__PURE__ */ jsx12(Label5, { children: label }),
    /* @__PURE__ */ jsx12(
      SegmentedControlGroup2,
      {
        size: "small",
        value,
        "aria-label": label,
        onValueChange: onChange,
        children: PRESET_SIZES.map((size) => /* @__PURE__ */ jsx12(SegmentedControlGroupItem2, { value: size, children: size }, size))
      }
    )
  ] });
};

// src/components/StyleSettings/InterfaceSection.tsx
import { jsx as jsx13, jsxs as jsxs10 } from "react/jsx-runtime";
var InterfaceSection = ({ tokens }) => {
  const { updateTheme } = useThemeEditor();
  const [fontSize, setFontSize] = useState7(currentFontSize(tokens));
  const [cornerRadius, setCornerRadius] = useState7(currentCornerRadius(tokens));
  const [spacing, setSpacing] = useState7(currentSpacing(tokens));
  const handleFontSizeChange = (value) => {
    setFontSize(value);
    updateTheme("content.tokens.font.size", presetFontSizes(value));
  };
  const handleCornerRadiusChange = (value) => {
    setCornerRadius(value);
    updateTheme("content.tokens.parts.container.corner-radius", {
      $value: `${value}px`
    });
  };
  const handleSpacingChange = (value) => {
    setSpacing(value);
    updateTheme("content.tokens.dimensions", presetSpacing(value));
  };
  return /* @__PURE__ */ jsxs10(AccordionItem3, { value: "interface", children: [
    /* @__PURE__ */ jsx13(AccordionTrigger3, { children: "Interface" }),
    /* @__PURE__ */ jsx13(AccordionContent3, { children: /* @__PURE__ */ jsxs10(Flex3, { direction: "column", gap: "md", children: [
      /* @__PURE__ */ jsx13(SettingsFieldset, { children: /* @__PURE__ */ jsx13(
        FontFamilySelect,
        {
          path: "content.tokens.font.family.base",
          label: "Font family",
          token: get5(tokens, "font.family.base")
        }
      ) }),
      /* @__PURE__ */ jsx13(SettingsFieldset, { children: /* @__PURE__ */ jsx13(
        PresetSizeControl,
        {
          label: "Font size",
          value: fontSize,
          onChange: handleFontSizeChange
        }
      ) }),
      /* @__PURE__ */ jsx13(SettingsFieldset, { children: /* @__PURE__ */ jsx13(
        RangeInput,
        {
          label: "Corner radius",
          value: cornerRadius,
          min: 0,
          max: 100,
          onValueChange: handleCornerRadiusChange
        }
      ) }),
      /* @__PURE__ */ jsx13(SettingsFieldset, { children: /* @__PURE__ */ jsx13(
        PresetSizeControl,
        {
          label: "Spacing",
          value: spacing,
          onChange: handleSpacingChange
        }
      ) })
    ] }) })
  ] });
};

// src/components/StyleSettings/StyleSettings.tsx
import { jsx as jsx14, jsxs as jsxs11 } from "react/jsx-runtime";
var StyleSettings = ({ theme }) => {
  return /* @__PURE__ */ jsxs11(
    Accordion,
    {
      defaultValue: ["overview", "color", "interface"],
      type: "multiple",
      children: [
        /* @__PURE__ */ jsx14(OverviewSection, { theme }),
        /* @__PURE__ */ jsx14(
          ColorSection,
          {
            tokens: theme.content.tokens,
            showDarkMode: theme.content.meta?.darkMode ?? false
          }
        ),
        /* @__PURE__ */ jsx14(InterfaceSection, { tokens: theme.content.tokens })
      ]
    }
  );
};

// src/components/ThemeModal/Styles.tsx
import { jsx as jsx15, jsxs as jsxs12 } from "react/jsx-runtime";
var Styles = ({ platform, theme }) => /* @__PURE__ */ jsxs12("div", { className: "flex-1 overflow-hidden flex gap-2", children: [
  /* @__PURE__ */ jsx15("div", { className: "w-[336px] overflow-y-auto", children: /* @__PURE__ */ jsx15(StyleSettings, { theme }) }),
  /* @__PURE__ */ jsx15("div", { className: "flex-1 border border-neutral-2 rounded-sm overflow-hidden", children: /* @__PURE__ */ jsx15(PreviewPane, { platform, theme }) })
] });

// src/components/ThemeModal/Components.tsx
import { useState as useState16 } from "react";
import { faPlusCircle } from "@fortawesome/pro-regular-svg-icons/faPlusCircle";
import { cn as cn9, Icon as Icon6 } from "@appcues/sonar-builder";

// src/components/VariantEditor/VariantEditor.tsx
import { useState as useState15, useMemo as useMemo3 } from "react";
import { useModalPortal as useModalPortal2 } from "@appcues/sonar-builder";

// src/components/AdvancedStyles/AdvancedStyles.tsx
import { useState as useState13 } from "react";
import {
  Accordion as Accordion2,
  AccordionItem as AccordionItem4,
  AccordionTrigger as AccordionTrigger4,
  AccordionContent as AccordionContent4,
  Select as Select4,
  SelectTrigger as SelectTrigger4,
  SelectValue as SelectValue4,
  SelectContent as SelectContent4,
  SelectItem as SelectItem4,
  FormRow as FormRow2,
  Flex as Flex4
} from "@appcues/sonar-builder";

// src/components/AdvancedStyles/AddSectionForm.tsx
import { useState as useState8 } from "react";
import {
  Button as Button2,
  FormRow,
  Select as Select2,
  SelectTrigger as SelectTrigger2,
  SelectValue as SelectValue2,
  SelectContent as SelectContent2,
  SelectItem as SelectItem2
} from "@appcues/sonar-builder";
import { faPlus } from "@fortawesome/pro-regular-svg-icons/faPlus";
import { Fragment as Fragment4, jsx as jsx16, jsxs as jsxs13 } from "react/jsx-runtime";
var NONE_VALUE = "__none__";
var AddSectionForm = ({
  pseudoStates,
  onAddSection,
  elementConfig,
  track
}) => {
  const { pseudoClasses, pseudoElements } = elementConfig;
  const [isAdding, setIsAdding] = useState8(false);
  const [newPseudoClass, setNewPseudoClass] = useState8(NONE_VALUE);
  const [newPseudoElement, setNewPseudoElement] = useState8(NONE_VALUE);
  const hasPseudoClasses = pseudoClasses.length > 0;
  const hasPseudoElements = pseudoElements.length > 0;
  const pseudoClassValue = newPseudoClass === NONE_VALUE ? "" : newPseudoClass;
  const pseudoElementValue = newPseudoElement === NONE_VALUE ? "" : newPseudoElement;
  const combinedState = (() => {
    if (!pseudoClassValue && !pseudoElementValue) return "";
    if (!pseudoClassValue && pseudoElementValue) return pseudoElementValue;
    if (pseudoClassValue && !pseudoElementValue) return pseudoClassValue;
    return `${pseudoClassValue}:${pseudoElementValue}`;
  })();
  const canAdd = combinedState && !pseudoStates.includes(combinedState);
  const reset = () => {
    setNewPseudoClass(NONE_VALUE);
    setNewPseudoElement(NONE_VALUE);
    setIsAdding(false);
  };
  const handleAdd = () => {
    if (canAdd) {
      onAddSection(combinedState);
      track("CSS: Section Added", combinedState);
      reset();
    }
  };
  const handleCancel = () => {
    reset();
  };
  if (!hasPseudoClasses && !hasPseudoElements) {
    return null;
  }
  if (!isAdding) {
    return /* @__PURE__ */ jsxs13(
      Button2,
      {
        variant: "outline",
        size: "small",
        fullWidth: true,
        onClick: () => setIsAdding(true),
        children: [
          /* @__PURE__ */ jsx16(FontAwesomeIcon, { icon: faPlus, style: { marginRight: "8px" } }),
          "Add Section"
        ]
      }
    );
  }
  return /* @__PURE__ */ jsxs13(Fragment4, { children: [
    /* @__PURE__ */ jsxs13(FormRow, { children: [
      hasPseudoClasses && /* @__PURE__ */ jsxs13(Select2, { value: newPseudoClass, onValueChange: setNewPseudoClass, children: [
        /* @__PURE__ */ jsx16(SelectTrigger2, { size: "small", "aria-label": "Choose pseudo-class", children: /* @__PURE__ */ jsx16(SelectValue2, { placeholder: "Choose pseudo-class" }) }),
        /* @__PURE__ */ jsxs13(SelectContent2, { children: [
          /* @__PURE__ */ jsx16(SelectItem2, { value: NONE_VALUE, children: "element" }),
          pseudoClasses.map((value) => /* @__PURE__ */ jsxs13(SelectItem2, { value, children: [
            ":",
            value
          ] }, value))
        ] })
      ] }),
      hasPseudoElements && /* @__PURE__ */ jsxs13(Select2, { value: newPseudoElement, onValueChange: setNewPseudoElement, children: [
        /* @__PURE__ */ jsx16(SelectTrigger2, { size: "small", "aria-label": "Choose pseudo-element", children: /* @__PURE__ */ jsx16(SelectValue2, { placeholder: "Choose pseudo-element" }) }),
        /* @__PURE__ */ jsxs13(SelectContent2, { children: [
          /* @__PURE__ */ jsx16(SelectItem2, { value: NONE_VALUE, children: "none" }),
          pseudoElements.map((value) => /* @__PURE__ */ jsxs13(SelectItem2, { value, children: [
            "::",
            value
          ] }, value))
        ] })
      ] })
    ] }),
    /* @__PURE__ */ jsxs13(FormRow, { children: [
      /* @__PURE__ */ jsx16(
        Button2,
        {
          variant: "primary",
          size: "small",
          onClick: handleAdd,
          disabled: !canAdd,
          children: "Add"
        }
      ),
      /* @__PURE__ */ jsx16(Button2, { variant: "outline", size: "small", onClick: handleCancel, children: "Cancel" })
    ] })
  ] });
};

// src/components/AdvancedStyles/PropertyList.tsx
import { useRef as useRef3, useState as useState10, useEffect as useEffect5, useCallback as useCallback2 } from "react";
import {
  Button as Button3,
  Select as Select3,
  SelectValue as SelectValue3,
  SelectContent as SelectContent3,
  SelectItem as SelectItem3,
  ComboBox,
  ComboBoxContent,
  ComboBoxEmpty,
  ComboBoxGroup,
  ComboBoxInput,
  ComboBoxItem,
  ComboBoxList,
  ComboBoxTrigger,
  ComboBoxValue,
  Input as Input5,
  SelectTrigger as SelectTrigger3,
  cn as cn7,
  AutocompleteMenu,
  useAutocomplete,
  useInputAutocompleteAdapter
} from "@appcues/sonar-builder";
import { faTrash } from "@fortawesome/pro-regular-svg-icons/faTrash";
import { faPlus as faPlus2 } from "@fortawesome/pro-regular-svg-icons/faPlus";
import { faRotateLeft } from "@fortawesome/pro-regular-svg-icons/faRotateLeft";

// src/components/AdvancedStyles/hooks/use-section-manager.ts
import { useState as useState9, useEffect as useEffect4 } from "react";

// src/components/AdvancedStyles/css/constants.ts
var APPEARANCE_CSS_PROPERTIES = {
  "backdrop-filter": "*",
  "background-color": "*",
  "background-image": "*",
  "background-position": "*",
  "background-repeat": "*",
  "background-size": "*",
  "border-color": "*",
  "border-left-color": "*",
  "border-right-color": "*",
  "border-top-color": "*",
  "border-bottom-color": "*",
  "border-style": "*",
  "border-left-style": "*",
  "border-right-style": "*",
  "border-top-style": "*",
  "border-bottom-style": "*",
  "border-width": "*",
  "border-left-width": "*",
  "border-right-width": "*",
  "border-top-width": "*",
  "border-bottom-width": "*",
  "border-radius": "*",
  "border-bottom-left-radius": "*",
  "border-bottom-right-radius": "*",
  "border-top-left-radius": "*",
  "border-top-right-radius": "*",
  "box-shadow": "*",
  "clip-path": "*",
  cursor: "*",
  filter: "*",
  "mix-blend-mode": "*",
  opacity: "*",
  "outline-color": "*",
  "outline-style": "*",
  "outline-width": "*",
  "outline-offset": "*",
  overflow: ["visible", "hidden"],
  transform: "*",
  "transform-origin": "*",
  transition: "*"
};
var TEXT_CSS_PROPERTIES = {
  color: "*",
  "font-family": "*",
  "font-size": "*",
  "font-style": ["normal", "italic"],
  "font-weight": [
    "normal",
    "bold",
    "100",
    "200",
    "300",
    "400",
    "500",
    "600",
    "700",
    "800",
    "900"
  ],
  "letter-spacing": "*",
  "line-height": "*",
  "text-align": ["start", "center", "end", "justify"],
  "text-decoration": ["none", "underline", "overline", "line-through"],
  "text-shadow": "*",
  "text-transform": ["none", "uppercase", "lowercase", "capitalize"]
};
var STRUCTURAL_CSS_PROPERTIES = {
  height: "*",
  width: "*",
  "margin-bottom": "*",
  "margin-inline-end": "*",
  "margin-inline-start": "*",
  "margin-top": "*",
  "padding-bottom": "*",
  "padding-inline-end": "*",
  "padding-inline-start": "*",
  "padding-top": "*",
  position: ["relative"]
};
var COMMON_CSS_PROPERTIES = {
  ...APPEARANCE_CSS_PROPERTIES,
  ...TEXT_CSS_PROPERTIES,
  ...STRUCTURAL_CSS_PROPERTIES
};
var PSEUDO_ELEMENT_PROPERTIES = {
  ...COMMON_CSS_PROPERTIES,
  content: "*",
  bottom: "*",
  display: ["block", "inline", "inline-block", "none"],
  height: "*",
  left: "*",
  "max-height": "*",
  "max-width": "*",
  "min-height": "*",
  "min-width": "*",
  position: ["relative", "absolute"],
  right: "*",
  top: "*",
  width: "*",
  "z-index": "*"
};

// src/components/AdvancedStyles/css/util.ts
var kebabToCamel = (str) => {
  return str.replace(/-([a-z])/g, (_, letter) => letter.toUpperCase());
};
var camelToKebab = (str) => {
  return str.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
};
var formatStateStyles = (stateStyles) => Object.fromEntries(
  Object.entries(stateStyles).map(([stateName, props]) => [
    stateName,
    Object.fromEntries(
      Object.entries(props).map(([prop, val]) => [camelToKebab(prop), val])
    )
  ])
);
var formatDefaultStyles = (styles) => Object.fromEntries(
  Object.entries(styles).map(([key, value]) => [
    camelToKebab(key),
    key === "state" ? formatStateStyles(value) : value
  ])
);

// src/components/AdvancedStyles/css/css-expand-utils.ts
function extractFunctionCall(text, functionName) {
  const startIndex = text.indexOf(functionName);
  if (startIndex === -1) return null;
  const openParenIndex = text.indexOf("(", startIndex);
  if (openParenIndex === -1) return null;
  let depth = 0;
  let i = openParenIndex;
  while (i < text.length) {
    if (text[i] === "(") {
      depth += 1;
    } else if (text[i] === ")") {
      depth -= 1;
      if (depth === 0) {
        return text.slice(startIndex, i + 1);
      }
    }
    i += 1;
  }
  return null;
}
function extractAllFunctions(text) {
  const functions = [];
  let remaining = text;
  let index = 0;
  const functionPattern = /([a-z-]+)\(/gi;
  let match = functionPattern.exec(remaining);
  while (match !== null) {
    const functionName = match[1];
    const extracted = extractFunctionCall(remaining, functionName);
    if (extracted) {
      const placeholder = `__FUNC_${index}__`;
      functions.push([extracted, placeholder]);
      remaining = remaining.replace(extracted, placeholder);
      functionPattern.lastIndex = 0;
      index += 1;
    }
    match = functionPattern.exec(remaining);
  }
  return functions;
}

// src/components/AdvancedStyles/css/css-expand-box-model.ts
function expandBoxModel(value, prefix) {
  const functionsMap = /* @__PURE__ */ new Map();
  let processed = value;
  const extracted = extractAllFunctions(value);
  extracted.forEach(([func, placeholder]) => {
    functionsMap.set(placeholder, func);
    processed = processed.replace(func, placeholder);
  });
  let values = processed.split(/\s+/).filter((v) => v);
  values = values.map((v) => functionsMap.get(v) || v);
  if (values.length === 0) {
    return {};
  }
  let top;
  let inlineEnd;
  let bottom;
  let inlineStart;
  switch (values.length) {
    case 1: {
      const [val] = values;
      top = val;
      inlineEnd = val;
      bottom = val;
      inlineStart = val;
      break;
    }
    case 2: {
      const [vertical, horizontal] = values;
      top = vertical;
      bottom = vertical;
      inlineEnd = horizontal;
      inlineStart = horizontal;
      break;
    }
    case 3: {
      const [topVal, horizontal, bottomVal] = values;
      top = topVal;
      inlineEnd = horizontal;
      bottom = bottomVal;
      inlineStart = horizontal;
      break;
    }
    default: {
      [top, inlineEnd, bottom, inlineStart] = values;
    }
  }
  return {
    [`${prefix}-top`]: top,
    [`${prefix}-inline-end`]: inlineEnd,
    [`${prefix}-bottom`]: bottom,
    [`${prefix}-inline-start`]: inlineStart
  };
}

// src/components/AdvancedStyles/css/css-expand-border.ts
function expandBorderLike(value, prefix) {
  const result = {};
  const styles = /* @__PURE__ */ new Set([
    "none",
    "hidden",
    "dotted",
    "dashed",
    "solid",
    "double",
    "groove",
    "ridge",
    "inset",
    "outset"
  ]);
  const widthKeywords = /* @__PURE__ */ new Set(["thin", "medium", "thick"]);
  const parts = value.split(/\s+/).filter((v) => v);
  parts.forEach((part) => {
    if (styles.has(part.toLowerCase())) {
      result[`${prefix}-style`] = part;
    } else if (/^(\d+\.?\d*|\.\d+)(px|em|rem|%|pt|cm|mm|in|pc|ex|ch|vh|vw|vmin|vmax)?$/.test(
      part
    ) || widthKeywords.has(part.toLowerCase())) {
      result[`${prefix}-width`] = part;
    } else {
      result[`${prefix}-color`] = part;
    }
  });
  return result;
}

// src/components/AdvancedStyles/css/css-expand-background.ts
function splitByLayers(text) {
  const allFunctions = extractAllFunctions(text);
  let processed = text;
  allFunctions.forEach(([func, placeholder]) => {
    processed = processed.replace(func, placeholder);
  });
  const layers = processed.split(",").map((layer) => layer.trim());
  return layers.map((layer) => {
    let restored = layer;
    allFunctions.forEach(([func, placeholder]) => {
      restored = restored.replace(placeholder, func);
    });
    return restored;
  });
}
function processSingleBackgroundLayer(value) {
  const result = {
    "background-color": "initial"
  };
  const imageFunctions = /* @__PURE__ */ new Set([
    "url",
    "linear-gradient",
    "radial-gradient",
    "conic-gradient",
    "repeating-linear-gradient",
    "repeating-radial-gradient",
    "repeating-conic-gradient"
  ]);
  const colorFunctions = /* @__PURE__ */ new Set([
    "rgb",
    "rgba",
    "hsl",
    "hsla",
    "hwb",
    "lab",
    "lch",
    "oklab",
    "oklch"
  ]);
  const repeatKeywords = [
    "no-repeat",
    "repeat-x",
    "repeat-y",
    "space",
    "round",
    "repeat"
  ];
  const positionKeywords = /* @__PURE__ */ new Set([
    "left",
    "right",
    "center",
    "top",
    "bottom"
  ]);
  const sizeKeywords = /* @__PURE__ */ new Set(["cover", "contain", "auto"]);
  const ignoredKeywords = /* @__PURE__ */ new Set([
    "scroll",
    "fixed",
    "local",
    // background-attachment
    "border-box",
    "padding-box",
    "content-box",
    "text"
    // background-origin, background-clip
  ]);
  const nonColorKeywords = /* @__PURE__ */ new Set([
    ...positionKeywords,
    ...repeatKeywords,
    ...sizeKeywords
  ]);
  const allFunctions = extractAllFunctions(value);
  let remaining = value;
  ignoredKeywords.forEach((keyword) => {
    const regex = new RegExp(`\\b${keyword}\\b`, "gi");
    remaining = remaining.replace(regex, "").trim();
  });
  const functionsMap = /* @__PURE__ */ new Map();
  allFunctions.forEach(([func, placeholder]) => {
    functionsMap.set(placeholder, func);
    remaining = remaining.replace(func, placeholder);
  });
  allFunctions.forEach(([func, placeholder]) => {
    const funcName = func.match(/^([a-z-]+)\(/i)?.[1]?.toLowerCase();
    if (!funcName) return;
    if (imageFunctions.has(funcName)) {
      result["background-image"] = func;
      remaining = remaining.replace(placeholder, "").trim();
    } else if (colorFunctions.has(funcName)) {
      result["background-color"] = func;
      remaining = remaining.replace(placeholder, "").trim();
    }
  });
  const hexMatch = remaining.match(/#[\da-f]{3,8}\b/i);
  if (hexMatch) {
    const [hexColor] = hexMatch;
    result["background-color"] = hexColor;
    remaining = remaining.replace(hexColor, "").trim();
  }
  if (result["background-color"] === "initial") {
    const tokens = remaining.split(/\s+/).filter((t) => t);
    tokens.forEach((token) => {
      if (/^[a-z]+$/i.test(token) && !nonColorKeywords.has(token.toLowerCase())) {
        result["background-color"] = token;
        remaining = remaining.replace(token, "").trim();
      }
    });
  }
  const repeatMatch = repeatKeywords.find((keyword) => {
    const regex = new RegExp(`\\b${keyword}\\b`, "i");
    return regex.test(remaining);
  });
  if (repeatMatch) {
    result["background-repeat"] = repeatMatch;
    remaining = remaining.replace(new RegExp(`\\b${repeatMatch}\\b`, "i"), "").trim();
  }
  const slashIndex = remaining.indexOf("/");
  if (slashIndex !== -1) {
    let sizeValue = remaining.slice(slashIndex + 1).trim();
    functionsMap.forEach((func, placeholder) => {
      sizeValue = sizeValue.replace(placeholder, func);
    });
    if (sizeValue) result["background-size"] = sizeValue;
    remaining = remaining.slice(0, slashIndex).trim();
  }
  if (remaining) {
    let positionValue = remaining;
    functionsMap.forEach((func, placeholder) => {
      positionValue = positionValue.replace(placeholder, func);
    });
    result["background-position"] = positionValue;
  }
  return result;
}
function expandBackground(value) {
  const layers = splitByLayers(value);
  if (layers.length === 0) {
    return { "background-color": "initial" };
  }
  if (layers.length === 1) {
    return processSingleBackgroundLayer(layers[0]);
  }
  const layerResults = layers.map((layer) => processSingleBackgroundLayer(layer));
  const images = layerResults.map((r) => r["background-image"] || "initial");
  const positions = layerResults.map(
    (r) => r["background-position"] || "initial"
  );
  const sizes = layerResults.map((r) => r["background-size"] || "initial");
  const repeats = layerResults.map((r) => r["background-repeat"] || "initial");
  const backgroundColor = layerResults[layerResults.length - 1]["background-color"];
  const result = {
    "background-color": backgroundColor
  };
  if (images.some((img) => img !== "initial")) {
    result["background-image"] = images.join(", ");
  }
  if (positions.some((pos) => pos !== "initial")) {
    result["background-position"] = positions.join(", ");
  }
  if (sizes.some((size) => size !== "initial")) {
    result["background-size"] = sizes.join(", ");
  }
  if (repeats.some((repeat) => repeat !== "initial")) {
    result["background-repeat"] = repeats.join(", ");
  }
  return result;
}

// src/components/AdvancedStyles/css/css-expand-font.ts
function expandFont(value) {
  const result = {};
  const parts = value.split(/\s+/);
  const styles = /* @__PURE__ */ new Set(["normal", "italic", "oblique"]);
  const weights = /* @__PURE__ */ new Set([
    "normal",
    "bold",
    "bolder",
    "lighter",
    "100",
    "200",
    "300",
    "400",
    "500",
    "600",
    "700",
    "800",
    "900"
  ]);
  const remaining = [];
  parts.forEach((part) => {
    if (styles.has(part.toLowerCase())) {
      result["font-style"] = part;
    } else if (weights.has(part)) {
      result["font-weight"] = part;
    } else {
      remaining.push(part);
    }
  });
  if (remaining.length > 0) {
    const [firstRemaining] = remaining;
    const sizeMatch = firstRemaining.match(/^([^/]+)(\/(.+))?$/);
    if (sizeMatch) {
      const [, fontSize, , lineHeight] = sizeMatch;
      result["font-size"] = fontSize;
      if (lineHeight) {
        result["line-height"] = lineHeight;
      }
    }
    if (remaining.length > 1) {
      result["font-family"] = remaining.slice(1).join(" ");
    }
  }
  return result;
}

// src/components/AdvancedStyles/css/css-expand-shorthand.ts
function expandShorthandProperty(property, value) {
  const trimmedValue = value.trim();
  switch (property) {
    case "padding":
      return expandBoxModel(trimmedValue, "padding");
    case "margin":
      return expandBoxModel(trimmedValue, "margin");
    case "border":
    case "border-left":
    case "border-right":
    case "border-top":
    case "border-bottom":
      return expandBorderLike(trimmedValue, property);
    case "outline":
      return expandBorderLike(trimmedValue, "outline");
    case "background":
      return expandBackground(trimmedValue);
    case "font":
      return expandFont(trimmedValue);
    default:
      return { [property]: trimmedValue };
  }
}
function expandAllShorthands(properties) {
  return Object.entries(properties).reduce((expanded, [property, value]) => {
    return {
      ...expanded,
      ...expandShorthandProperty(property, value)
    };
  }, {});
}

// src/components/AdvancedStyles/css/css-validate.ts
function validateProperty(property, value, allowedProperties, denylistProperties) {
  if (!allowedProperties[property] || denylistProperties.has(property)) {
    return {
      valid: false,
      error: {
        type: "property-unsupported",
        message: `Property '${property}' is not supported`
      }
    };
  }
  const constraints = allowedProperties[property];
  if (Array.isArray(constraints)) {
    const trimmedValue = value.trim();
    if (!constraints.includes(trimmedValue)) {
      return {
        valid: false,
        error: {
          type: "value-invalid",
          message: `Value '${trimmedValue}' is not supported for '${property}'`
        }
      };
    }
  }
  return { valid: true };
}

// src/components/AdvancedStyles/css/css-parse.ts
function normalizeStateName(selector, allowedPseudoClasses, allowedPseudoElements) {
  const normalized = selector.replace(/^:+/, "");
  const parts = normalized.split(/:{1,2}/);
  let pseudoClass = "";
  let pseudoElement = "";
  let hasUnknown = false;
  let seenPseudoElement = false;
  parts.forEach((part) => {
    if (allowedPseudoClasses.has(part)) {
      if (seenPseudoElement) {
        hasUnknown = true;
      } else {
        pseudoClass = part;
      }
    } else if (allowedPseudoElements.has(part)) {
      pseudoElement = part;
      seenPseudoElement = true;
    } else if (part) {
      hasUnknown = true;
    }
  });
  if (hasUnknown) {
    return null;
  }
  if (pseudoClass && pseudoElement) {
    return `${pseudoClass}:${pseudoElement}`;
  }
  if (pseudoElement) {
    return pseudoElement;
  }
  return pseudoClass;
}
function normalizeMultilineValues(text) {
  const propertyStartPattern = /^\s*[a-z][\w-]*\s*:/i;
  const normalized = text.split("\n").reduce((acc, line) => {
    const trimmed = line.trim();
    if (!trimmed) {
      return acc;
    }
    if (propertyStartPattern.test(trimmed)) {
      return [...acc, trimmed];
    }
    const previousLine = acc[acc.length - 1];
    if (acc.length > 0 && !previousLine.endsWith(";")) {
      const updated = [...acc];
      updated[updated.length - 1] += ` ${trimmed}`;
      return updated;
    }
    return acc;
  }, []);
  return normalized.join("\n");
}
function parseProperties(text) {
  const lines = normalizeMultilineValues(text).split(/[\n;]/);
  return lines.reduce(
    (properties, line) => {
      const trimmed = line.trim();
      if (!trimmed) {
        return properties;
      }
      const colonIndex = trimmed.indexOf(":");
      if (colonIndex === -1) {
        return properties;
      }
      const property = trimmed.slice(0, colonIndex).trim();
      let value = trimmed.slice(colonIndex + 1).trim();
      value = value.replace(/\s*!important\s*$/i, "").trim();
      if (property && value) {
        return { ...properties, [property]: value };
      }
      return properties;
    },
    {}
  );
}
function parseCssText(cssText, allowedProperties = COMMON_CSS_PROPERTIES, denylistProperties, allowedPseudoClasses = [], allowedPseudoElements = []) {
  const errors = [];
  const style = {};
  const stateStyles = {};
  const allowedPseudoClassesSet = new Set(allowedPseudoClasses);
  const allowedPseudoElementsSet = new Set(allowedPseudoElements);
  let cleaned = cssText.replace(/\/\*[\S\s]*?\*\//g, "");
  const stateBlockRegex = /((?::{1,2}[\w-]+){1,2})\s*{([^}]*)}/g;
  const matches = [...cleaned.matchAll(stateBlockRegex)];
  matches.forEach((match) => {
    const [fullMatch, selector, content] = match;
    const stateName = normalizeStateName(
      selector,
      allowedPseudoClassesSet,
      allowedPseudoElementsSet
    );
    if (stateName === null) {
      errors.push({
        property: selector,
        type: "selector-unsupported",
        message: `Selector '${selector}' contains unsupported pseudo-class or pseudo-element`
      });
      cleaned = cleaned.replace(fullMatch, "");
      return;
    }
    const isPseudoElement = stateName.includes("before") || stateName.includes("after");
    const propertyAllowList = isPseudoElement ? PSEUDO_ELEMENT_PROPERTIES : allowedProperties;
    const propertyDenyList = isPseudoElement ? /* @__PURE__ */ new Set() : denylistProperties;
    const properties = parseProperties(content);
    const expandedProperties = expandAllShorthands(properties);
    Object.entries(expandedProperties).forEach(([property, value]) => {
      const validation = validateProperty(
        property,
        value,
        propertyAllowList,
        propertyDenyList
      );
      if (validation.valid) {
        if (!stateStyles[stateName]) {
          stateStyles[stateName] = {};
        }
        stateStyles[stateName][kebabToCamel(property)] = value;
      } else {
        errors.push({
          property: `${stateName}:${property}`,
          type: validation.error.type,
          message: validation.error.message
        });
      }
    });
    cleaned = cleaned.replace(fullMatch, "");
  });
  const baseProperties = parseProperties(cleaned);
  const expandedBase = expandAllShorthands(baseProperties);
  Object.entries(expandedBase).forEach(([property, value]) => {
    const validation = validateProperty(
      property,
      value,
      allowedProperties,
      denylistProperties
    );
    if (validation.valid) {
      style[kebabToCamel(property)] = value;
    } else {
      errors.push({
        property,
        type: validation.error.type,
        message: validation.error.message
      });
    }
  });
  if (Object.keys(stateStyles).length > 0) {
    style.state = stateStyles;
  }
  if (Object.keys(style).length === 0) {
    errors.push({
      property: "css",
      type: "other",
      message: "No supported CSS properties found"
    });
  }
  return {
    style,
    errors
  };
}

// src/components/AdvancedStyles/hooks/use-section-manager.ts
var useSectionManager = (elementConfig) => {
  const { styleStore } = elementConfig;
  const [cssErrors, setCssErrors] = useState9([]);
  const [previousStyles, setPreviousStyles] = useState9(null);
  const getPseudoStates = () => Object.keys(styleStore.getStyles()?.state || {});
  const [pseudoStates, setPseudoStates] = useState9(getPseudoStates());
  useEffect4(() => {
    setPseudoStates(getPseudoStates());
    setCssErrors([]);
    setPreviousStyles(null);
  }, [styleStore.id]);
  const addSection = (state) => {
    const currentStyles = styleStore.getStyles();
    styleStore.setAllStyles({
      ...currentStyles,
      state: {
        ...currentStyles.state,
        [state]: {}
      }
    });
    setPseudoStates((prev) => [...prev, state]);
  };
  const deleteSection = (state) => {
    const currentStyles = styleStore.getStyles();
    const newState = { ...currentStyles.state };
    delete newState[state];
    styleStore.setAllStyles({
      ...currentStyles,
      ...Object.keys(newState).length > 0 ? { state: newState } : { state: void 0 }
    });
    setPseudoStates((prev) => prev.filter((s) => s !== state));
  };
  const handleBulkCss = (cssText) => {
    if (!cssText.trim()) {
      setCssErrors([
        {
          property: "clipboard",
          type: "other",
          message: "No CSS provided"
        }
      ]);
      return;
    }
    const { style: parsedStyles, errors } = parseCssText(
      cssText,
      elementConfig.allowedProperties,
      elementConfig.denylistProperties,
      elementConfig.pseudoClasses,
      elementConfig.pseudoElements
    );
    if (errors.length > 0 && Object.keys(parsedStyles).length === 0) {
      setCssErrors(errors);
      return;
    }
    const currentStyles = styleStore.getStyles();
    setPreviousStyles({ ...currentStyles });
    const currentState = currentStyles.state || {};
    const { state: newState = {}, ...baseStyles } = parsedStyles;
    const mergedState = Object.keys(newState).reduce(
      (acc, state) => {
        acc[state] = {
          ...currentState[state],
          ...newState[state]
        };
        return acc;
      },
      { ...currentState }
    );
    const mergedStyles = {
      ...currentStyles,
      ...baseStyles,
      ...Object.keys(mergedState).length > 0 ? { state: mergedState } : {}
    };
    styleStore.setAllStyles(mergedStyles);
    setPseudoStates(Object.keys(mergedStyles.state || {}));
    setCssErrors(errors);
  };
  const handleUndo = () => {
    if (previousStyles) {
      styleStore.setAllStyles(previousStyles);
      setPseudoStates(Object.keys(previousStyles.state || {}));
      setPreviousStyles(null);
      setCssErrors([]);
    }
  };
  const handleDismissErrors = () => {
    setCssErrors([]);
    setPreviousStyles(null);
  };
  return {
    pseudoStates,
    addSection,
    deleteSection,
    handleBulkCss,
    cssErrors,
    setCssErrors: handleDismissErrors,
    handleUndo: previousStyles ? handleUndo : void 0
  };
};

// src/components/AdvancedStyles/hooks/use-style-store-styles.ts
import { useMemo } from "react";
var useStyleStoreStyles = (styleStore, state) => {
  const getStylesForState = () => {
    const styleValues = styleStore.getStyles();
    return (state ? styleValues?.state?.[state] : styleValues) || {};
  };
  const getInitialValues = () => {
    const styles = getStylesForState();
    return Object.keys(styles).reduce((acc, key) => {
      if (key !== "state") {
        acc[camelToKebab(key)] = styles[key];
      }
      return acc;
    }, {});
  };
  const onChange = (key, value) => {
    styleStore.setStyleProp(kebabToCamel(key), value, state);
  };
  const onDelete = (key) => {
    styleStore.removeStyleProp(kebabToCamel(key), state);
  };
  const stylesForState = getStylesForState();
  const initialValues = useMemo(
    () => getInitialValues(),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [JSON.stringify(stylesForState)]
  );
  return {
    onChange,
    onDelete,
    initialValues
  };
};

// src/components/AdvancedStyles/hooks/use-theme-variant-style-store.ts
import { useMemo as useMemo2 } from "react";
import { get as get6, set, del } from "object-path-immutable";
function useThemeVariantStyleStore(componentKey, variantName) {
  const { theme, setTheme } = useThemeEditor();
  return useMemo2(() => {
    if (!componentKey || !variantName || !theme) return null;
    const stylePath = `${componentKey}.${variantName}.$style`;
    const updatePath = `content.components.${componentKey}.${variantName}.$style`;
    const id = `${componentKey}.${variantName}`;
    const getStyles = () => get6(theme.content.components, stylePath) ?? {};
    const replaceStyles = (next) => {
      setTheme(set(theme, updatePath, next));
    };
    const setStyleProp = (key, value, state) => {
      const current = getStyles();
      const updated = state ? set(current, `state.${state}.${key}`, value) : { ...current, [key]: value };
      replaceStyles(updated);
    };
    const removeStyleProp = (key, state) => {
      const current = getStyles();
      if (state) {
        replaceStyles(del(current, `state.${state}.${key}`));
        return;
      }
      const { [key]: _removed, ...rest } = current;
      replaceStyles(rest);
    };
    const setAllStyles = (styles) => {
      replaceStyles(styles);
    };
    return { id, getStyles, setStyleProp, removeStyleProp, setAllStyles };
  }, [componentKey, variantName, theme, setTheme]);
}

// src/components/AdvancedStyles/PropertyList.tsx
import { Fragment as Fragment5, jsx as jsx17, jsxs as jsxs14 } from "react/jsx-runtime";
var CssValueInput = ({
  id,
  autoFocus,
  value,
  valueTriggers,
  category,
  onChange,
  onBlur,
  onKeyDown,
  container
}) => {
  const inputRef = useRef3(null);
  const adapter = useInputAutocompleteAdapter(inputRef, onChange);
  const {
    target,
    search,
    items,
    activeIndex,
    onSelect,
    onEditorChange,
    onMenuKeyDown
  } = useAutocomplete(adapter, valueTriggers, category);
  const getAnchorRect = useCallback2(() => {
    return inputRef.current?.getBoundingClientRect() ?? null;
  }, []);
  return /* @__PURE__ */ jsxs14(Fragment5, { children: [
    /* @__PURE__ */ jsx17(
      Input5,
      {
        ref: inputRef,
        autoFocus,
        id,
        value,
        className: "px-1 py-0.5 border-0 bg-transparent [&>input]:font-mono!",
        onChange: (e) => {
          onChange(e.target.value);
          onEditorChange();
        },
        onKeyDown: (e) => {
          if (target && onMenuKeyDown(e)) return;
          if (e.key === "Enter") e.currentTarget.blur();
          onKeyDown?.(e);
        },
        onBlur,
        size: "small"
      }
    ),
    target ? /* @__PURE__ */ jsx17(
      AutocompleteMenu,
      {
        getAnchorRect,
        search,
        items,
        activeIndex,
        onSelect,
        container: container ?? void 0
      }
    ) : null
  ] });
};
var PropertyList = ({
  state,
  styleStore,
  sectionConfig,
  defaultStyles,
  onDeleteSection,
  portal,
  track,
  valueTriggers
}) => {
  const { allowedProperties, uiProperties, denylistProperties } = sectionConfig;
  const { onChange, onDelete, initialValues } = useStyleStoreStyles(
    styleStore,
    state
  );
  const [editingValues, setEditingValues] = useState10(initialValues);
  const [isAdding, setIsAdding] = useState10(false);
  useEffect5(() => {
    setEditingValues(initialValues);
  }, [initialValues]);
  const propertyList = Object.keys(editingValues).filter(
    (prop) => !denylistProperties.has(prop)
  );
  const allowedPropertyNames = Object.keys(allowedProperties).sort();
  const availablePropertiesToAdd = allowedPropertyNames.filter(
    (prop) => !propertyList.includes(prop) && !denylistProperties.has(prop)
  );
  const handleChange = (property, value) => {
    setEditingValues((prev) => ({ ...prev, [property]: value }));
  };
  const handleBlur = (property, value) => {
    const finalValue = value ?? editingValues[property];
    const section = state || "base";
    if (finalValue !== initialValues[property]) {
      onChange(property, finalValue);
      track("CSS: Value Changed", `${section}::${property}:${finalValue}`);
    }
  };
  const handleDelete = (property) => {
    const valueBeingDeleted = editingValues[property] ?? "";
    const section = state || "base";
    onDelete(property);
    setEditingValues((prev) => {
      const newValues = { ...prev };
      delete newValues[property];
      return newValues;
    });
    track(
      "CSS: Property Removed",
      `${section}::${property}:${valueBeingDeleted}`
    );
  };
  const handleReset = (property) => {
    const defaultValue = defaultStyles?.[property];
    const section = state || "base";
    if (defaultValue !== void 0) {
      onChange(property, defaultValue);
      setEditingValues((prev) => ({ ...prev, [property]: defaultValue }));
      track("CSS: Property Reset", `${section}::${property}`);
    }
  };
  const handlePropertySelect = (property) => {
    const section = state || "base";
    setEditingValues((prev) => ({ ...prev, [property]: "" }));
    setIsAdding(false);
    track("CSS: Property Added", `${section}::${property}`);
  };
  const handleDeleteSection = () => {
    if (state && onDeleteSection) {
      onDeleteSection(state);
      track("CSS: Section Removed", state);
    }
  };
  return /* @__PURE__ */ jsxs14("div", { className: "flex flex-col bg-neutral-1 border border-neutral-1 rounded-md p-2 font-mono", children: [
    propertyList.map((property) => {
      const constraints = allowedProperties[property] || "*";
      const isConstrainedProp = Array.isArray(constraints);
      const isUiProperty = uiProperties.has(property);
      const propertyValue = String(editingValues[property] ?? "");
      const shouldWrap = !isConstrainedProp && (propertyValue.length > 20 || propertyValue.startsWith("{")) || property.length > 20;
      const isNewlyAdded = !initialValues[property];
      const defaultValue = defaultStyles?.[property];
      const hasDefault = defaultValue !== void 0;
      const matchesDefault = hasDefault && propertyValue === defaultValue;
      const showResetButton = hasDefault && !matchesDefault;
      const showDeleteButton = !hasDefault;
      return /* @__PURE__ */ jsxs14(
        "div",
        {
          className: "group flex items-center gap-2 transition-colors",
          children: [
            /* @__PURE__ */ jsxs14(
              "div",
              {
                className: cn7(
                  "flex flex-1 min-w-0",
                  shouldWrap ? "flex-col items-start gap-0" : "flex-row items-center gap-1"
                ),
                children: [
                  /* @__PURE__ */ jsxs14(
                    "div",
                    {
                      className: cn7(
                        "whitespace-nowrap min-w-fit font-mono",
                        isUiProperty ? "text-highlight-3" : void 0
                      ),
                      children: [
                        property,
                        ":"
                      ]
                    }
                  ),
                  /* @__PURE__ */ jsx17("div", { className: "flex-1 self-stretch", children: isConstrainedProp ? /* @__PURE__ */ jsxs14(
                    Select3,
                    {
                      defaultOpen: isNewlyAdded,
                      value: propertyValue,
                      onValueChange: (val) => {
                        handleChange(property, val);
                        handleBlur(property, val);
                      },
                      children: [
                        /* @__PURE__ */ jsx17(
                          SelectTrigger3,
                          {
                            size: "small",
                            className: "px-1 py-0.5 border-0 bg-transparent font-mono! font-semibold",
                            "aria-label": `${property} value`,
                            children: /* @__PURE__ */ jsx17(SelectValue3, { placeholder: "Choose value..." })
                          }
                        ),
                        /* @__PURE__ */ jsx17(SelectContent3, { children: constraints.map((val) => /* @__PURE__ */ jsx17(SelectItem3, { value: val, children: val }, val)) })
                      ]
                    }
                  ) : valueTriggers ? /* @__PURE__ */ jsx17(
                    CssValueInput,
                    {
                      autoFocus: isNewlyAdded,
                      id: `${state || "base"}-${property}`,
                      value: propertyValue,
                      valueTriggers,
                      category: property,
                      onChange: (val) => handleChange(property, val),
                      onBlur: () => handleBlur(property),
                      container: portal
                    }
                  ) : /* @__PURE__ */ jsx17(
                    Input5,
                    {
                      autoFocus: isNewlyAdded,
                      id: `${state || "base"}-${property}`,
                      value: propertyValue,
                      className: "px-1 py-0.5 border-0 bg-transparent [&>input]:font-mono!",
                      onChange: (e) => handleChange(property, e.target.value),
                      onKeyDown: (e) => {
                        if (e.key === "Enter") e.currentTarget.blur();
                      },
                      onBlur: () => handleBlur(property),
                      size: "small"
                    }
                  ) })
                ]
              }
            ),
            showResetButton && /* @__PURE__ */ jsx17(
              Button3,
              {
                modifier: "icon",
                size: "small",
                className: "hidden group-hover:flex",
                onClick: () => handleReset(property),
                "aria-label": `Reset ${property} to default`,
                "data-reset-button": true,
                children: /* @__PURE__ */ jsx17(FontAwesomeIcon, { icon: faRotateLeft })
              }
            ),
            showDeleteButton && /* @__PURE__ */ jsx17(
              Button3,
              {
                modifier: "icon",
                size: "small",
                className: "hidden group-hover:flex",
                onClick: () => handleDelete(property),
                "aria-label": `Delete ${property}`,
                "data-delete-button": true,
                children: /* @__PURE__ */ jsx17(FontAwesomeIcon, { icon: faTrash })
              }
            )
          ]
        },
        property
      );
    }),
    isAdding && /* @__PURE__ */ jsxs14("div", { className: "flex items-center gap-2", children: [
      /* @__PURE__ */ jsx17("div", { className: "flex flex-1 min-w-0 flex-row items-center gap-1", children: /* @__PURE__ */ jsxs14(
        ComboBox,
        {
          value: void 0,
          onValueChange: handlePropertySelect,
          defaultOpen: true,
          children: [
            /* @__PURE__ */ jsx17(ComboBoxTrigger, { size: "small", "aria-label": "Choose CSS property", children: /* @__PURE__ */ jsx17(ComboBoxValue, { placeholder: "Select property..." }) }),
            /* @__PURE__ */ jsxs14(ComboBoxContent, { container: portal ?? void 0, children: [
              /* @__PURE__ */ jsx17(ComboBoxInput, { placeholder: "Search properties..." }),
              /* @__PURE__ */ jsxs14(ComboBoxList, { children: [
                /* @__PURE__ */ jsx17(ComboBoxEmpty, { children: "No properties found." }),
                /* @__PURE__ */ jsx17(ComboBoxGroup, { children: availablePropertiesToAdd.map((prop) => /* @__PURE__ */ jsx17(ComboBoxItem, { value: prop, children: prop }, prop)) })
              ] })
            ] })
          ]
        }
      ) }),
      /* @__PURE__ */ jsx17(
        Button3,
        {
          modifier: "icon",
          size: "small",
          onClick: () => setIsAdding(false),
          "aria-label": "Cancel add",
          children: /* @__PURE__ */ jsx17(FontAwesomeIcon, { icon: faTrash })
        }
      )
    ] }),
    !isAdding && /* @__PURE__ */ jsxs14("div", { className: "flex items-center justify-between gap-2", children: [
      /* @__PURE__ */ jsxs14(
        Button3,
        {
          variant: "outline",
          size: "small",
          onClick: () => setIsAdding(true),
          disabled: availablePropertiesToAdd.length === 0,
          children: [
            /* @__PURE__ */ jsx17(FontAwesomeIcon, { icon: faPlus2 }),
            "Add"
          ]
        }
      ),
      propertyList.length === 0 && state && /* @__PURE__ */ jsx17(
        Button3,
        {
          modifier: "icon",
          size: "small",
          onClick: handleDeleteSection,
          "aria-label": "Delete section",
          children: /* @__PURE__ */ jsx17(FontAwesomeIcon, { icon: faTrash })
        }
      )
    ] })
  ] });
};

// src/components/AdvancedStyles/PasteStyles.tsx
import { useState as useState11, useEffect as useEffect6, useRef as useRef4 } from "react";
import { faCircleExclamation as faCircleExclamation2 } from "@fortawesome/pro-regular-svg-icons/faCircleExclamation";
import { faXmark } from "@fortawesome/pro-regular-svg-icons/faXmark";
import { faRotateLeft as faRotateLeft2 } from "@fortawesome/pro-regular-svg-icons/faRotateLeft";
import { faCircleInfo } from "@fortawesome/pro-regular-svg-icons/faCircleInfo";
import { Icon as Icon4, Button as Button4, Alert as Alert2, AlertDescription as AlertDescription2 } from "@appcues/sonar-builder";
import { jsx as jsx18, jsxs as jsxs15 } from "react/jsx-runtime";
var PasteStyles = ({
  errors,
  onBulkCss,
  onDismiss,
  onUndo,
  track
}) => {
  const [isFocused, setIsFocused] = useState11(false);
  const justPasted = useRef4(false);
  useEffect6(() => {
    if (justPasted.current) {
      if (errors.length > 0) {
        const failedProperties = errors.map((error) => error.property).filter(Boolean).join(",");
        track("CSS: Paste with Error", failedProperties);
      } else {
        track("CSS: Paste Succeeded");
      }
      justPasted.current = false;
    }
  }, [errors, track]);
  const handlePaste = (event) => {
    const target = event.target;
    if (target.tagName === "INPUT") {
      return;
    }
    event.preventDefault();
    const clipboardText = event.clipboardData.getData("text/plain");
    justPasted.current = true;
    onBulkCss(clipboardText);
  };
  if (errors.length === 0) {
    return /* @__PURE__ */ jsxs15(
      Alert2,
      {
        variant: "info",
        onPaste: handlePaste,
        tabIndex: 0,
        onFocus: () => setIsFocused(true),
        onBlur: () => setIsFocused(false),
        children: [
          /* @__PURE__ */ jsx18(Icon4, { icon: faCircleInfo, size: "small" }),
          /* @__PURE__ */ jsx18(AlertDescription2, { children: /* @__PURE__ */ jsx18("p", { children: isFocused ? "Press Ctrl+V or Cmd+V to paste CSS." : "Click here to paste CSS to quickly add styles." }) })
        ]
      }
    );
  }
  const propertyErrorCount = errors.filter(
    (error) => error.type !== "other"
  ).length;
  return /* @__PURE__ */ jsxs15(Alert2, { variant: "warning", children: [
    /* @__PURE__ */ jsx18(Icon4, { icon: faCircleExclamation2, size: "small" }),
    /* @__PURE__ */ jsxs15(AlertDescription2, { children: [
      propertyErrorCount > 0 && /* @__PURE__ */ jsxs15("p", { children: [
        propertyErrorCount,
        " ",
        propertyErrorCount === 1 ? "property was" : "properties were",
        " not added:"
      ] }),
      /* @__PURE__ */ jsx18("ul", { className: "mt-1 pl-4 list-disc", children: errors.map((error) => /* @__PURE__ */ jsx18("li", { children: error.message }, `${error.property}-${error.type}`)) })
    ] }),
    /* @__PURE__ */ jsxs15("div", { className: "absolute top-1 right-1 flex gap-1", children: [
      onUndo && /* @__PURE__ */ jsx18(
        Button4,
        {
          modifier: "icon",
          size: "small",
          onClick: onUndo,
          "aria-label": "Undo paste",
          children: /* @__PURE__ */ jsx18(Icon4, { icon: faRotateLeft2, size: "small" })
        }
      ),
      /* @__PURE__ */ jsx18(
        Button4,
        {
          modifier: "icon",
          size: "small",
          onClick: onDismiss,
          "aria-label": "Dismiss errors",
          children: /* @__PURE__ */ jsx18(Icon4, { icon: faXmark, size: "small" })
        }
      )
    ] })
  ] });
};

// src/components/AdvancedStyles/CopyStyles.tsx
import { useState as useState12 } from "react";
import { Button as Button5 } from "@appcues/sonar-builder";
import { faCopy } from "@fortawesome/pro-regular-svg-icons/faCopy";
import { jsx as jsx19, jsxs as jsxs16 } from "react/jsx-runtime";
var stylesToCssText = (styles) => {
  const baseStyles = Object.entries(styles).filter(([key]) => key !== "state");
  const lines = baseStyles.map(
    ([key, value]) => `${camelToKebab(key)}: ${value};`
  );
  if (styles.state) {
    const stateLines = Object.entries(styles.state).flatMap(
      ([stateName, stateStyles]) => {
        const statePropertyLines = Object.entries(stateStyles).map(
          ([key, value]) => `  ${camelToKebab(key)}: ${value};`
        );
        return [`:${stateName} {`, ...statePropertyLines, "}"];
      }
    );
    lines.push(...stateLines);
  }
  return lines.join("\n");
};
var CopyStyles = ({
  styleStore,
  track
}) => {
  const [copyFeedback, setCopyFeedback] = useState12(false);
  const handleCopyStyles = async () => {
    const blockStyles = styleStore.getStyles();
    if (!blockStyles || Object.keys(blockStyles).length === 0) return;
    const cssText = stylesToCssText(blockStyles);
    await navigator.clipboard.writeText(cssText);
    setCopyFeedback(true);
    setTimeout(() => setCopyFeedback(false), 2e3);
    track("CSS: Copied");
  };
  return /* @__PURE__ */ jsxs16(Button5, { variant: "outline", size: "small", fullWidth: true, onClick: handleCopyStyles, children: [
    /* @__PURE__ */ jsx19(FontAwesomeIcon, { icon: faCopy }),
    copyFeedback ? "Copied!" : "Copy CSS"
  ] });
};

// src/components/AdvancedStyles/AdvancedStyles.tsx
import { jsx as jsx20, jsxs as jsxs17 } from "react/jsx-runtime";
var resolveSectionConfig = (elementConfig, state) => {
  const isPseudoElement = state?.includes("before") || state?.includes("after");
  const stateOverrides = state ? elementConfig.states?.[state] : void 0;
  return {
    allowedProperties: stateOverrides?.allowedProperties ?? (isPseudoElement ? PSEUDO_ELEMENT_PROPERTIES : elementConfig.allowedProperties),
    uiProperties: stateOverrides?.uiProperties ?? (isPseudoElement ? /* @__PURE__ */ new Set() : elementConfig.uiProperties),
    denylistProperties: stateOverrides?.denylistProperties ?? (isPseudoElement ? /* @__PURE__ */ new Set() : elementConfig.denylistProperties)
  };
};
var resolveDefaultStyles = (elementConfig, state) => {
  const { defaultStyles } = elementConfig;
  if (!defaultStyles) return void 0;
  if (state) {
    return defaultStyles.state?.[state];
  }
  return Object.fromEntries(
    Object.entries(defaultStyles).filter(([key]) => key !== "state")
  );
};
var noop = () => {
};
function AdvancedStyles({
  elements,
  portal,
  track = noop,
  valueTriggers
}) {
  const elementKeys = Object.keys(elements);
  const [selectedElement, setSelectedElement] = useState13(elementKeys[0]);
  const hasMultipleElements = elementKeys.length > 1;
  const activeElement = elementKeys.includes(selectedElement) ? selectedElement : elementKeys[0];
  const elementConfig = elements[activeElement];
  const handleElementChange = (newElement) => {
    setSelectedElement(newElement);
    track("CSS: Element Switched", elements[newElement].label);
  };
  const {
    pseudoStates,
    addSection,
    deleteSection,
    handleBulkCss,
    cssErrors,
    setCssErrors,
    handleUndo
  } = useSectionManager(elementConfig);
  return /* @__PURE__ */ jsxs17(Flex4, { direction: "column", gap: "sm", children: [
    hasMultipleElements && /* @__PURE__ */ jsx20(FormRow2, { children: /* @__PURE__ */ jsxs17(Select4, { value: activeElement, onValueChange: handleElementChange, children: [
      /* @__PURE__ */ jsx20(SelectTrigger4, { size: "small", "aria-label": "Choose element", children: /* @__PURE__ */ jsx20(SelectValue4, { placeholder: "Choose element" }) }),
      /* @__PURE__ */ jsx20(SelectContent4, { children: elementKeys.map((key) => /* @__PURE__ */ jsx20(SelectItem4, { value: key, children: elements[key].label }, key)) })
    ] }) }),
    /* @__PURE__ */ jsx20(
      PasteStyles,
      {
        errors: cssErrors,
        onBulkCss: handleBulkCss,
        onDismiss: setCssErrors,
        onUndo: handleUndo,
        track
      }
    ),
    /* @__PURE__ */ jsxs17(Accordion2, { type: "multiple", defaultValue: ["base"], children: [
      /* @__PURE__ */ jsxs17(AccordionItem4, { value: "base", children: [
        /* @__PURE__ */ jsxs17(AccordionTrigger4, { children: [
          elementConfig.label,
          " Styles"
        ] }),
        /* @__PURE__ */ jsx20(AccordionContent4, { children: /* @__PURE__ */ jsx20(
          PropertyList,
          {
            styleStore: elementConfig.styleStore,
            sectionConfig: resolveSectionConfig(elementConfig),
            defaultStyles: resolveDefaultStyles(elementConfig),
            onDeleteSection: deleteSection,
            portal,
            track,
            valueTriggers
          }
        ) })
      ] }),
      pseudoStates.map((state) => /* @__PURE__ */ jsxs17(AccordionItem4, { value: state, children: [
        /* @__PURE__ */ jsxs17(AccordionTrigger4, { children: [
          ":",
          state,
          " Styles"
        ] }),
        /* @__PURE__ */ jsx20(AccordionContent4, { children: /* @__PURE__ */ jsx20(
          PropertyList,
          {
            state,
            styleStore: elementConfig.styleStore,
            sectionConfig: resolveSectionConfig(elementConfig, state),
            defaultStyles: resolveDefaultStyles(elementConfig, state),
            onDeleteSection: deleteSection,
            portal,
            track,
            valueTriggers
          }
        ) })
      ] }, state))
    ] }),
    /* @__PURE__ */ jsx20(
      AddSectionForm,
      {
        pseudoStates,
        onAddSection: addSection,
        elementConfig,
        track
      }
    ),
    /* @__PURE__ */ jsx20(CopyStyles, { styleStore: elementConfig.styleStore, track })
  ] });
}
var AdvancedStyles_default = AdvancedStyles;

// src/components/AdvancedStyles/block-configs.ts
var BUTTON_CONFIG = {
  label: "Button",
  pseudoClasses: ["hover", "active", "focus"],
  pseudoElements: ["before", "after"],
  allowedProperties: {
    ...COMMON_CSS_PROPERTIES,
    "white-space": ["normal", "nowrap"]
  },
  uiProperties: /* @__PURE__ */ new Set([
    "background-color",
    "border-color",
    "border-radius",
    "border-style",
    "border-width",
    "color",
    "font-size",
    "text-align",
    "text-decoration",
    "font-weight",
    "font-style",
    "font-family",
    "margin-top",
    "margin-bottom",
    "margin-inline-start",
    "margin-inline-end",
    "padding-top",
    "padding-bottom",
    "padding-inline-start",
    "padding-inline-end"
  ]),
  denylistProperties: /* @__PURE__ */ new Set([
    "border",
    "display",
    "justify-self",
    "flex-grow"
  ]),
  states: {
    hover: {
      uiProperties: /* @__PURE__ */ new Set(["background-color"])
    }
  }
};
var IMAGE_CONFIG = {
  label: "Image",
  pseudoClasses: [],
  pseudoElements: [],
  allowedProperties: {
    ...APPEARANCE_CSS_PROPERTIES,
    ...STRUCTURAL_CSS_PROPERTIES
  },
  uiProperties: /* @__PURE__ */ new Set([
    "border-color",
    "border-style",
    "border-width",
    "border-radius"
  ]),
  denylistProperties: /* @__PURE__ */ new Set(["pointer-events", "z-index", "box-sizing"])
};
var CELL_CONFIG = {
  label: "Cell",
  pseudoClasses: ["hover"],
  pseudoElements: ["before", "after"],
  allowedProperties: {
    ...APPEARANCE_CSS_PROPERTIES,
    ...STRUCTURAL_CSS_PROPERTIES
  },
  uiProperties: /* @__PURE__ */ new Set([
    "background-color",
    "border-radius",
    "border-color",
    "border-style",
    "border-width",
    "padding-top",
    "padding-bottom",
    "padding-inline-start",
    "padding-inline-end",
    "margin-top",
    "margin-bottom",
    "margin-inline-start",
    "margin-inline-end"
  ]),
  denylistProperties: /* @__PURE__ */ new Set([
    "display",
    "flex",
    "flex-direction",
    "flex-grow",
    "flex-shrink",
    "flex-basis",
    "justify-content",
    "align-items",
    "position",
    "top",
    "bottom",
    "left",
    "right",
    "box-sizing",
    "width",
    "height",
    "min-width",
    "min-height",
    "max-width",
    "max-height"
  ])
};
var STEP_CONFIG = {
  label: "Step",
  pseudoClasses: ["hover"],
  pseudoElements: ["before", "after"],
  allowedProperties: {
    ...APPEARANCE_CSS_PROPERTIES,
    ...STRUCTURAL_CSS_PROPERTIES
  },
  uiProperties: /* @__PURE__ */ new Set([
    "background-color",
    "border-radius",
    // `min-height` is the responsive Settings "Min height" control; `height` is
    // no longer a Design-tab control (escape-hatch only) so it's not listed here.
    "min-height",
    "width",
    "margin-top",
    "margin-bottom",
    "margin-inline-start",
    "margin-inline-end",
    "padding-top",
    "padding-bottom",
    "padding-inline-start",
    "padding-inline-end"
  ]),
  denylistProperties: /* @__PURE__ */ new Set([
    "border",
    "bottom",
    "left",
    "max-height",
    "max-width",
    "min-width",
    "position",
    "right",
    "top",
    "transform",
    // The step root is laid out as a flex column to fill its min-height floor;
    // `display`/`flex-direction` are structural, not user-editable (SC-89301).
    "display",
    "flex-direction"
  ])
};
var EMBED_CONFIG = {
  ...STEP_CONFIG,
  denylistProperties: /* @__PURE__ */ new Set([
    ...STEP_CONFIG.denylistProperties,
    "flex",
    "box-sizing",
    "width"
  ])
};
var CLOSE_X_CONFIG = {
  label: "Close button",
  pseudoClasses: ["hover", "active", "focus"],
  pseudoElements: ["before", "after"],
  allowedProperties: {
    ...APPEARANCE_CSS_PROPERTIES,
    ...TEXT_CSS_PROPERTIES,
    ...STRUCTURAL_CSS_PROPERTIES
  },
  uiProperties: /* @__PURE__ */ new Set([
    "background-color",
    "border-radius",
    "color",
    "margin-top",
    "margin-bottom",
    "margin-inline-start",
    "margin-inline-end",
    "padding-top",
    "padding-bottom",
    "padding-inline-start",
    "padding-inline-end"
  ]),
  states: {
    hover: {
      uiProperties: /* @__PURE__ */ new Set(["color"])
    }
  },
  denylistProperties: /* @__PURE__ */ new Set([
    "position",
    "top",
    "right",
    "bottom",
    "left",
    "inset",
    "inset-inline-start",
    "inset-inline-end",
    "inset-block-start",
    "inset-block-end",
    "z-index",
    "box-sizing",
    "display",
    "align-items",
    "justify-content",
    "align-self",
    "width",
    "height"
  ])
};
var IFRAME_CONFIG = {
  label: "IFrame",
  pseudoClasses: ["hover", "focus"],
  pseudoElements: ["before", "after"],
  allowedProperties: {
    ...APPEARANCE_CSS_PROPERTIES,
    ...STRUCTURAL_CSS_PROPERTIES
  },
  uiProperties: /* @__PURE__ */ new Set([
    "border-color",
    "border-style",
    "border-width",
    "border-radius"
  ]),
  denylistProperties: /* @__PURE__ */ new Set([
    "display",
    "pointer-events",
    "z-index",
    "box-sizing"
  ])
};
var TEXT_CONFIG = {
  label: "Text",
  pseudoClasses: ["hover", "focus"],
  pseudoElements: ["before", "after"],
  allowedProperties: {
    ...TEXT_CSS_PROPERTIES,
    opacity: "*",
    "text-shadow": "*",
    "margin-top": "*",
    "margin-bottom": "*",
    "margin-inline-start": "*",
    "margin-inline-end": "*"
  },
  uiProperties: /* @__PURE__ */ new Set([
    "color",
    "font-family",
    "font-size",
    "font-weight",
    "font-style",
    "text-align",
    "text-decoration",
    "line-height",
    "letter-spacing"
  ]),
  denylistProperties: /* @__PURE__ */ new Set([
    "display",
    "position",
    "width",
    "height",
    "min-width",
    "min-height",
    "max-width",
    "max-height",
    "box-sizing",
    "pointer-events"
  ])
};
var WEB_COMPONENT_STYLE_CONFIGS = {
  "web.h1": TEXT_CONFIG,
  "web.h2": TEXT_CONFIG,
  "web.h3": TEXT_CONFIG,
  "web.h4": TEXT_CONFIG,
  "web.h5": TEXT_CONFIG,
  "web.p": TEXT_CONFIG,
  "web.button": BUTTON_CONFIG,
  "web.img": IMAGE_CONFIG,
  "web.close-x": CLOSE_X_CONFIG,
  "web.cell": CELL_CONFIG,
  "web.modal": STEP_CONFIG,
  "web.tooltip": STEP_CONFIG,
  "web.embed": EMBED_CONFIG
};

// src/lib/get-token-paths.ts
function walkTokens(tokens, prefix, inheritedType, out) {
  const localType = typeof tokens.$type === "string" ? tokens.$type : inheritedType;
  for (const [key, node] of Object.entries(tokens).filter(
    ([k]) => !k.startsWith("$")
  )) {
    const path = prefix ? `${prefix}.${key}` : key;
    if (node !== null && typeof node === "object") {
      const obj = node;
      if ("$value" in obj) {
        const leafType = typeof obj.$type === "string" ? obj.$type : localType;
        out.push({ path: `{${path}}`, value: obj.$value, type: leafType });
      } else {
        walkTokens(obj, path, localType, out);
      }
    }
  }
}
function getTokenEntries(tokens) {
  const out = [];
  walkTokens(tokens, "", void 0, out);
  return out;
}

// src/components/VariantEditor/VariantCard.tsx
import { cn as cn8 } from "@appcues/sonar-builder";
import { Fragment as Fragment6, jsx as jsx21, jsxs as jsxs18 } from "react/jsx-runtime";
var VariantCard = ({
  label,
  componentKey,
  variantName,
  platform,
  theme,
  selected = false,
  onSelect
}) => {
  const component = makeComponentVariantPreview(
    theme,
    platform,
    componentKey,
    variantName
  );
  const cardClassName = cn8(
    "flex flex-col rounded-md p-3 gap-2 text-left w-full border-0",
    selected ? "bg-highlight-3" : "bg-highlight-4",
    onSelect ? "cursor-pointer" : void 0
  );
  const content = /* @__PURE__ */ jsxs18(Fragment6, { children: [
    /* @__PURE__ */ jsx21(
      "span",
      {
        className: cn8(
          "text-sm font-bold",
          selected ? "text-highlight-1" : "text-neutral-1"
        ),
        children: label
      }
    ),
    component ? /* @__PURE__ */ jsx21(
      "div",
      {
        className: cn8(
          "h-[150px] relative overflow-hidden rounded-md",
          selected ? "bg-neutral-0" : "bg-highlight-4 pointer-events-none"
        ),
        children: /* @__PURE__ */ jsx21(
          PreviewFrame,
          {
            theme,
            platform,
            component,
            colorMode: "light"
          }
        )
      }
    ) : /* @__PURE__ */ jsx21("div", { className: "h-[150px] flex items-center justify-center text-sm text-neutral-3 bg-neutral-0 rounded-md", children: "No preview" })
  ] });
  if (onSelect) {
    return /* @__PURE__ */ jsx21("button", { type: "button", onClick: onSelect, className: cardClassName, children: content });
  }
  return /* @__PURE__ */ jsx21("div", { className: cardClassName, children: content });
};

// src/components/VariantEditor/AddVariantBar.tsx
import { useRef as useRef5, useState as useState14 } from "react";
import { get as get7 } from "object-path-immutable";
import camelCase2 from "lodash.camelcase";
import { faPlus as faPlus3 } from "@fortawesome/pro-regular-svg-icons/faPlus";
import { faCheck } from "@fortawesome/pro-regular-svg-icons/faCheck";
import { faXmark as faXmark2 } from "@fortawesome/pro-regular-svg-icons/faXmark";
import {
  Button as Button6,
  Icon as Icon5,
  Input as Input6,
  Select as Select5,
  SelectTrigger as SelectTrigger5,
  SelectValue as SelectValue5,
  SelectContent as SelectContent5,
  SelectItem as SelectItem5
} from "@appcues/sonar-builder";
import { jsx as jsx22, jsxs as jsxs19 } from "react/jsx-runtime";
var AddVariantBar = ({
  keys,
  components,
  onCreated
}) => {
  const { updateTheme } = useThemeEditor();
  const [isAdding, setIsAdding] = useState14(false);
  const [name, setName] = useState14("");
  const [selectedKey, setSelectedKey] = useState14(keys[0]);
  const inputRef = useRef5(null);
  const multiKey = keys.length > 1;
  const existingVariants = Object.keys(
    get7(components, selectedKey) ?? {}
  );
  const sanitizedKey = camelCase2(name.trim());
  const isDuplicate = !!sanitizedKey && existingVariants.includes(sanitizedKey);
  const canSave = !!sanitizedKey && !isDuplicate;
  const handleOpen = () => {
    setIsAdding(true);
    setName("");
    setSelectedKey(keys[0]);
    setTimeout(() => inputRef.current?.focus(), 0);
  };
  const handleCancel = () => {
    setIsAdding(false);
    setName("");
  };
  const handleSave = () => {
    if (!canSave) return;
    const defaultData = get7(components, `${selectedKey}.default`) ?? get7(
      components,
      `${selectedKey}.${existingVariants[0]}`
    ) ?? {};
    updateTheme(
      `content.components.${selectedKey}.${sanitizedKey}`,
      defaultData
    );
    onCreated(selectedKey, sanitizedKey);
    setIsAdding(false);
    setName("");
  };
  const handleKeyDown = (e) => {
    if (e.key === "Enter") handleSave();
    if (e.key === "Escape") handleCancel();
  };
  if (isAdding) {
    return /* @__PURE__ */ jsxs19("div", { className: "flex flex-col border-t border-neutral-2 shrink-0", children: [
      /* @__PURE__ */ jsxs19("div", { className: "flex items-center gap-1.5 px-2 py-2", children: [
        multiKey ? /* @__PURE__ */ jsxs19(Select5, { value: selectedKey, onValueChange: setSelectedKey, children: [
          /* @__PURE__ */ jsx22(SelectTrigger5, { size: "small", className: "w-20 shrink-0", children: /* @__PURE__ */ jsx22(SelectValue5, {}) }),
          /* @__PURE__ */ jsx22(SelectContent5, { children: keys.map((k) => /* @__PURE__ */ jsx22(SelectItem5, { value: k, children: k.split(".").at(-1) }, k)) })
        ] }) : null,
        /* @__PURE__ */ jsx22(
          Input6,
          {
            ref: inputRef,
            value: name,
            onChange: (e) => setName(e.target.value),
            onKeyDown: handleKeyDown,
            placeholder: "Variant name",
            size: "small",
            className: "flex-1"
          }
        ),
        /* @__PURE__ */ jsx22(
          Button6,
          {
            type: "button",
            variant: "ghost",
            size: "small",
            modifier: "icon",
            onClick: handleSave,
            disabled: !canSave,
            "aria-label": "Save variant",
            children: /* @__PURE__ */ jsx22(Icon5, { icon: faCheck })
          }
        ),
        /* @__PURE__ */ jsx22(
          Button6,
          {
            type: "button",
            variant: "ghost",
            size: "small",
            modifier: "icon",
            onClick: handleCancel,
            "aria-label": "Cancel",
            children: /* @__PURE__ */ jsx22(Icon5, { icon: faXmark2 })
          }
        )
      ] }),
      isDuplicate ? /* @__PURE__ */ jsxs19("p", { className: "px-2 pb-2 text-xs text-red-500", children: [
        "\u201C",
        sanitizedKey,
        "\u201D already exists."
      ] }) : null
    ] });
  }
  return /* @__PURE__ */ jsx22("div", { className: "flex items-center justify-end px-2 py-1.5 border-t border-neutral-2 shrink-0", children: /* @__PURE__ */ jsx22(
    Button6,
    {
      type: "button",
      variant: "ghost",
      size: "small",
      modifier: "icon",
      onClick: handleOpen,
      "aria-label": "Add variant",
      children: /* @__PURE__ */ jsx22(Icon5, { icon: faPlus3 })
    }
  ) });
};

// src/components/VariantEditor/VariantEditor.tsx
import { jsx as jsx23, jsxs as jsxs20 } from "react/jsx-runtime";
var CSS_PROPERTY_CATEGORY = {
  color: "color",
  "background-color": "color",
  "border-color": "color",
  "outline-color": "color",
  "text-decoration-color": "color",
  "font-size": "dimension",
  margin: "dimension",
  "margin-top": "dimension",
  "margin-right": "dimension",
  "margin-bottom": "dimension",
  "margin-left": "dimension",
  "margin-inline-start": "dimension",
  "margin-inline-end": "dimension",
  padding: "dimension",
  "padding-top": "dimension",
  "padding-right": "dimension",
  "padding-bottom": "dimension",
  "padding-left": "dimension",
  "padding-inline-start": "dimension",
  "padding-inline-end": "dimension",
  "border-radius": "dimension",
  "border-width": "dimension",
  "letter-spacing": "dimension",
  "line-height": "dimension",
  gap: "dimension",
  width: "dimension",
  height: "dimension"
};
var EditorPanel = ({
  selectedVariant,
  portal,
  tokens,
  darkMode
}) => {
  const styleStore = useThemeVariantStyleStore(
    selectedVariant.key,
    selectedVariant.variantName
  );
  const config = WEB_COMPONENT_STYLE_CONFIGS[selectedVariant.key];
  const tokenEntries = useMemo3(
    () => getTokenEntries(tokens).filter(
      (e) => darkMode || !e.path.startsWith("{colors.dark.")
    ),
    [tokens, darkMode]
  );
  const valueTriggers = useMemo3(
    () => [
      {
        pattern: /\{([\w.-]*)$/,
        guard: /^[\w.-]|^[^{]*\}/,
        getItems: (search, category) => {
          const tokenType = category ? CSS_PROPERTY_CATEGORY[category] : void 0;
          const lower = search.toLowerCase();
          return tokenEntries.filter((e) => !tokenType || e.type === tokenType).filter((e) => e.path.toLowerCase().includes(lower)).map((e) => ({
            key: e.path,
            label: e.path,
            value: e.path,
            prefix: e.type === "color" && typeof e.value === "string" ? /* @__PURE__ */ jsx23(
              "span",
              {
                style: {
                  backgroundColor: e.value,
                  border: "1px solid rgba(0,0,0,0.15)"
                },
                className: "inline-block w-3.5 h-3.5 rounded-sm shrink-0"
              }
            ) : typeof e.value === "string" && e.value.endsWith("px") ? /* @__PURE__ */ jsx23("span", { className: "tabular-nums min-w-[2rem] font-mono", children: e.value }) : void 0
          }));
        }
      }
    ],
    [tokenEntries]
  );
  if (!config || !styleStore) {
    return /* @__PURE__ */ jsx23("div", { className: "flex items-center justify-center h-full text-sm text-neutral-3 p-4 text-center", children: "No CSS editor available for this component type." });
  }
  const elementKey = selectedVariant.key.split(".").at(-1) ?? selectedVariant.key;
  const elements = {
    [elementKey]: { ...config, styleStore, uiProperties: /* @__PURE__ */ new Set() }
  };
  return /* @__PURE__ */ jsx23("div", { className: "overflow-y-auto h-full p-3", children: /* @__PURE__ */ jsx23(
    AdvancedStyles_default,
    {
      elements,
      portal,
      valueTriggers
    }
  ) });
};
var VariantEditor = ({
  selectedDef,
  components,
  platform,
  theme
}) => {
  const portal = useModalPortal2();
  const variants = selectedDef ? getVariants(components, selectedDef.keys) : [];
  const multiKey = (selectedDef?.keys.length ?? 0) > 1;
  const [selectedVariant, setSelectedVariant] = useState15(variants[0] ?? null);
  return /* @__PURE__ */ jsxs20("div", { className: "flex flex-1 border border-neutral-2 rounded-sm overflow-hidden", children: [
    /* @__PURE__ */ jsxs20("div", { className: "flex flex-col w-[340px] shrink-0 border-r border-neutral-2", children: [
      /* @__PURE__ */ jsx23("div", { className: "overflow-y-auto flex-1", children: /* @__PURE__ */ jsx23("div", { className: "p-3 flex flex-col gap-3", children: variants.map(({ key, variantName }) => {
        const cardLabel = multiKey ? `${key.split(".").at(-1)} / ${variantName}` : variantName;
        const isSelected = selectedVariant?.key === key && selectedVariant?.variantName === variantName;
        return /* @__PURE__ */ jsx23(
          VariantCard,
          {
            label: cardLabel,
            componentKey: key,
            variantName,
            platform,
            theme,
            selected: isSelected,
            onSelect: () => setSelectedVariant({ key, variantName })
          },
          `${key}.${variantName}`
        );
      }) }) }),
      selectedDef ? /* @__PURE__ */ jsx23(
        AddVariantBar,
        {
          keys: selectedDef.keys,
          components,
          onCreated: (key, variantName) => setSelectedVariant({ key, variantName })
        }
      ) : null
    ] }),
    /* @__PURE__ */ jsxs20("div", { className: "flex flex-col flex-1 overflow-hidden", children: [
      /* @__PURE__ */ jsx23("div", { className: "px-3 py-2 border-b border-neutral-2 shrink-0", children: /* @__PURE__ */ jsx23("span", { className: "text-xs font-bold uppercase tracking-wider text-neutral-3", children: selectedVariant?.variantName ?? "Styles" }) }),
      /* @__PURE__ */ jsx23("div", { className: "flex-1 overflow-hidden", children: selectedVariant ? /* @__PURE__ */ jsx23(
        EditorPanel,
        {
          selectedVariant,
          portal,
          tokens: theme.content.tokens,
          darkMode: theme.content.meta?.darkMode ?? false
        },
        selectedVariant.key
      ) : /* @__PURE__ */ jsx23("div", { className: "flex items-center justify-center h-full text-sm text-neutral-3", children: "Select a variant to edit" }) })
    ] })
  ] });
};

// src/components/ThemeModal/Components.tsx
import { jsx as jsx24, jsxs as jsxs21 } from "react/jsx-runtime";
var GROUP_ORDER = ["Containers", "Blocks"];
var TypeList = ({ platform, selectedId, onSelect }) => {
  const typeDefs = getComponentTypes(platform);
  return /* @__PURE__ */ jsx24("div", { className: "flex flex-col gap-1 w-[180px] p-1 shrink-0", children: GROUP_ORDER.map((groupLabel) => /* @__PURE__ */ jsxs21("div", { children: [
    /* @__PURE__ */ jsx24("div", { className: "px-2 pt-2 pb-1 text-xs font-bold uppercase tracking-wider text-neutral-3 first:pt-0", children: groupLabel }),
    typeDefs[groupLabel].map(({ id, label }) => /* @__PURE__ */ jsx24(
      "button",
      {
        type: "button",
        onClick: () => onSelect(id),
        className: cn9(
          "flex items-center w-full gap-2 px-2 py-1 mb-1 text-sm font-bold text-left rounded-sm cursor-pointer border-0",
          id === selectedId ? "bg-highlight-3 text-highlight-1" : "bg-transparent text-neutral-1"
        ),
        children: label
      },
      id
    ))
  ] }, groupLabel)) });
};
var Components = ({ platform, theme }) => {
  const components = theme.content.components ?? {};
  const typeDefs = getComponentTypes(platform);
  const allDefs = GROUP_ORDER.flatMap((g) => typeDefs[g]);
  const [selectedId, setSelectedId] = useState16(allDefs[0]?.id ?? "");
  const selectedDef = allDefs.find((d) => d.id === selectedId);
  const variants = selectedDef ? getVariants(components, selectedDef.keys) : [];
  return /* @__PURE__ */ jsxs21("div", { className: "flex-1 overflow-hidden flex gap-2", children: [
    /* @__PURE__ */ jsx24(
      TypeList,
      {
        platform,
        selectedId,
        onSelect: setSelectedId
      }
    ),
    platform === "web" ? /* @__PURE__ */ jsx24(
      VariantEditor,
      {
        selectedDef,
        components,
        platform,
        theme
      },
      selectedId
    ) : /* @__PURE__ */ jsx24("div", { className: "flex-1 border border-neutral-2 rounded-sm overflow-y-auto", children: /* @__PURE__ */ jsxs21("div", { className: "p-3 grid grid-cols-2 auto-rows-min gap-3", children: [
      variants.map(({ key, variantName }) => {
        const multiKey = (selectedDef?.keys.length ?? 0) > 1;
        const cardLabel = multiKey ? `${key.split(".").at(-1)} / ${variantName}` : variantName;
        return /* @__PURE__ */ jsx24(
          VariantCard,
          {
            label: cardLabel,
            componentKey: key,
            variantName,
            platform,
            theme
          },
          `${key}.${variantName}`
        );
      }),
      /* @__PURE__ */ jsx24("div", { className: "flex flex-col justify-center bg-highlight-4 rounded-md p-3", children: /* @__PURE__ */ jsxs21("div", { className: "flex flex-col items-center justify-center gap-2 rounded-lg text-center px-4", children: [
        /* @__PURE__ */ jsx24(Icon6, { icon: faPlusCircle, className: "text-neutral-3 text-lg" }),
        /* @__PURE__ */ jsxs21("p", { className: "text-sm font-bold text-neutral-1", children: [
          "Add ",
          selectedDef?.label,
          " variant"
        ] }),
        /* @__PURE__ */ jsx24("p", { className: "text-sm text-neutral-2", children: "New variants can be added from the Design tab when editing an experience." })
      ] }) })
    ] }) })
  ] });
};

// src/components/ThemeModal/MigrationTab.tsx
import { useMemo as useMemo5 } from "react";
import { faArrowUpRight } from "@fortawesome/pro-regular-svg-icons/faArrowUpRight";
import { Flex as Flex5, Icon as Icon7 } from "@appcues/sonar-builder";

// src/components/ThemeModal/LegacyPreviewFrame.tsx
import { useMemo as useMemo4 } from "react";
import { cn as cn10 } from "@appcues/sonar-builder";

// src/lib/legacy-theme-migration/legacy-theme-document.ts
var WEB_SDK_BASE_CSS = `
/* -- Typography -- */
div, p, ul, ol, table, dl, blockquote, pre {
  font-size: 14px;
  line-height: 1.6em;
}
p, ul, ol, table, dl, figure, blockquote, pre {
  margin: 0 0 15px;
  border: none;
  background: none;
  box-shadow: none;
}
h1, h2, h3, h4, h5, h6 {
  font-weight: 700;
  color: #000;
  padding: 0;
  background: none;
  margin: 0 0 0.5em;
}
h1, h2, h3, h4 { line-height: 1.3; }
h1 { font-size: 36px; }
h2 { font-size: 24px; margin-bottom: 0.7em; }
h3 { font-size: 21px; }
h4 { font-size: 18px; }
h5 { font-size: 16px; }
h6 { font-size: 12px; text-transform: uppercase; }

/* -- Modal: appcues element -- */
appcues {
  font-family: Helvetica Neue, Helvetica, sans-serif;
  font-size: 14px;
  box-sizing: border-box;
  overflow-wrap: break-word;
}

/* -- Modal: cue (step container) -- */
appcues cue {
  display: block;
  position: relative;
  background-color: #fff;
  color: #888;
  max-width: 650px;
  padding: 20px;
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;
  box-shadow: 0 0 6px #aaa;
  box-sizing: border-box;
}

/* -- Buttons -- */
.appcues-button {
  background-color: #ccc;
  cursor: pointer;
  padding: 8px 18px;
  color: #fff;
  font-weight: 700;
  display: inline-block;
  text-decoration: none;
  border-radius: 3px;
  line-height: 1.42857em;
} 
.appcues-button.appcues-button-success {
  background-color: #5cb85c;
}

/* -- Backdrop -- */
.appcues-backdrop,
.appcues-backdrop[data-pattern-type='fullscreen'] {
  background-color: #eee;
}
.appcues-backdrop[data-pattern-type='modal'],
.appcues-backdrop[data-pattern-type='left'],
.appcues-backdrop[data-pattern-type='shorty'],
.appcues-backdrop[data-pattern-type='slideout'] {
  opacity: 0.7;
  background-color: #000;
}

/* -- Tooltip: body -- */
body {
  font-family: Helvetica Neue, Helvetica, sans-serif;
  font-size: 13px;
  line-height: 1.3;
}

/* -- Tooltip: panel -- */
.tooltip {
  display: table;
  width: 100%;
  overflow-wrap: break-word;
}
.tooltip p {
  margin: 0 0 15px;
  line-height: 1.6em;
  font-size: 14px;
  border: none;
  background: none;
  box-shadow: none;
}
.tooltip p:last-child { margin-bottom: 0; }
.content {
  color: #333;
  display: table-cell;
}
.panel {
  border: 1px solid #ddd;
  background-color: #fff;
  padding: 5px;
}
.panel.panel-default {
  box-shadow: 3px 2px #eee9;
  border-radius: 3px;
}
.panel .panel-content { padding: 5px; }
`;
var LEGACY_MODAL_BODY = `
  <div id="extract-backdrop" class="appcues-backdrop" data-pattern-type="modal"></div>
  <appcues data-pattern-type="modal" class="active fullscreen">
    <cue id="extract-modal" class="active">
      <section>
        <h1 id="extract-h1">Heading H1</h1>
        <h2 id="extract-h2">Heading H2</h2>
        <h3 id="extract-h3">Heading H3</h3>
        <h4 id="extract-h4">Heading H4</h4>
        <h5 id="extract-h5">Heading H5</h5>
        <p id="extract-p">Paragraph</p>
      </section>
      <div class="appcues-actions">
        <div class="appcues-actions-right appcues-actions-full-row appcues-actions-align-center">
          <a id="extract-primary-button" class="appcues-button appcues-button-success">Primary Button</a>
        </div>
        <div class="appcues-actions-left">
          <a id="extract-secondary-button" class="appcues-button">Secondary Button</a>
        </div>
      </div>
      <div id="button-state-wrapper" class="appcues-actions">
        <div class="appcues-actions-right appcues-actions-full-row appcues-actions-align-center">
          <a id="extract-primary-button-hover" class="appcues-button appcues-button-success appcues-button-hover appcues-button-success-hover">Primary Button</a>
          <a id="extract-primary-button-active" class="appcues-button appcues-button-success appcues-button-active appcues-button-success-active">Primary Button</a>
        </div>
        <div class="appcues-actions-left">
          <a id="extract-secondary-button-hover" class="appcues-button appcues-button-hover">Secondary Button</a>
          <a id="extract-secondary-button-active" class="appcues-button appcues-button-active">Secondary Button</a>
        </div>
      </div>
    </cue>
  </appcues>`;
var LEGACY_TOOLTIP_BODY = `
  <div class="tooltip">
    <div class="content">
      <div id="extract-tooltip" class="panel panel-default">
        <div class="panel-content">
          <h4>Heading 4</h4>
          <p>Tooltip body text.</p>
        </div>
      </div>
    </div>
  </div>`;
function escapeCssForStyleTag(css) {
  return css.replace(/<\/style/gi, String.raw`<\/style`);
}
function rewritePseudoClasses(css) {
  return css.replace(/\.appcues-button:hover/g, ".appcues-button-hover").replace(/\.appcues-button:active/g, ".appcues-button-active").replace(/\.appcues-button-success:hover/g, ".appcues-button-success-hover").replace(
    /\.appcues-button-success:active/g,
    ".appcues-button-success-active"
  );
}
function legacyThemeDocument(css) {
  return `
  <!doctype html>
  <html>
    <head>
      <style>${WEB_SDK_BASE_CSS}</style>
      <style>${escapeCssForStyleTag(rewritePseudoClasses(css))}</style>
    </head>
    <body>${LEGACY_MODAL_BODY}${LEGACY_TOOLTIP_BODY}</body>
  </html>`;
}

// src/lib/legacy-theme-migration/migrate-legacy.ts
import { get as get8, set as set2 } from "object-path-immutable";

// src/model/base-theme.ts
var base_theme_default = {
  name: "Base Theme",
  content: {
    meta: {
      schemaVersion: 7,
      darkMode: false
    },
    tone: {},
    tokens: {
      colors: {
        $type: "color",
        foreground: { $value: "#000000" },
        background: { $value: "#ffffff" },
        primary: { $value: "#5c5cff" },
        "primary-contrast": { $value: "#ffffff" },
        utility: {
          backdrop: { $value: "#0000004d" },
          error: { $value: "#d6216b" },
          unselected: { $value: "#627293" }
        },
        dark: {
          foreground: { $value: "#ffffff" },
          background: { $value: "#000000" },
          primary: { $value: "#5c5cff" },
          "primary-contrast": { $value: "#ffffff" },
          utility: {
            backdrop: { $value: "#0000004d" },
            error: { $value: "#bf3c97" },
            unselected: { $value: "#627293" }
          }
        }
      },
      font: {
        family: {
          $type: "fontFamily",
          base: {
            $value: "System Sans-serif",
            $extensions: {
              "com.appcues.theme.font": {
                web: {},
                mobile: {
                  ultralight: "System Default Ultralight",
                  thin: "System Default Thin",
                  light: "System Default Light",
                  regular: "System Default Regular",
                  medium: "System Default Medium",
                  semibold: "System Default Semibold",
                  bold: "System Default Bold",
                  heavy: "System Default Heavy",
                  black: "System Default Black"
                }
              }
            }
          }
        },
        weight: {
          $type: "fontWeight",
          regular: { $value: "regular" },
          medium: { $value: "medium" },
          bold: { $value: "bold" }
        },
        size: {
          $type: "dimension",
          $extensions: {
            "com.appcues.theme.preset": "M"
          },
          small: { $value: "14px" },
          regular: { $value: "16px" },
          large: { $value: "22px" },
          h5: { $value: "16px" },
          h4: { $value: "18px" },
          h3: { $value: "20px" },
          h2: { $value: "24px" },
          h1: { $value: "32px" }
        }
      },
      dimensions: {
        $type: "dimension",
        unit: {
          $extensions: {
            "com.appcues.theme.preset": "M"
          },
          0: { $value: "0px" },
          1: { $value: "8px" },
          2: { $value: "12px" },
          3: { $value: "16px" },
          4: { $value: "20px" },
          5: { $value: "24px" }
        }
      },
      parts: {
        container: {
          "corner-radius": { $type: "dimension", $value: "8px" },
          padding: { $type: "dimension", $value: "{dimensions.unit.3}" },
          "shadow-radius": { $type: "dimension", $value: "6px" }
        }
      }
    },
    components: {
      container: {
        modal: {
          default: {
            $style: {
              backgroundColor: { light: "{colors.background}" },
              cornerRadius: "{parts.container.corner-radius}",
              paddingBottom: "{parts.container.padding}",
              shadow: {
                color: { light: "#00000029" },
                radius: "{parts.container.shadow-radius}",
                x: "0px",
                y: "3px"
              }
            },
            backdrop: {
              $style: {
                backgroundColor: { light: "{colors.utility.backdrop}" }
              }
            }
          }
        },
        tooltip: {
          default: {
            $style: {
              backgroundColor: { light: "{colors.background}" },
              cornerRadius: "{parts.container.corner-radius}",
              shadow: {
                color: { light: "#00000029" },
                radius: "{parts.container.shadow-radius}",
                x: "0px",
                y: "3px"
              },
              width: "300px"
            },
            backdrop: {
              $style: {
                backgroundColor: { light: "{colors.utility.backdrop}" }
              }
            },
            pointer: {
              $style: {
                pointerBase: "24px",
                pointerLength: "12px"
              }
            }
          }
        },
        embed: {
          default: {
            $style: {
              backgroundColor: { light: "{colors.background}" },
              paddingBottom: "{parts.container.padding}",
              cornerRadius: "{parts.container.corner-radius}"
            }
          }
        }
      },
      text: {
        default: {
          $style: {
            fontFamily: "{font.family.base}",
            fontWeight: "{font.weight.regular}",
            fontSize: "{font.size.regular}",
            textAlignment: "center",
            horizontalAlignment: "center",
            foregroundColor: { light: "{colors.foreground}" },
            marginTop: "{dimensions.unit.1}",
            marginBottom: "{dimensions.unit.1}",
            marginLeading: "{dimensions.unit.3}",
            marginTrailing: "{dimensions.unit.3}"
          }
        }
      },
      button: {
        default: {
          $style: {
            backgroundColor: { light: "{colors.primary}" },
            cornerRadius: "{parts.container.corner-radius}",
            marginTop: "{dimensions.unit.1}",
            marginBottom: "{dimensions.unit.1}",
            marginLeading: "{dimensions.unit.3}",
            marginTrailing: "{dimensions.unit.3}",
            paddingTop: "{dimensions.unit.2}",
            paddingBottom: "{dimensions.unit.2}",
            paddingLeading: "{dimensions.unit.5}",
            paddingTrailing: "{dimensions.unit.5}"
          },
          text: {
            $style: {
              fontFamily: "{font.family.base}",
              fontWeight: "{font.weight.regular}",
              fontSize: "{font.size.regular}",
              foregroundColor: { light: "{colors.primary-contrast}" }
            }
          }
        }
      },
      hero: {
        default: {
          $style: {
            backgroundColor: { light: "{colors.primary}" }
          },
          title: {
            $style: {
              fontFamily: "{font.family.base}",
              fontWeight: "{font.weight.bold}",
              fontSize: "{font.size.large}",
              foregroundColor: { light: "{colors.primary-contrast}" },
              textAlignment: "center",
              marginTop: "{dimensions.unit.5}",
              marginBottom: "{dimensions.unit.3}",
              marginLeading: "{dimensions.unit.3}",
              marginTrailing: "{dimensions.unit.3}"
            }
          },
          subtitle: {
            $style: {
              fontFamily: "{font.family.base}",
              fontWeight: "{font.weight.medium}",
              fontSize: "{font.size.large}",
              foregroundColor: { light: "{colors.primary-contrast}" },
              textAlignment: "center",
              marginBottom: "{dimensions.unit.5}",
              marginLeading: "{dimensions.unit.3}",
              marginTrailing: "{dimensions.unit.3}"
            }
          }
        }
      },
      image: {
        default: {
          $style: {}
        }
      },
      imagewithtext: {
        default: {
          $style: {
            paddingTop: "{dimensions.unit.1}",
            paddingBottom: "{dimensions.unit.1}",
            paddingLeading: "{dimensions.unit.3}",
            paddingTrailing: "{dimensions.unit.3}"
          },
          image: {
            $style: {
              marginTrailing: "{dimensions.unit.1}",
              width: "56px"
            }
          },
          title: {
            $style: {
              fontFamily: "{font.family.base}",
              fontWeight: "{font.weight.bold}",
              fontSize: "{font.size.regular}",
              foregroundColor: { light: "{colors.foreground}" },
              textAlignment: "leading",
              horizontalAlignment: "leading"
            }
          },
          subtitle: {
            $style: {
              fontFamily: "{font.family.base}",
              fontWeight: "{font.weight.regular}",
              fontSize: "{font.size.regular}",
              foregroundColor: { light: "{colors.foreground}" },
              textAlignment: "leading",
              horizontalAlignment: "leading"
            }
          }
        }
      },
      select: {
        default: {
          $style: {
            marginBottom: "{dimensions.unit.2}",
            marginLeading: "{dimensions.unit.2}",
            marginTop: "{dimensions.unit.2}",
            marginTrailing: "{dimensions.unit.2}"
          },
          colors: {
            $style: {
              accentColor: { light: "#ffffff" },
              selectedColor: { light: "{colors.foreground}" },
              unselectedColor: { light: "{colors.utility.unselected}" }
            }
          },
          label: {
            $style: {
              fontFamily: "{font.family.base}",
              fontWeight: "{font.weight.regular}",
              fontSize: "{font.size.regular}",
              foregroundColor: { light: "{colors.foreground}" },
              marginBottom: "{dimensions.unit.2}",
              horizontalAlignment: "leading",
              textAlignment: "leading"
            }
          },
          errorLabel: {
            $style: {
              fontFamily: "{font.family.base}",
              fontWeight: "{font.weight.regular}",
              fontSize: "{font.size.small}",
              foregroundColor: { light: "{colors.utility.error}" },
              marginTop: "{dimensions.unit.2}",
              horizontalAlignment: "leading",
              textAlignment: "leading"
            }
          },
          optionContent: {
            $style: {
              foregroundColor: { light: "{colors.foreground}" },
              textAlignment: "leading",
              fontFamily: "{font.family.base}",
              fontWeight: "{font.weight.regular}",
              fontSize: "{font.size.regular}"
            }
          },
          ratingNumberContent: {
            $style: {
              fontFamily: "{font.family.base}",
              fontWeight: "{font.weight.regular}",
              foregroundColor: { light: "{colors.primary}" },
              borderColor: { light: "{colors.primary}" }
            }
          },
          ratingNumberContentSelected: {
            $style: {
              fontFamily: "{font.family.base}",
              fontWeight: "{font.weight.regular}",
              foregroundColor: { light: "{colors.primary-contrast}" },
              backgroundColor: { light: "{colors.primary}" },
              borderColor: { light: "{colors.primary}" }
            }
          },
          ratingStarContent: {
            $style: {
              foregroundColor: { light: "{colors.primary}" }
            }
          },
          ratingStarContentSelected: {
            $style: {
              foregroundColor: { light: "{colors.primary}" }
            }
          },
          ratingEmojiContent: {
            $style: {
              foregroundColor: { light: "{colors.foreground}" }
            }
          },
          ratingEmojiContentSelected: {
            $style: {
              backgroundColor: { light: "{colors.foreground}" },
              foregroundColor: { light: "{colors.foreground}" }
            }
          }
        }
      },
      textinput: {
        default: {
          $style: {
            marginTop: "{dimensions.unit.2}",
            marginBottom: "{dimensions.unit.2}",
            marginLeading: "{dimensions.unit.3}",
            marginTrailing: "{dimensions.unit.3}"
          },
          label: {
            $style: {
              fontFamily: "{font.family.base}",
              fontWeight: "{font.weight.regular}",
              fontSize: "{font.size.regular}",
              foregroundColor: { light: "{colors.foreground}" },
              marginBottom: "{dimensions.unit.2}",
              horizontalAlignment: "leading",
              textAlignment: "leading"
            }
          },
          errorLabel: {
            $style: {
              fontFamily: "{font.family.base}",
              fontWeight: "{font.weight.regular}",
              fontSize: "{font.size.small}",
              foregroundColor: { light: "{colors.utility.error}" },
              marginTop: "{dimensions.unit.2}",
              horizontalAlignment: "leading",
              textAlignment: "leading"
            }
          },
          placeholder: {
            $style: {
              fontFamily: "{font.family.base}",
              fontWeight: "{font.weight.regular}",
              foregroundColor: { light: "{colors.utility.unselected}" }
            }
          },
          textField: {
            $style: {
              fontFamily: "{font.family.base}",
              fontWeight: "{font.weight.regular}",
              fontSize: "{font.size.regular}",
              borderColor: { light: "{colors.utility.unselected}" },
              borderWidth: "0.5px",
              cornerRadius: "4px",
              foregroundColor: { light: "{colors.foreground}" }
            }
          }
        }
      },
      web: {
        cell: {
          default: {
            $style: {
              paddingInlineStart: 0,
              paddingTop: 0,
              paddingInlineEnd: 0,
              paddingBottom: 0,
              gap: 0
            }
          }
        },
        embed: {
          default: {
            $style: {
              backgroundColor: "{colors.background}",
              borderRadius: "{parts.container.corner-radius}",
              color: "{colors.foreground}",
              padding: "0px"
            }
          }
        },
        modal: {
          default: {
            $style: {
              backgroundColor: "{colors.background}",
              border: "none",
              borderRadius: "{parts.container.corner-radius}",
              boxShadow: "0px 6px 16px 0px rgba(0, 0, 0, 0.2)",
              color: "{colors.foreground}",
              padding: "0px"
            }
          }
        },
        tooltip: {
          default: {
            $style: {
              backgroundColor: "{colors.background}",
              border: "none",
              borderRadius: "{parts.container.corner-radius}",
              boxShadow: "none",
              filter: "drop-shadow(0px 6px 16px rgba(0, 0, 0, 0.2))",
              color: "{colors.foreground}",
              padding: "0px",
              margin: "0px"
            }
          }
        },
        button: {
          default: {
            $style: {
              backgroundColor: "{colors.primary}",
              borderStyle: "none",
              borderWidth: "0px",
              borderColor: "unset",
              borderRadius: "{parts.container.corner-radius}",
              color: "{colors.primary-contrast}",
              cursor: "pointer",
              flexGrow: "0",
              fontFamily: "inherit",
              fontSize: "{font.size.small}",
              height: "fit-content",
              marginTop: "0px",
              marginBottom: "0px",
              marginInlineStart: "{dimensions.unit.3}",
              marginInlineEnd: "{dimensions.unit.3}",
              paddingTop: "{dimensions.unit.2}",
              paddingBottom: "{dimensions.unit.2}",
              paddingInlineStart: "{dimensions.unit.3}",
              paddingInlineEnd: "{dimensions.unit.3}",
              textAlign: "center",
              textDecoration: "none",
              transition: "background-color 0.15s ease-out 0s, box-shadow 0.15s ease-out 0s, outline-color 0.15s ease-out 0s",
              width: "fit-content",
              state: {
                hover: {
                  backgroundColor: "{colors.primary}"
                }
              }
            }
          }
        },
        "close-x": {
          default: {
            $style: {
              backgroundColor: "transparent",
              border: "none",
              borderRadius: "6px",
              boxSizing: "content-box",
              color: "{colors.foreground}",
              cursor: "pointer",
              width: "14px",
              height: "14px",
              insetInlineStart: "auto",
              insetInlineEnd: "0",
              marginTop: "{dimensions.unit.2}",
              marginBottom: "{dimensions.unit.2}",
              marginInlineStart: "{dimensions.unit.2}",
              marginInlineEnd: "{dimensions.unit.2}",
              paddingTop: "{dimensions.unit.1}",
              paddingBottom: "{dimensions.unit.1}",
              paddingInlineStart: "{dimensions.unit.1}",
              paddingInlineEnd: "{dimensions.unit.1}",
              state: {
                hover: {
                  color: "{colors.foreground}"
                }
              }
            }
          }
        },
        img: {
          default: {
            $style: {
              height: "100%",
              width: "100%"
            }
          }
        },
        p: {
          default: {
            $style: {
              fontFamily: "inherit",
              fontWeight: "unset",
              textAlign: "center",
              margin: "0px",
              color: "{colors.foreground}",
              fontSize: "{font.size.regular}"
            }
          }
        },
        h1: {
          default: {
            $style: {
              margin: "0px",
              fontFamily: "inherit",
              fontWeight: "bold",
              textAlign: "center",
              fontSize: "{font.size.h1}",
              color: "{colors.foreground}"
            }
          }
        },
        h2: {
          default: {
            $style: {
              margin: "0px",
              fontFamily: "inherit",
              fontWeight: "bold",
              textAlign: "center",
              fontSize: "{font.size.h2}",
              color: "{colors.foreground}"
            }
          }
        },
        h3: {
          default: {
            $style: {
              margin: "0px",
              fontFamily: "inherit",
              fontWeight: "bold",
              textAlign: "center",
              fontSize: "{font.size.h3}",
              color: "{colors.foreground}"
            }
          }
        },
        h4: {
          default: {
            $style: {
              margin: "0px",
              fontFamily: "inherit",
              fontWeight: "bold",
              textAlign: "center",
              fontSize: "{font.size.h4}",
              color: "{colors.foreground}"
            }
          }
        },
        h5: {
          default: {
            $style: {
              margin: "0px",
              fontFamily: "inherit",
              fontWeight: "bold",
              textAlign: "center",
              fontSize: "{font.size.h5}",
              color: "{colors.foreground}"
            }
          }
        }
      }
    }
  }
};

// src/lib/legacy-theme-migration/extract-legacy.ts
var EXTRACTED_PROPS = [
  "backgroundColor",
  "backgroundImage",
  "borderColor",
  "borderRadius",
  "borderStyle",
  "borderWidth",
  "boxShadow",
  "color",
  "fontFamily",
  "fontSize",
  "fontStyle",
  "fontWeight",
  "letterSpacing",
  "lineHeight",
  "marginTop",
  "marginInlineEnd",
  "marginBottom",
  "marginInlineStart",
  "opacity",
  "outlineColor",
  "outlineOffset",
  "outlineStyle",
  "outlineWidth",
  "paddingTop",
  "paddingInlineEnd",
  "paddingBottom",
  "paddingInlineStart",
  "textAlign",
  "textDecoration",
  "transform",
  "transition"
];
var DEFAULT_VALUES = {
  backgroundImage: ["none"],
  borderStyle: ["none"],
  borderWidth: ["0px", "medium"],
  boxShadow: ["none"],
  fontStyle: ["normal"],
  letterSpacing: ["normal"],
  lineHeight: ["normal"],
  paddingTop: ["0px"],
  paddingInlineEnd: ["0px"],
  paddingBottom: ["0px"],
  paddingInlineStart: ["0px"],
  marginTop: ["0px"],
  marginInlineEnd: ["0px"],
  marginBottom: ["0px"],
  marginInlineStart: ["0px"],
  opacity: ["1"],
  outlineOffset: ["0px"],
  textAlign: ["start"],
  textDecoration: ["none"],
  transform: ["none"],
  transition: ["none", "all 0s ease 0s"]
};
function extractComponentStyles(win, el) {
  if (!el) return void 0;
  const computed = win.getComputedStyle(el);
  const result = {};
  for (const prop of EXTRACTED_PROPS) {
    const raw = computed[prop]?.trim();
    if (raw && !DEFAULT_VALUES[prop]?.includes(raw)) {
      result[prop] = raw;
    }
  }
  return Object.keys(result).length > 0 ? result : void 0;
}
function extractStylesFromGlobalCss(css) {
  const iframe = document.createElement("iframe");
  iframe.style.cssText = "position:absolute;width:1px;height:1px;border:none;visibility:hidden;";
  document.body.append(iframe);
  try {
    const doc = iframe.contentDocument;
    doc.open();
    doc.write(legacyThemeDocument(css));
    doc.close();
    const win = iframe.contentWindow;
    const ex = (id) => extractComponentStyles(win, doc.querySelector(`#${id}`));
    return {
      modal: ex("extract-modal"),
      backdrop: ex("extract-backdrop"),
      primaryButton: ex("extract-primary-button"),
      primaryButtonHover: ex("extract-primary-button-hover"),
      primaryButtonActive: ex("extract-primary-button-active"),
      secondaryButton: ex("extract-secondary-button"),
      secondaryButtonHover: ex("extract-secondary-button-hover"),
      secondaryButtonActive: ex("extract-secondary-button-active"),
      h1: ex("extract-h1"),
      h2: ex("extract-h2"),
      h3: ex("extract-h3"),
      h4: ex("extract-h4"),
      h5: ex("extract-h5"),
      p: ex("extract-p"),
      tooltip: ex("extract-tooltip")
    };
  } finally {
    document.body.removeChild(iframe);
  }
}

// src/lib/legacy-theme-migration/preprocess-extracted-styles.ts
function rgbToHex(rgb) {
  const match = rgb.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*([\d.]+))?\)/);
  if (!match) return null;
  const [, r, g, b, a] = match;
  if (a !== void 0 && Number.parseFloat(a) === 0) return null;
  const hex = [r, g, b].map((n) => Number.parseInt(n, 10).toString(16).padStart(2, "0")).join("");
  const alpha = a !== void 0 && Number.parseFloat(a) < 1 ? Math.round(Number.parseFloat(a) * 255).toString(16).padStart(2, "0") : "";
  return `#${hex}${alpha}`;
}
var BOTTOM_ONLY_RADIUS_RE = /^0px 0px (.+) \1$/;
function normalizeBottomOnlyRadius(value) {
  const match = value.match(BOTTOM_ONLY_RADIUS_RE);
  return match ? match[1] : value;
}
var PX_VALUE_RE = /^([\d.]+)px$/;
function normalizeLineHeight(s) {
  if (!s.lineHeight || !s.fontSize) return {};
  const lhMatch = s.lineHeight.match(PX_VALUE_RE);
  const fsMatch = s.fontSize.match(PX_VALUE_RE);
  if (!lhMatch || !fsMatch) return {};
  const ratio = Number.parseFloat(lhMatch[1]) / Number.parseFloat(fsMatch[1]);
  return { lineHeight: String(Number.parseFloat(ratio.toFixed(4))) };
}
var COLOR_PROPS = [
  "backgroundColor",
  "borderColor",
  "color",
  "outlineColor"
];
function normalizeColors(s) {
  const result = { ...s };
  for (const prop of COLOR_PROPS) {
    const raw = result[prop];
    if (raw) {
      const hex = rgbToHex(raw);
      if (hex === null) {
        delete result[prop];
      } else {
        result[prop] = hex;
      }
    }
  }
  return result;
}
function cleanBorderProps({
  borderWidth,
  borderColor,
  borderStyle,
  ...rest
}) {
  const hasActiveBorder = !!borderWidth && borderWidth !== "0px" && borderWidth !== "0";
  return hasActiveBorder ? { borderWidth, borderColor, borderStyle, ...rest } : { ...rest };
}
function cleanOutlineProps({
  outlineWidth,
  outlineColor,
  outlineStyle,
  outlineOffset,
  ...rest
}) {
  const hasActiveOutline = !!outlineWidth && outlineWidth !== "0px" && outlineWidth !== "0";
  return hasActiveOutline ? { outlineWidth, outlineColor, outlineStyle, outlineOffset, ...rest } : { ...rest };
}
function ensureFontFamilyFallback(s) {
  if (!s.fontFamily || s.fontFamily.includes(",")) return {};
  return { fontFamily: `${s.fontFamily}, sans-serif` };
}
function omitPadding({
  /* eslint-disable @typescript-eslint/no-unused-vars */
  paddingTop,
  paddingBottom,
  paddingInlineStart,
  paddingInlineEnd,
  /* eslint-enable @typescript-eslint/no-unused-vars */
  ...rest
}) {
  return rest;
}
function diffStyles(state, base) {
  if (!state) return void 0;
  const result = Object.fromEntries(
    Object.entries(state).filter(
      ([k, v]) => v !== base?.[k]
    )
  );
  return Object.keys(result).length > 0 ? result : void 0;
}
function preprocessCss(raw) {
  const normalized = Object.fromEntries(
    Object.entries(raw).map(
      ([k, v]) => [
        k,
        v ? cleanOutlineProps(
          cleanBorderProps({
            ...normalizeColors(v),
            ...normalizeLineHeight(v),
            ...ensureFontFamilyFallback(v)
          })
        ) : v
      ]
    )
  );
  return {
    ...normalized,
    modal: normalized.modal ? {
      ...omitPadding(normalized.modal),
      ...normalized.modal.borderRadius !== void 0 && {
        borderRadius: normalizeBottomOnlyRadius(
          normalized.modal.borderRadius
        )
      }
    } : void 0,
    tooltip: normalized.tooltip ? omitPadding(normalized.tooltip) : void 0,
    // Pseudo-class states: keep only properties that differ from the base style.
    primaryButtonHover: diffStyles(
      normalized.primaryButtonHover,
      normalized.primaryButton
    ),
    primaryButtonActive: diffStyles(
      normalized.primaryButtonActive,
      normalized.primaryButton
    ),
    secondaryButtonHover: diffStyles(
      normalized.secondaryButtonHover,
      normalized.secondaryButton
    ),
    secondaryButtonActive: diffStyles(
      normalized.secondaryButtonActive,
      normalized.secondaryButton
    )
  };
}

// src/lib/legacy-theme-migration/migrate-legacy.ts
function toHexWithAlpha(hexColor, opacity) {
  const hasAlpha = /^#[0-9a-f]{8}$/i.test(hexColor);
  const base = hasAlpha ? hexColor.slice(0, 7) : hexColor;
  const existingAlpha = hasAlpha ? Number.parseInt(hexColor.slice(7, 9), 16) / 255 : 1;
  const alpha = Math.round(existingAlpha * opacity * 255).toString(16).padStart(2, "0");
  return `${base}${alpha}`;
}
function definedStyles(s, omit = [], allowList) {
  return Object.fromEntries(
    Object.entries(s).filter(([k, v]) => {
      if (v === void 0) return false;
      if (omit.includes(k)) return false;
      if (allowList && !allowList.has(camelToKebab(k))) return false;
      return true;
    })
  );
}
function buildTokens(css, base) {
  const cssBackdropHex = css.backdrop?.backgroundColor && css.backdrop.opacity !== void 0 ? toHexWithAlpha(
    css.backdrop.backgroundColor,
    Number.parseFloat(css.backdrop.opacity)
  ) : css.backdrop?.backgroundColor;
  const mappings = [
    // { value: css.p?.fontFamily, to: 'font.family.base.$value' },
    { value: css.p?.color, to: "colors.foreground.$value" },
    { value: css.p?.fontSize, to: "font.size.regular.$value" },
    { value: css.h1?.fontSize, to: "font.size.h1.$value" },
    { value: css.h2?.fontSize, to: "font.size.h2.$value" },
    { value: css.h3?.fontSize, to: "font.size.h3.$value" },
    { value: css.h4?.fontSize, to: "font.size.h4.$value" },
    { value: css.h5?.fontSize, to: "font.size.h5.$value" },
    { value: css.primaryButton?.backgroundColor, to: "colors.primary.$value" },
    { value: css.primaryButton?.color, to: "colors.primary-contrast.$value" },
    {
      // Secondary tokens must have fallback values because the components below are relying on these tokens to be defined and they don't exist in the base theme.
      value: css.secondaryButton?.backgroundColor ?? "#ffffff00",
      to: "colors.secondary.$value"
    },
    {
      value: css.secondaryButton?.color ?? "#00000000",
      to: "colors.secondary-contrast.$value"
    },
    {
      value: css.modal?.borderRadius,
      to: "parts.container.corner-radius.$value"
    },
    { value: css.modal?.backgroundColor, to: "colors.background.$value" },
    { value: cssBackdropHex, to: "colors.utility.backdrop.$value" }
  ];
  return mappings.reduce(
    (tokens, { value, to }) => value !== void 0 && value !== null ? set2(tokens, to, value) : tokens,
    base
  );
}
function buildComponents(css, base, tokens) {
  const resolveTokenIfMatch = (value, token) => {
    const resolved = get8(tokens, `${token.slice(1, -1)}.$value`);
    return value === void 0 || value === resolved ? token : value;
  };
  const withForegroundColor = (s) => ({
    color: resolveTokenIfMatch(s.color, "{colors.foreground}")
  });
  const withContainerValues = (s) => ({
    borderRadius: resolveTokenIfMatch(
      s.borderRadius,
      "{parts.container.corner-radius}"
    ),
    ...s.backgroundColor !== void 0 && {
      backgroundColor: resolveTokenIfMatch(
        s.backgroundColor,
        "{colors.background}"
      )
    }
  });
  const makeButtonStateStyles = (state, bgToken, colorToken) => {
    if (!state) return {};
    return {
      ...state.backgroundColor !== void 0 && {
        backgroundColor: resolveTokenIfMatch(state.backgroundColor, bgToken)
      },
      ...state.color !== void 0 && {
        color: resolveTokenIfMatch(state.color, colorToken)
      },
      ...state.borderColor !== void 0 && {
        borderColor: resolveTokenIfMatch(state.borderColor, bgToken)
      },
      ...definedStyles(state, ["backgroundColor", "color", "borderColor"])
    };
  };
  const makeButtonValues = (bgToken, colorToken, hoverCss, activeCss) => (s) => ({
    backgroundColor: resolveTokenIfMatch(s.backgroundColor, bgToken),
    color: resolveTokenIfMatch(s.color, colorToken),
    ...s.borderColor !== void 0 && {
      borderColor: resolveTokenIfMatch(s.borderColor, bgToken)
    },
    state: {
      ...hoverCss !== void 0 && {
        hover: makeButtonStateStyles(hoverCss, bgToken, colorToken)
      },
      ...activeCss !== void 0 && {
        active: makeButtonStateStyles(activeCss, bgToken, colorToken)
      }
    }
  });
  const COMPONENT_VARIANTS = [
    {
      path: "web.modal.default",
      cssStyles: css.modal,
      omit: ["borderRadius", "backgroundColor"],
      customValues: withContainerValues
    },
    {
      path: "web.tooltip.default",
      cssStyles: css.tooltip,
      omit: ["borderRadius", "backgroundColor"],
      customValues: withContainerValues
    },
    {
      path: "web.h1.default",
      cssStyles: css.h1,
      omit: ["color", "fontSize"],
      customValues: withForegroundColor
    },
    {
      path: "web.h2.default",
      cssStyles: css.h2,
      omit: ["color", "fontSize"],
      customValues: withForegroundColor
    },
    {
      path: "web.h3.default",
      cssStyles: css.h3,
      omit: ["color", "fontSize"],
      customValues: withForegroundColor
    },
    {
      path: "web.h4.default",
      cssStyles: css.h4,
      omit: ["color", "fontSize"],
      customValues: withForegroundColor
    },
    {
      path: "web.h5.default",
      cssStyles: css.h5,
      omit: ["color", "fontSize"],
      customValues: withForegroundColor
    },
    {
      path: "web.p.default",
      cssStyles: css.p,
      omit: ["color", "fontSize"],
      customValues: withForegroundColor
    },
    {
      path: "web.button.default",
      cssStyles: css.primaryButton,
      omit: ["color", "backgroundColor", "borderColor"],
      customValues: makeButtonValues(
        "{colors.primary}",
        "{colors.primary-contrast}",
        css.primaryButtonHover,
        css.primaryButtonActive
      )
    },
    {
      path: "web.button.secondary",
      cssStyles: css.secondaryButton,
      omit: ["color", "backgroundColor", "borderColor"],
      customValues: makeButtonValues(
        "{colors.secondary}",
        "{colors.secondary-contrast}",
        css.secondaryButtonHover,
        css.secondaryButtonActive
      )
    }
  ];
  const defaultButtonStyle = base_theme_default.content.components.web.button.default.$style;
  let components = set2(base, "web.button.secondary.$style", defaultButtonStyle);
  for (const { path, cssStyles, omit, customValues } of COMPONENT_VARIANTS) {
    if (cssStyles) {
      const componentKey = path.split(".").slice(0, 2).join(".");
      const allowedProperties = WEB_COMPONENT_STYLE_CONFIGS[componentKey]?.allowedProperties;
      const allowList = allowedProperties ? new Set(Object.keys(allowedProperties)) : void 0;
      const existingStyle = get8(components, `${path}.$style`);
      components = set2(components, `${path}.$style`, {
        ...existingStyle,
        ...definedStyles(cssStyles, omit, allowList),
        ...customValues?.(cssStyles)
      });
    }
  }
  return components;
}
function migrateLegacyThemeContent(legacyTheme) {
  const globalStyling = legacyTheme?.globalStyling;
  if (!globalStyling) {
    throw new Error("Cannot migrate legacy theme: missing globalStyling CSS");
  }
  const css = preprocessCss(extractStylesFromGlobalCss(globalStyling));
  const meta = {
    ...base_theme_default.content.meta,
    sourceLegacyThemeId: legacyTheme?.id
  };
  const tokens = buildTokens(css, base_theme_default.content.tokens);
  const components = buildComponents(
    css,
    base_theme_default.content.components,
    tokens
  );
  return {
    ...base_theme_default.content,
    meta,
    tokens,
    components
  };
}

// src/components/ThemeModal/LegacyPreviewFrame.tsx
import { jsx as jsx25, jsxs as jsxs22 } from "react/jsx-runtime";
var SCAFFOLD_STYLES = `
appcues {
  display: block;
  width: 720px;
  max-width: 80vw;
  max-height: 80vh;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
appcues cue {
  text-align: center;
  padding: 0!important;
  width: 100%!important;
  min-width: auto!important;
  max-width: auto!important;
}
section {
  padding: 10px
}
.appcues-actions {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 10px;
}
#button-state-wrapper {
  display: none!important;
}
`;
function buildPreviewDoc(css) {
  return `<!doctype html>
<html>
<head>
  <style>${SCAFFOLD_STYLES}</style>
  <style>${WEB_SDK_BASE_CSS}</style>
  ${css ? `<style>${escapeCssForStyleTag(css)}</style>` : ""}
</head>
<body>${LEGACY_MODAL_BODY}
</body>
</html>`;
}
var LegacyPreviewFrame = ({
  globalStyling,
  title,
  action
}) => {
  const srcDoc = useMemo4(() => buildPreviewDoc(globalStyling), [globalStyling]);
  return /* @__PURE__ */ jsxs22("div", { className: cn10("relative flex-1"), children: [
    /* @__PURE__ */ jsx25(
      "iframe",
      {
        className: cn10("w-full h-full border-0"),
        title,
        srcDoc,
        sandbox: "",
        scrolling: "no"
      }
    ),
    title ? /* @__PURE__ */ jsx25(
      "div",
      {
        className: cn10("absolute top-0 left-0 p-4 font-bold leading-normal"),
        children: title
      }
    ) : null,
    action ? /* @__PURE__ */ jsx25("div", { className: cn10("absolute top-0 right-0 p-4"), children: action }) : null
  ] });
};

// src/components/ThemeModal/MigrationTab.tsx
import { jsx as jsx26, jsxs as jsxs23 } from "react/jsx-runtime";
var MigrationTab = ({ theme }) => {
  const { getLegacyTheme, studioUrl } = useThemeEditor();
  const legacyId = theme.content.meta?.sourceLegacyThemeId;
  const legacyTheme = useMemo5(
    () => legacyId ? getLegacyTheme?.(legacyId) : void 0,
    [legacyId, getLegacyTheme]
  );
  const webExperience = useMemo5(() => makeWebExperience(theme), [theme]);
  const viewOriginalLink = legacyId && studioUrl ? /* @__PURE__ */ jsxs23(
    "a",
    {
      href: `${studioUrl}/themes/${legacyId}/edit/general`,
      target: "_blank",
      rel: "noreferrer",
      className: "inline-flex items-center gap-1 text-xs text-neutral-4 hover:text-neutral-1 transition-colors",
      children: [
        "View original",
        /* @__PURE__ */ jsx26(Icon7, { icon: faArrowUpRight })
      ]
    }
  ) : null;
  return /* @__PURE__ */ jsx26(
    Flex5,
    {
      direction: "column",
      className: "flex-1 border border-neutral-2 rounded-md overflow-hidden",
      children: /* @__PURE__ */ jsxs23("div", { className: "flex flex-1 overflow-hidden", children: [
        /* @__PURE__ */ jsx26(WebPreviewFrame, { experience: webExperience, title: "Experience Theme" }),
        /* @__PURE__ */ jsx26("div", { className: "w-px self-stretch my-4 bg-neutral-2" }),
        legacyTheme !== void 0 ? /* @__PURE__ */ jsx26(
          LegacyPreviewFrame,
          {
            globalStyling: legacyTheme.globalStyling,
            title: "Legacy Theme",
            action: viewOriginalLink
          }
        ) : /* @__PURE__ */ jsx26("div", { className: "relative flex-1 flex items-center justify-center text-sm text-neutral-5", children: "Legacy theme not available" })
      ] })
    }
  );
};

// src/components/ThemeModal/ThemeModal.tsx
import { Fragment as Fragment7, jsx as jsx27, jsxs as jsxs24 } from "react/jsx-runtime";
var ThemeModal = ({ platform, onSave }) => {
  const { theme, container, isEditorOpen, setIsEditorOpen, getLegacyTheme } = useThemeEditor();
  const handleClose = () => setIsEditorOpen(false);
  const showMigrationTab = !!theme?.content.meta?.sourceLegacyThemeId && getLegacyTheme !== void 0;
  return /* @__PURE__ */ jsx27(
    Modal2,
    {
      open: isEditorOpen,
      onOpenChange: () => setIsEditorOpen(false),
      container,
      children: /* @__PURE__ */ jsxs24(
        ModalContent2,
        {
          size: "large",
          onWheel: (e) => {
            e.stopPropagation();
          },
          children: [
            /* @__PURE__ */ jsx27(ModalHeader2, { children: /* @__PURE__ */ jsxs24(ModalTitle2, { children: [
              /* @__PURE__ */ jsx27(Icon8, { icon: faSwatchbook }),
              theme ? `Edit Theme \u201C${theme.name}\u201D` : "Loading\u2026"
            ] }) }),
            /* @__PURE__ */ jsx27(
              "div",
              {
                className: "flex flex-col h-[min(700px,calc(100vh-12rem))]",
                "data-theme": "light",
                children: !theme ? /* @__PURE__ */ jsx27("div", { className: "flex flex-1 items-center justify-center text-neutral-3", children: /* @__PURE__ */ jsx27(FontAwesomeIcon, { icon: faSpinnerThird, spin: true, size: "2x" }) }) : /* @__PURE__ */ jsxs24(Fragment7, { children: [
                  /* @__PURE__ */ jsx27("div", { className: "flex flex-col flex-1 min-h-0 pt-0", children: /* @__PURE__ */ jsxs24(
                    TabsRoot,
                    {
                      defaultValue: "styles",
                      className: "flex flex-col flex-1 min-h-0",
                      children: [
                        /* @__PURE__ */ jsx27("div", { className: "px-4 shrink-0", children: /* @__PURE__ */ jsxs24(TabsList, { children: [
                          /* @__PURE__ */ jsxs24(TabsTrigger, { value: "styles", children: [
                            /* @__PURE__ */ jsx27(Icon8, { icon: faSwatchbook }),
                            "Styles"
                          ] }),
                          /* @__PURE__ */ jsxs24(TabsTrigger, { value: "components", children: [
                            /* @__PURE__ */ jsx27(Icon8, { icon: faPuzzlePiece }),
                            "Components"
                          ] }),
                          showMigrationTab ? /* @__PURE__ */ jsxs24(TabsTrigger, { value: "migration", children: [
                            /* @__PURE__ */ jsx27(Icon8, { icon: faArrowRightFromLine }),
                            "Migration"
                          ] }) : null
                        ] }) }),
                        /* @__PURE__ */ jsx27(
                          TabsContent,
                          {
                            value: "styles",
                            className: "flex flex-col flex-1 min-h-0 p-4",
                            children: /* @__PURE__ */ jsx27(Styles, { platform, theme })
                          }
                        ),
                        /* @__PURE__ */ jsx27(
                          TabsContent,
                          {
                            value: "components",
                            className: "flex flex-col flex-1 min-h-0 p-4",
                            children: /* @__PURE__ */ jsx27(Components, { platform, theme })
                          }
                        ),
                        showMigrationTab ? /* @__PURE__ */ jsx27(
                          TabsContent,
                          {
                            value: "migration",
                            className: "flex flex-col flex-1 min-h-0 p-4",
                            children: /* @__PURE__ */ jsx27(MigrationTab, { theme })
                          }
                        ) : null
                      ]
                    },
                    theme.id
                  ) }),
                  /* @__PURE__ */ jsxs24(ModalFooter2, { children: [
                    /* @__PURE__ */ jsx27(Button7, { type: "button", variant: "outline", onClick: handleClose, children: "Cancel" }),
                    /* @__PURE__ */ jsx27(Button7, { type: "button", variant: "primary", onClick: onSave, children: "Save" })
                  ] })
                ] })
              }
            )
          ]
        }
      )
    }
  );
};

// src/components/ThemeEditor/ThemeEditor.tsx
import { Fragment as Fragment8, jsx as jsx28, jsxs as jsxs25 } from "react/jsx-runtime";
var ThemeEditor = ({
  id,
  platform: targetPlatform,
  container,
  onPublish
}) => {
  const {
    theme,
    isEditorOpen,
    setIsEditorOpen,
    donatedComponent,
    setDonatedComponent,
    setContainer,
    fetchTheme,
    saveTheme,
    publishTheme
  } = useThemeEditor();
  useEffect7(() => {
    setContainer(container);
  }, [container, setContainer]);
  useEffect7(() => {
    if (isEditorOpen || donatedComponent !== null) {
      fetchTheme(id);
    }
  }, [isEditorOpen, donatedComponent, fetchTheme, id]);
  const handleSave = async (metadata = {}) => {
    if (!theme) return;
    const delta = {
      id: theme.id,
      name: theme.name,
      content: theme.content
    };
    await saveTheme(delta);
    const updatedCompiledThemes = await publishTheme(theme.id);
    onPublish?.(
      updatedCompiledThemes.find(({ platform }) => platform === targetPlatform)
    );
    if (donatedComponent && metadata.donatedVariantName) {
      donatedComponent.onComplete?.(metadata.donatedVariantName);
    }
    setIsEditorOpen(false);
    setDonatedComponent(null);
  };
  return /* @__PURE__ */ jsxs25(Fragment8, { children: [
    /* @__PURE__ */ jsx28(DonateComponentModal, { platform: targetPlatform, onSave: handleSave }),
    /* @__PURE__ */ jsx28(ThemeModal, { platform: targetPlatform, onSave: handleSave })
  ] });
};

// src/components/Provider.tsx
import { useState as useState17, useMemo as useMemo6, useCallback as useCallback3 } from "react";
import { assign } from "object-path-immutable";

// src/lib/normalize-web-root-height.ts
var MIN_HEIGHT_ROOT_CONTAINERS = ["modal", "embed"];
var foldVariantHeight = (variant) => {
  const style = variant?.$style;
  if (!style || typeof style !== "object" || !("height" in style)) return null;
  const { height, ...rest } = style;
  return {
    ...variant,
    $style: rest.minHeight === void 0 ? { ...rest, minHeight: height } : rest
  };
};
var normalizeWebRootHeight = (theme) => {
  const components = theme.content?.components;
  const web = components?.web;
  if (!web) return theme;
  let changed = false;
  const nextWeb = { ...web };
  MIN_HEIGHT_ROOT_CONTAINERS.forEach((container) => {
    const variants = web[container];
    if (!variants) return;
    let containerChanged = false;
    const nextVariants = Object.entries(variants).reduce((acc, [name, variant]) => {
      const folded = foldVariantHeight(variant);
      if (folded) containerChanged = true;
      acc[name] = folded ?? variant;
      return acc;
    }, {});
    if (containerChanged) {
      changed = true;
      nextWeb[container] = nextVariants;
    }
  });
  if (!changed) return theme;
  return {
    ...theme,
    content: {
      ...theme.content,
      components: { ...theme.content.components, web: nextWeb }
    }
  };
};

// src/components/Provider.tsx
import { jsx as jsx29 } from "react/jsx-runtime";
var Provider = ({
  children,
  fetchTheme: fetchThemeApi,
  saveTheme: saveThemeApi,
  publishTheme: publishThemeApi,
  getLegacyTheme,
  studioUrl
}) => {
  const [theme, setTheme] = useState17(null);
  const [isLoading, setIsLoading] = useState17(false);
  const [isEditorOpen, setIsEditorOpen] = useState17(false);
  const [donatedComponent, setDonatedComponent] = useState17(null);
  const [container, setContainer] = useState17(null);
  const updateTheme = useCallback3(
    (path, chunk) => {
      setTheme(assign(theme, path, chunk));
    },
    [theme]
  );
  const fetchTheme = useCallback3(
    async (id) => {
      try {
        setIsLoading(true);
        setTheme(null);
        const loadedTheme = await fetchThemeApi(id);
        setTheme(normalizeWebRootHeight(loadedTheme));
      } catch (error) {
        console.error("Error fetching theme:", error);
      } finally {
        setIsLoading(false);
      }
    },
    [fetchThemeApi]
  );
  const saveTheme = useCallback3(
    async (model) => {
      try {
        if (!model.id) {
          throw new Error("Theme ID is required");
        }
        const result = await saveThemeApi(model.id, model);
        return result;
      } catch (error) {
        console.error("Theme save failed:", error);
        throw error;
      }
    },
    [saveThemeApi]
  );
  const publishTheme = useCallback3(
    async (id) => {
      try {
        const publishedThemes = await publishThemeApi(id);
        return publishedThemes;
      } catch (error) {
        console.error("Theme publish failed:", error);
        throw error;
      }
    },
    [publishThemeApi]
  );
  const value = useMemo6(
    () => ({
      theme,
      setTheme,
      updateTheme,
      isLoading,
      setIsLoading,
      isEditorOpen,
      setIsEditorOpen,
      donatedComponent,
      setDonatedComponent,
      container,
      setContainer,
      fetchTheme,
      saveTheme,
      publishTheme,
      getLegacyTheme,
      studioUrl
    }),
    [
      theme,
      updateTheme,
      isLoading,
      isEditorOpen,
      donatedComponent,
      container,
      fetchTheme,
      saveTheme,
      publishTheme,
      getLegacyTheme,
      studioUrl
    ]
  );
  return /* @__PURE__ */ jsx29(Context_default.Provider, { value, children });
};

// src/model/migrations/index.ts
import { set as set4 } from "object-path-immutable";

// src/model/migrations/migrations.ts
import { get as get10 } from "object-path-immutable";

// src/model/migrations/utils.ts
import { get as get9, set as set3 } from "object-path-immutable";
var setIfMissing = (theme, path, value) => {
  const existing = get9(theme, path);
  if (existing !== void 0) {
    return theme;
  }
  return set3(theme, path, value);
};
var addVariantIfMissing = (theme, variant, variantDefinition) => {
  const path = `content.components.${variant}`;
  return setIfMissing(theme, path, variantDefinition);
};

// src/model/migrations/migrations.ts
var migrations = [
  {
    // Version 1: Baseline - Establishes the initial schema version
    version: 1,
    migrate: (theme) => theme
  },
  {
    // Version 2: 2026-01 - Initial experience-builder components
    version: 2,
    migrate: (theme) => {
      const addedVariants = [
        ["web.modal.default", base_theme_default.content.components.web.modal.default],
        ["web.button.default", base_theme_default.content.components.web.button.default],
        ["web.img.default", base_theme_default.content.components.web.img.default]
      ];
      return addedVariants.reduce(
        (migratedTheme, [variant, definition]) => addVariantIfMissing(migratedTheme, variant, definition),
        theme
      );
    }
  },
  {
    // Version 3: 2026-01 - Rich text components (p, h1-h5) and heading font size tokens
    version: 3,
    migrate: (theme) => {
      const addedVariants = [
        ["web.p.default", base_theme_default.content.components.web.p.default],
        ["web.h1.default", base_theme_default.content.components.web.h1.default],
        ["web.h2.default", base_theme_default.content.components.web.h2.default],
        ["web.h3.default", base_theme_default.content.components.web.h3.default],
        ["web.h4.default", base_theme_default.content.components.web.h4.default],
        ["web.h5.default", base_theme_default.content.components.web.h5.default]
      ];
      let migratedTheme = addedVariants.reduce(
        (acc, [variant, definition]) => addVariantIfMissing(acc, variant, definition),
        theme
      );
      const rawPreset = get10(theme, [
        "content",
        "tokens",
        "font",
        "size",
        "$extensions",
        TOKEN_EXTENSIONS.PRESET
      ]);
      const currentPreset = PRESET_SIZES.includes(rawPreset) ? rawPreset : "M";
      const fontSizeTokens = presetFontSizes(currentPreset);
      const headingFontSizeTokens = ["h1", "h2", "h3", "h4", "h5"];
      migratedTheme = headingFontSizeTokens.reduce(
        (acc, token) => setIfMissing(
          acc,
          `content.tokens.font.size.${token}`,
          fontSizeTokens[token]
        ),
        migratedTheme
      );
      return migratedTheme;
    }
  },
  {
    // Version 4: 2026-02 - Embed web component variant
    version: 4,
    migrate: (theme) => {
      return addVariantIfMissing(
        theme,
        "web.embed.default",
        base_theme_default.content.components.web.embed.default
      );
    }
  },
  {
    // Version 5: 2026-04 - Tooltip web component variant
    version: 5,
    migrate: (theme) => {
      return addVariantIfMissing(
        theme,
        "web.tooltip.default",
        base_theme_default.content.components.web.tooltip.default
      );
    }
  },
  {
    // Version 6: 2026-05 - Cell web component variant (cell-settings sidebar
    // migration, sc-88206). Adds `web.cell.default` so the new sidebar Cell
    // panel always has a baseline variant to render against and to seed
    // "Save as new variant" overrides — works for both new themes (via
    // base-theme) and existing themes (via this migration).
    version: 6,
    migrate: (theme) => {
      return addVariantIfMissing(
        theme,
        "web.cell.default",
        base_theme_default.content.components.web.cell.default
      );
    }
  },
  {
    // Version 7: 2026-05 - CloseX web component variant
    version: 7,
    migrate: (theme) => {
      return addVariantIfMissing(
        theme,
        "web.close-x.default",
        base_theme_default.content.components.web["close-x"].default
      );
    }
  },
  {
    // Version 8: 2026-05 - Adds `gap` to the existing Cell variant so the
    // Design tab can show it as a theme override (parity with padding).
    // Earlier themes already migrated past v6 have `web.cell.default` but
    // without `gap`; this fills in just that property without disturbing
    // any customer-edited padding values.
    version: 8,
    migrate: (theme) => setIfMissing(theme, "content.components.web.cell.default.$style.gap", 0)
  }
];

// src/model/migrations/index.ts
var CURRENT_SCHEMA_VERSION = migrations.length > 0 ? Math.max(...migrations.map((m) => m.version)) : 0;
var getSchemaVersion = (theme) => {
  const meta = theme.content?.meta;
  return meta?.schemaVersion ?? 0;
};
var isThemeCurrent = (theme) => {
  return getSchemaVersion(theme) >= CURRENT_SCHEMA_VERSION;
};
var migrateTheme = (theme) => {
  const currentVersion = getSchemaVersion(theme);
  if (currentVersion >= CURRENT_SCHEMA_VERSION) {
    return theme;
  }
  const pendingMigrations = migrations.filter((m) => m.version > currentVersion).sort((a, b) => a.version - b.version);
  const migratedTheme = pendingMigrations.reduce(
    (currentTheme, migration) => migration.migrate(currentTheme),
    theme
  );
  return set4(
    migratedTheme,
    "content.meta.schemaVersion",
    CURRENT_SCHEMA_VERSION
  );
};
export {
  APPEARANCE_CSS_PROPERTIES,
  AdvancedStyles_default as AdvancedStyles,
  BUTTON_CONFIG,
  CELL_CONFIG,
  CLOSE_X_CONFIG,
  COMMON_CSS_PROPERTIES,
  Context_default as Context,
  EMBED_CONFIG,
  IFRAME_CONFIG,
  IMAGE_CONFIG,
  PSEUDO_ELEMENT_PROPERTIES,
  STEP_CONFIG,
  STRUCTURAL_CSS_PROPERTIES,
  TEXT_CONFIG,
  TEXT_CSS_PROPERTIES,
  ThemeEditor,
  Provider as ThemeEditorProvider,
  WEB_COMPONENT_STYLE_CONFIGS,
  base_theme_default as baseTheme,
  expandBackground,
  formatDefaultStyles,
  isThemeCurrent,
  migrateLegacyThemeContent,
  migrateTheme,
  useThemeEditor
};
/*! Bundled license information:

react-is/cjs/react-is.development.js:
  (** @license React v16.13.1
   * react-is.development.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   *)

object-assign/index.js:
  (*
  object-assign
  (c) Sindre Sorhus
  @license MIT
  *)
*/
//# sourceMappingURL=index.mjs.map